let app = {
    ui: {},
    //api: {},
    //util: {},
    debug:{
        enabled: false,
        originallog:function(){},
        originaldebug:function(){},
        originaltrace:function(){},
        log:function(...args){
            if(app.debug.enabled || app.debug_mode()) app.debug.originallog(...args);
        },
        debug:function(...args){
            if(app.debug.enabled || app.debug_mode()) app.debug.originaldebug(...args);
        },
        trace:function(...args){
            if(app.debug.enabled || app.debug_mode()) app.debug.originaltrace(...args);
        },
        /**
         * Wrap a function with debug functions
         * @param {function|null} original the original or replacement function to be ran in place of the one being wrapped
         * @param {function|'debug'|null} after a function to call after the 'original' function. If this is 'debug', a console debug line is printed.
         * @param {function|'debug'|null} before a function to call after the 'original' function. If this is 'debug', a console debug line is printed.
         */
        wrap(original,before="debug",after=null){
            if(app.debug.enabled || app.debug_mode()){
                console.debug("Wrapping function ",original.name??'unknown')
                return function(...args){
                    if(before!==null){
                        if(before==='debug') console.debug("CALL BEFORE",original.name??'unknown',...args)
                        else before.call(this,...args);
                    }
                    let retval = null;
                    if(original!==null) retval = original.call(this,...args);
                    if(after!==null){
                        if(before==='debug') console.debug("CALL AFTER",original.name??'unknown',...args)
                        else before.call(this,...args);
                    }
                    return retval;
                };

            }else{
                console.debug("Not Wrapping function ",original.name??'unknown')
                return original;
            }
        },
        startDebuggingNativeEvents(){
            document.createEvent=app.debug.wrap(document.createEvent);
            EventTarget.prototype.dispatchEvent=app.debug.wrap(EventTarget.prototype.dispatchEvent);

            let originalListener = EventTarget.prototype.addEventListener;
            EventTarget.prototype.addEventListener=app.debug.wrap(EventTarget.prototype.addEventListener,function(type,...args){
                console.debug("CALL BEFORE",'addEventListener',type,...args);
                originalListener.call(this,type,function(e){
                    console.debug(" CALL ON",'event',type,e);
                })

            });
            if(typeof EventTarget.prototype.fireEvent!=='undefined') EventTarget.prototype.fireEvent=app.debug.wrap(EventTarget.prototype.fireEvent);
            if(typeof document.createEventObject!=='undefined') document.createEventObject = app.debug.wrap(document.createEventObject);
            Event.prototype.initEvent = app.debug.wrap(Event.prototype.initEvent);
            CustomEvent.prototype.initCustomEvent = app.debug.wrap(CustomEvent.prototype.initCustomEvent);
            window.postMessage = app.debug.wrap(window.postMessage);
            Worker.prototype.postMessage = app.debug.wrap(Worker.prototype.postMessage);
        }
    },
    data: {
        values:{

        },
        importValue: function (exportedname) {
            return $("#META-EXPORT-" + $.escapeSelector(exportedname)).val();
        },
        importValues: function () {
            $("#META-EXPORTS").find('input').each(function () {
                let name = $(this).data('originalname');
                let value = $(this).val();
                if(typeof app.util !=="undefined" && !name.endsWith('uid')) value = app.util.autoConvertFromString(value);
//                console.log("Import value", name, value, this);
                app.data.values[name] = value;
            })
        },
        /**
         * @deprecated
         */
        importGlobals:function(){
            for(let entry of Object.entries(app.data.values)){
                window[entry[0]] = entry[1];
            }
        }

    },
    loggedIn:function(){
        if(window.APP_PUBLIC_VIEW) return false;
        return app.data.values['auth_loggedin'];
    },
    debug_mode:function() {
        return (typeof window.APP_DEBUG_MODE !== "undefined" && (+window.APP_DEBUG_MODE) === 1);
    },
    shorturl:function(url){
      if(!(app.data.values['APP_SHORT_URLS']??0)) return url;
      if(url.endsWith('.php') || url.includes('.php?')) return url.replace('.php','');
      return url;
    },
    init:function(){
        if(!app.debug.enabled){
            app.debug.originallog = window.console.log;
            window.console.log = app.debug.log;
            app.debug.originaldebug = window.console.debug;
            window.console.debug = app.debug.debug;
            app.debug.originaltrace = window.console.trace ?? app.debug.originaltrace;
            window.console.trace = app.debug.trace;
        }
    }
}

app.init();

window.app = app;


window.rcps = window.app;

/**
 * App library providing methods for interfacing with the JSON-API component.
 */

app.api = {

    uri: 'json-api.php',
    /**
     * Specifies whether to treat results with no 'api-error' field (usually required) as a successful request.
     *
     * If this is false, a result without the 'api-error' field will be treated as if the API returned an error.
     *
     * This can be useful if you work with libraries that do not tolerate extra fields in results and need to exclude the 'api-error' field.
     */
    allowUndefinedError: true,

    /**
     * An enumeration of status codes returned by the API library.
     *
     * ---
     *
     * The status codes will be issued in events and callbacks in the following order:
     * AJAX success or failure, Preprocess, API success or error, no-data or got-data, Processed, Postprocess.
     *
     * Most processing should occur during the 'no-data' or 'got-data state events.
     *
     * ---
     *
     * Postprocess event is always fired regardless of success, likewise an Ajax success or failure event will always be fired.
     *
     * Preprocess, API Success or failure, and Processed can only be fired if the Ajax request succeeded.
     *
     * Got-Data/No-Data can only be fired if both the Ajax request succeeded and there was no API Error response.
     *
     *
     *
     * ---
     *
     * See {@link AJAX_FAIL}, {@link API_ERROR}, {@link NO_DATA} for information about common failure reasons.
     */
    status_codes : {
        SENDING_REQUEST: "sending-request",
        SENT_REQUEST: "sent-request",
        /**
         * There was an error in the Ajax request [or other script].  This may indicate a networking, security, or HTTP Status issue.
         */
        AJAX_FAIL: "ajax-fail",
        AJAX_SUCCESS: "ajax-success",
        /**
         * An error code was returned by the API.  No networking issue occurred, but the request was rejected or failed.
         */
        API_ERROR: "api-error",
        API_SUCCESS: "api-success",
        GOT_DATA: "got-data",
        /**
         * No data other than metafields about the request were returned by the API.
         *
         * This may indicate there were no results, the value request wasn't present, or there is no information available.
         */
        NO_DATA: "no-data",
        PROCESSING: "processing",
        PROCESSED: "processed",
        POSTPROCESS: "postprocess",
    },


    /**
     * Convert an API result containing a list of values into an array.
     *
     * The API result must contain a `field-count` property and the results must have contiguous numerical keys starting at 0
     * @param {APIRequestData|object} data the API result data
     * @returns {*[]}
     */
    resultsToArray: function (data) {
        let n = data['field-count'];
        let a = [];
        for (let i = 0; i < n; i++) {
            a.push(data[i]);
        }
        return a;
    },

    /**
     * parses a list (array or object) received from the API that contains a list of values and [optionally] display strings in the form {0:vala,1:valb} or {vala:"first display",valb:"second display"}.
     * The resulting output will be an array of entry objects with 'value' and 'display' properties.
     * If the input object or array has numeric keys, they will be discarded and the value of each entry will be used as both the value and display of the output.
     *
     * @param list {string|array|object}
     * @param backupNamePreparer {null|function}
     * @return {APIValuePair_Display[]} array of display-value objects.
     */
    prepareMixedList: function (list, backupNamePreparer = app.api.defaultNamePreparer) {
        if (app.api.isDisplayPairList(list)) return list;

        //if the list is a string, assume it is CSV
        //if the list is an array - well, get the entries (keys will be numeric for later)
        //if the list is an object - get the entries (keys are defined by sender)

        if (list === null || typeof list === "undefined" || list === false) return [];
        list = typeof list === "string" ? list.split(',').entries() : (Array.isArray(list) ? list.entries() : Object.entries(list));
        //console.log("listafter",list)


        let prepared = [];
        for (let entry of list) {
            let key = entry[0];
            let value = entry[1];
            let outValue, outDisp;

            if(typeof key==="string") key = key.replaceAll('<<COMMA>>',',');
            if(typeof value==="string") value = value.replaceAll('<<COMMA>>',',');

            if (app.api.isMetaField(key)) continue;
            if (app.util.isNumeric("" + key)) {//numeric key
                //console.log("numeric key",key,backupNamePreparer)
                outValue = value;
                outDisp = value;
                if (backupNamePreparer != null) outDisp = backupNamePreparer(outDisp);
            } else {
                //console.log("string key",key,backupNamePreparer)
                outValue = key;
                outDisp = value;
            }
            prepared.push({display: outDisp, value: outValue});
        }
        return prepared;
    },

    /**
     * Check whether an array is a valid Value-Display pair list ({@link APIValuePair_Display})
     *
     * This consists of an array of objects each with the properties `display` and `value`, similar to how they appear in Bootstrap Autocomplete.
     *
     * @param {APIValuePair_Display[]|any[]|any} arr an input array
     */
    isDisplayPairList: function (arr) {
        if (!Array.isArray(arr)) return false;
        if (arr.length === 0) return true;//we have nothing to go on.
        if (!(arr[0] instanceof Object)) return false;
        if (typeof arr[0].display === "undefined" || typeof arr[0].value === "undefined") return false;//only do cursory check of first value
        return true;
    },


    /**
     * Get a CSV list of display text from a Value-Display pair list ({@link APIValuePair_Display})
     *
     * This method does not escape embedded commas.
     * @param {APIValuePair_Display[]} entries the array of value-display pairs
     * @param {boolean} csv display text CSV output
     */
    displayPairList_displays: function (entries, csv = false) {
        let arr = [];
        for (let entry of entries) {
            arr.push(entry.display);
        }
        if (csv) return arr.join(',');
        return arr;
    },

    /**
     * Get a CSV list of values from a Value-Display pair list ({@link APIValuePair_Display})
     *
     * This method does not escape embedded commas.
     * @param {APIValuePair_Display[]} entries the array of value-display pairs
     * @param {boolean} csv values CSV output
     */
    displayPairList_values:function (entries, csv = false) {
        let arr = [];
        for (let entry of entries) {
            arr.push(entry.value);
        }
        if (csv) return arr.join(',');
        return arr;
    },

    /**
     * An object containing lists of display-texts and values from a {@link APIValuePair_Display} array.
     *
     * There should be an equal number of display-texts and values and their order should allow each element to be associated with the other.
     *
     * Generally this is received from {@link displayPairList_unpair}
     *
     * @typedef {object} APIValueDisplay_Grouped
     * @property {string[]} displays an array of display texts
     * @property {*[]} values an array of values
     */

    /**
     * Regroups a Value-Display pair list ({@link APIValuePair_Display}) as a list of display text and a list of values
     * @param {APIValuePair_Display[]} entries
     * @return {APIValueDisplay_Grouped} An object containing the list of display-text and a list of values
     */
    displayPairList_unpair: function (entries) {
        return {displays: app.api.displayPairList_displays(entries), values: app.api.displayPairList_values(entries)};
    },

    /**
     * The default name-preparer function used by {@link prepareMixedList}.
     *
     * This method replaces underscores with spaces by default.
     * @param value the name value
     * @returns {string} the formatted name
     */
    defaultNamePreparer: function (value) {
        //console.log("namepreparer",value);
        return value.replaceAll('_', ' ');
    },

    /**
     * Check whether an API result field name is a known API 'Meta' field.
     *
     * Meta fields are informational fields returned by the API which are not considered part of the resulting data.
     *
     * This method only checks for field names that are known to be added by the API, and will not detect other custom meta-fields (prefixed with `META-`).
     * Not all API-added fields are prefixed in this manner (such as `field-count` or `requested-action`)
     *
     * @param key the property or field name
     * @returns {boolean} whether the field was a known meta field
     */
    isMetaField: function (key) {
        return (key==="meta-version" || key === "meta-performance" || key === "field-count" || key === "requested-action" || key === "api-error" || key === "total-results" || key === "requested-offset" || key === "requested-amount" || key === "preset-name");
    },


    /**
     * Internal method: make a raw POST ajax request to the API URL.
     *
     * This may be rejected if tokens are not sent in the data.
     *
     * Note: `action` and `META-version` GET parameters are appended to the API URL.
     *
     * @param action the API action string (`action` GET parameter)
     * @param {string|array|FormData} postData the post data to send
     * @param {function(any:data,string:status,jqXHR)} callback_success a callback function ran during the {@link jQuery.jqXHR.success} event
     * @param {function(jqXHR,string:status,string:error)} callback_error a callback function ran during the {@link jQuery.jqXHR.error} event
     * @param {object} headers "An object of additional header key/value pairs to send along with requests"
     * @returns {jQuery.jqXHR} the request object
     * @private
     */
    _internal_post: function (action, postData, callback_success, callback_error, headers = {}) {
        //console.log("api-internal-post",action,postData,headers);

        let metaflags = "";
        if (app.debug_mode()) {
            metaflags += "&META-performance=1";
        }

        //if(postData instanceof FormData){
        //    console.log("API formdata 4:",action,postData,postData.get('file'));
        //}

        let method = "POST";

        if(!(postData instanceof FormData)){ //prevent GET when uploading file
            if(Array.isArray(postData) && postData.length===0) method="GET";
            if(typeof postData==="object" && Object.keys(postData).length===0) method="GET";
            if(postData==="") method="GET";
        }

        let a = $.ajax({
            type: method,
            crossDomain: false,
            url: app.shorturl(app.api.uri)+"?action=" + encodeURIComponent(action) + metaflags+"&META-version="+(window['APP_VERSION']??'unknown'),
            headers: headers,
            data: postData,
            success: callback_success,
            error: callback_error,
            dataType: "json",
            processData: !(postData instanceof FormData),
            contentType: (postData instanceof FormData) ? false : 'application/x-www-form-urlencoded; charset=UTF-8'
        });
        return a;
    },

    /**
     * Internal method: Request new token data from the API in order to make future requests.
     *
     * uses {@link app.api._internal_post}
     *
     * @returns {Promise<unknown>} a promise yielding the token response data
     * @private
     */
    _internal_fetchtokens: function () {
        let promise = new Promise(function (resolve, reject) {
            app.api._internal_post("tokens.generate", "", function (data, status) {
                resolve(data);
            }, function () {
                reject();
            }, {"X-API-TOKEN": "NEW"});
        });
        return promise;
    },

    /**
     * Internal: the time requested tokens are considered valid for (in seconds)
     * @private
     * @type {int}
     */
    _internal_maxtokentime: 3 * 60,//3min

    /**
     * Internal: Retrieves tokens to allow using API requests.
     *
     * This method may be cached while tokens are valid, otherwise they are requested using {@link _internal_fetchtokens}
     * @returns {Promise<unknown>|null|*} yields the token data or rejects with the error `fetchtokens-failure`
     * @private
     */
    _internal_gettokens: function () { //fetch tokens with caching for up to the specified duration
        //if(typeof rcps.api._internal_gettokens.lastts==="undefined") rcps.api._internal_gettokens.lastts=0;
        //if(typeof rcps.api._internal_gettokens.lastresult==="undefined") rcps.api._internal_gettokens.lastresult=null;
        if (typeof app.api._internal_gettokens.lastpromise === "undefined") app.api._internal_gettokens.lastpromise = null;
        if (typeof app.api._internal_gettokens.lastpromisets === "undefined") app.api._internal_gettokens.lastpromisets = null;


        let ts = Date.now() / 1000; //ms to s
        let tsd = Math.abs(ts - app.api._internal_gettokens.lastpromisets);
        if (tsd < app.api._internal_maxtokentime && app.api._internal_gettokens.lastpromisets !== 0) {
            //console.log("api-tokens", "resolving with cached tokens (cache-hit)", rcps.api._internal_gettokens.lastpromisets,ts,tsd)
            return app.api._internal_gettokens.lastpromise;
        }
        //console.log("api-tokens","resolving live (cache-miss)",rcps.api._internal_gettokens.lastpromisets,ts,tsd)


        let promise = new Promise(function (resolve, reject) {
            app.api._internal_fetchtokens().then(function (data) {
                let rs = resolve;
                //console.log("api-tokens","fetchtokens success");

                rs(data);
            }).catch(function (reason) {
//                console.log("api-tokens", "fetchtokens failed", reason);
                let rj = reject;
                rj('fetchtokens-failure');
            })

        });
        app.api._internal_gettokens.lastpromise = promise;
        app.api._internal_gettokens.lastpromisets = Date.now() / 1000;

        return promise;
    },

    /**
     *
     * Internal: Makes a request to the API after retrieving tokens necessary to make the request.
     *
     * Token parameters and headers may be added to the final API request.
     *
     * Uses {@link _internal_gettokens} to retrieve tokens.  Uses {@link _internal_post} to make the final request.
     *
     *
     * @param {string} action the API action being requested
     * @param {Object|FormData|string} postData serialized post data
     * @param {APIRequestDataCallback} callback_success a callback function ran when the request succeeds
     * @param {APIRequestErrorCallback} callback_error a callback function ran when the request fails (for a reason other than being rejected)
     * @returns {Promise<APIRequestData|object>} a promise yielding the data provided by the API, if any.
     * @private
     */
    _internal_tokened_post: function (action, postData, callback_success, callback_error) {
        let promise = new Promise((resolve, reject) => {
            app.api._internal_gettokens().then((data) => {
                //console.log("api-internal-tokened-post","gettokens resolved",data);
                let a = action;
                let d = postData;
                // noinspection EqualityComparisonWithCoercionJS
                if (typeof data['api-error'] !== "undefined" && data['api-error'] == 0) {
                    let token1 = data['token1'];
                    let token2 = data['token2'];

                    if (d instanceof FormData) {
                        d.append('X_API_TOKEN', token1);
                    }else if(Array.isArray(d)){
                        let obj = {};
                        for(let i=0;i<d.length;i++) obj[i]=d[i];
                        obj['X_API_TOKEN'] = token1;
                        d = obj;
                        console.debug("final object(arr)", d);
                    } else if (d instanceof Object) {
                        d['X_API_TOKEN'] = token1;
//                        console.log("final object", d);
                    } else {
                        d += "&X_API_TOKEN=" + encodeURIComponent(token1);
                    }
                    let headers = {
                        "X-API-TOKEN": token2
                    }


                    //console.log("API formdata 3:",action,d);
                    app.api._internal_post(a, d, function (data, status, xhr) {
                        let rs = resolve;
                        let cs = callback_success;
                        //console.log("api-internal-post","cb success");
                        if (cs !== null) cs(data, status, xhr);
                        rs(data);
                    }, function (xhr, status, error) {
                        let rj = reject;
                        let ce = callback_error;
                        //console.log("api-internal-post","cb error");
                        if (ce !== null) ce({}, status, xhr, error);
                        rj('request-failed');
                    }, headers);

                } else {
                    reject('gettokens failure')
                }
            }).catch((reason) => {
                console.warn("api-internal-tokened-post", "gettokens rejected", reason);
                let rj = reject;
                let ce = callback_error;
                console.warn(ce)
                if (ce !== null) ce({}, "ajax-fail");
                rj();
            });
        });

        promise.fail = promise.catch;//shim for ajax object we're replacing.
        promise.success = promise.then;//shim for ajax object we're replacing.

        return promise;
    },



    /**
     * Request a server API action and yields the response data as an object.
     *
     * Uses {@link _internal_tokened_post} to make a request with API tokens, and uses the success/error state along with the data-length to provide a status value and events.
     *
     * ---
     *
     * The following events will be fired during the course of a request:
     * * `api:event` (fields: status, data, action, flags)
     * * `api:<status code string>` (fields: data, action, flags)
     * * `api:<action>:<status code string>` (fields: data, flags)
     *
     * Where the status code is the state of processing the request.
     *
     *
     * See {@link status_codes} for a list of status codes used during processing the request.
     *
     * @param {string} action the API action to request
     * @param {string|Object|FormData} postData the serialized post data to send
     * @param {APIRequestCallback|null} eventCallback_external a callback to fire at different states of the request and processing
     * @returns {Promise<APIRequestData|object>} a promise yielding the response data as an object
     */
    request:async function(action, postData, eventCallback_external = null) {
        if (eventCallback_external === null) eventCallback_external = function (t, v) {
        };//assign dummy to streamline code;

        if(APP_PUBLIC_VIEW){
            if(action.endsWith('-private')) action = action.substr(0,action.length-('private'.length))+'public'; //TODO: make this cleaner
            if(action.endsWith('-full')) action = action.substr(0,action.length-('full'.length))+'public';
            if(action.endsWith('-personalized')) action = action.substr(0,action.length-('personalized'.length))+'public';
        }

        /**
         * @type {APIRequestCallback}
         */
        let eventCallback = async function (t, v, a, f) { //debug shim for request
            let cb = eventCallback_external;
            //console.log("API request status ",t,v,a,f," forwarding-to");
            app.ui.event.fire("api:event", {status: t, data: v, action: a, flags: f});
            app.ui.event.fire("api:" + t, {data: v, action: a, flags: f});
            app.ui.event.fire("api:" + a + ":" + t, {data: v, flags: f});
            if (cb !== null) await cb(t, v, a, f);
        }
        //if(eventCallback_external!==null) eventCallback = eventCallback_external;


        let data_f = {};
        let eventFlags = {hadData: false, error: false};
        eventCallback("sending-request", [action, postData], action, eventFlags);


        //$.post("json-api.php?action="+encodeURIComponent(action), ...)
        //console.log("API formdata 2:",action,postData);
        let p = app.api._internal_tokened_post(action, postData, async function (data, status) {
            data_f = data;
            let act = action; //instance these variables locally to prevent changes;
            let cb = eventCallback;
            let tmpFlags = eventFlags;
            await cb('ajax-success', data, act, tmpFlags);
            if(typeof data['api-error'] == "undefined"){
                if (app.api.allowUndefinedError) {
                    data['api-error'] = 0 ;
                }else{
                    data['api-error'] = 'API did not supply an error code';
                }
            }
            //if (typeof data['api-error'] !== "undefined") {
                await cb('preprocess', data, act, tmpFlags);
                // noinspection EqualityComparisonWithCoercionJS
                if (data['api-error'] != 0) {
                    console.warn("API error: ", data['api-error'], action);
                    tmpFlags.error = true;
                    await cb('api-error', data, act, tmpFlags);
                } else if (data['field-count'] < 1) { //no matching record
                    tmpFlags.hadData = false;
                    await cb('api-success', data, act, tmpFlags);
                    await cb('no-data', data, act, tmpFlags);
                } else {
                    tmpFlags.hadData = true;
                    //console.log("got-data dbg",act,cb);
                    await cb('api-success', data, act, tmpFlags);
                    await cb('got-data', data, act, tmpFlags);
                }
                await cb('processed', data, act, tmpFlags);
                await cb('postprocess', data, act, tmpFlags);
            //}
        }, null, "json").fail(function (reason) {
            //console.log("fail")
            let data = data_f;
            let cb = eventCallback;
            let tmpFlags = eventFlags;
            tmpFlags.error = true;
            let act = action;
            cb('ajax-fail', data, act, tmpFlags);
            console.warn("API error: ", "AJAX failure", act, data, tmpFlags, reason);
            cb('postprocess', data, act, tmpFlags);
        });
        await eventCallback("sent-request", [action, postData], action, eventFlags);
        return p;
    },

    /**
     * Creates a promise wrapping an API {@link request} which is resolved or rejected when the API response is processed or fails.
     * @param {string} action the API action to request
     * @param {string|Object|FormData} data
     * @param {boolean} acceptNoData whether to accept (resolve) responses with "no data" (ie: no fields other than metadata about the request).  This is particularly useful if you are expecting an array or optional value.
     * @param {boolean} defaultErrorMessage whether to create default error message dialogs when API errors (or no-data) occur.
     * @returns {Promise<APIRequestData|object>} a promise that yields the API response data, or is rejected - depending on if the request has an error or was accepted.
     */
    promise:function (action, data = "", acceptNoData = false, defaultErrorMessage = true) {
        let promise = new Promise((resolve, reject) => {
            let inner_promise = app.api.request(action, data, function (status, data) {
                let reject_ = reject; //instancing issues
                let resolve_ = resolve; //instancing issues
                let acceptNoData_ = acceptNoData;
                switch (status) {
                    case "ajax-fail":
                        reject_({status: status, data: data, message: "AJAX Failure"});
                        break;
                    case "api-error":
                        reject_({status: status, data: data, message: "API Error: " + data['api-error']});
                        break;
                    case "no-data":
                        if (acceptNoData_) resolve_(null);
                        else reject_({status: status, data: data, message: "No matching data returned from API"});
                        break;
                    case "got-data":
                        resolve_(data);
                        break;
                }
            });
            inner_promise.catch((reason) => {
                let reject_ = reject; //instancing issues
                reject_(reason);
            })
        });
        if (defaultErrorMessage) {
            promise.catch((reason) => {
                if (reason.status === "no-data") app.ui.common.error("Error retrieving data:\r\n " + reason.message);
                else {
                    if (reason.message.startsWith("API Error")) app.ui.common.error(reason.message);
                    else app.ui.common.error("Error communicating with the server:\r\n " + reason.message);
                }
            })
        }
        return promise;
    },
    /**
     * Creates a promise wrapping an API {@link request} which is resolved or rejected* when the API response is processed or fails.
     * Unlike {@link app.api.promise}, this method will prevent any exceptions while awaiting the API Promise. If an exception or rejection occurs, a default response is resolved instead.
     * @param {string} action the API action to request
     * @param {string|Object|FormData} data
     * @param {boolean} acceptNoData whether to accept (resolve) responses with "no data" (ie: no fields other than metadata about the request).  This is particularly useful if you are expecting an array or optional value.
     * @param {boolean} defaultErrorMessage whether to create default error message dialogs when API errors (or no-data) occur.
     * @param {any} defaultResponse the value to return in place of the promise result when there is an error awaiting the promise.
     * @returns {Promise<APIRequestData|object>|any} a promise that yields the API response data, or is rejected - depending on if the request has an error or was accepted. If an exception occurs while awaiting the promise, defaultResponse is returned.
     */
    async promiseNoThrow(action, data = "", acceptNoData = false, defaultErrorMessage = true, defaultResponse = null){
        try{
            return await this.promise(action,data,acceptNoData,defaultErrorMessage);
        }catch(ex){
            console.warn("API Promise await failed",action);
            return defaultResponse;
        }
    },

    /**
     * Wraps an API {@link request} in a {@link promise} which only yields an array of results.
     *
     * The promise will be rejected if the API response data does not contain valid number-indexed results.
     *
     * Note: this method strips metadata about the request from the result - if you need that data, you should use {@link promise} or {@link app.ui.event.handle_args} to capture API events. (see {@link request})
     *
     * @param {string} action the action to request
     * @param {string|Object|FormData} data the serialized form data to submit to the API
     * @param {boolean} acceptNoData whether to accept a lack of entries (as an empty array)
     * @param defaultErrorMessage whether to display a default error message dialog for AJAX and API errors.
     * @returns {Promise<any[]>} a promise yielding an array of response values, if valid.
     */
    promise_arraydata:function (action, data = "", acceptNoData = true, defaultErrorMessage = true) {
        return new Promise((resolve, reject) => {
            app.api.promise(action, data, acceptNoData, defaultErrorMessage).then((data) => {
                let arr = [];
                let n = data === null ? 0 : data['field-count'];
                if (acceptNoData && (data === null || n === 0)) resolve(arr);
                for (let i = 0; i < n; i++) {
                    if (typeof data[i] === "undefined") reject("API data was not compatible with array type");
                    arr.push(data[i]);
                }
                resolve(arr);
            }).catch((reason) => {
                reject(reason);
            });
        });
    },

    /**
     * Wraps an API {@link request} in a {@link promise} which only yields an array of results.
     * Unlike {@link app.api.promise_arraydata}, this method will prevent any exceptions while awaiting the API Promise. If an exception or rejection occurs, a default response is resolved instead.
     *
     * The API promise will be rejected if the API response data does not contain valid number-indexed result. (triggering the default response)
     *
     * Note: this method strips metadata about the request from the result - if you need that data, you should use {@link promise} or {@link app.ui.event.handle_args} to capture API events. (see {@link request})
     *
     * @param {string} action the action to request
     * @param {string|Object|FormData} data the serialized form data to submit to the API
     * @param {boolean} acceptNoData whether to accept a lack of entries (as an empty array)
     * @param defaultErrorMessage whether to display a default error message dialog for AJAX and API errors.
     * @param {any} defaultResponse the value to return in place of the promise result when there is an error awaiting the promise.
     * @returns {Promise<any[]>|any} a promise yielding an array of response values, if valid.
     */
    async promiseNoThrow_arraydata(action, data = "", acceptNoData = true, defaultErrorMessage = true, defaultResponse = null){
        try{
            return await this.promise_arraydata(action,data,acceptNoData,defaultErrorMessage);
        }catch(ex){
            console.warn("API Promise await failed",action);
            return defaultResponse;
        }
    },

    /**
     * Generates a post-data string for the object, using property names as field names and values as values (propertyname1=propertyvalue1&...)
     * @param {object} obj
     * @returns {string}
     */
    objectToPostData:function (obj) {
        let postData = "";
        for (let [key, value] of Object.entries(obj)) {
            postData += "&" + encodeURIComponent("" + key) + "=" + encodeURIComponent("" + value);
        }
        return postData;
    },

    /**
     * Generates a post-data string for the array, using the fieldname as an array-value input (fieldname[]=value1&fieldname[]=value2&...)
     * @param {string} fieldname
     * @param {string[]} arr
     * @returns {string}
     */
    arrayToPostData:function (fieldname, arr) {
        let postData = "";
        for (let value of arr) {
            postData += "&" + encodeURIComponent("" + fieldname) + "[]=" + encodeURIComponent("" + value);
        }
        return postData;
    }

}



/**
 * UI Display information (display,value) of a list entry.
 * @typedef {object} APIValuePair_Display
 * @property {string} display the display string for the value for UI purposes
 * @property {*} value the actual value of the entry.
 */


/**
 * API Request event callback - this function is called when the API Request it is passed to changes states.
 * @callback APIRequestCallback
 * @param {APIStatus} status the status string of the API event occuring
 * @param {APIRequestData} data an object containing information returned from the serverside API
 * @param {string} [action] the API action originally requested
 * @param {APIRequestFlags} [flags] flag values
 */
/**
 * API Request data callback - this function is called when the API Request it is passed to receives raw data of any kind
 * @callback APIRequestDataCallback
 * @param {APIRequestData|object} data an object containing information returned from the serverside API
 * @param {APIStatus} status
 * @param {jqXHR} request
 */
/**
 * API Request error callback - this function is called when the API Request it is passed to receives an error
 * @callback APIRequestErrorCallback
 * @param {object} data the data of the request - this is generally an unusable value / empty object or empty string
 * @param {APIStatus} status
 * @param {jqXHR} request
 * @param error error value from ajax
 */

/**
 * @typedef {Object} APIRequestFlags
 * @property {boolean} hadData whether the request has received data
 * @property {boolean} error whether the request encountered an error (ajax, API, or otherwise)
 */

/**
 * Data returned from the server API. May contain fields in addition to the ones here.
 * @typedef {Object} APIRequestData
 * @property {string|number} api-error the error code, or 0 if there is no error
 * @property {number} field-count number of fields of data returned by the API, not counting meta fields like this one.
 * @property {string} requested-action the action that was requested by the client
 */

/**
 * API Data returned from a search request. Will contain other fields than ones defined here
 * @typedef {Object} APIRequestData_Search
 * @property {number} total-results the total results for the request, ignoring pagination, offset, and limits
 * @property {number} requested-offset the offset (start of page entries) that was requested by the client
 * @property {number} requested-amount the amount (number of results on page) that was requested by the client
 *
 */


//trying to autocomplete api status strings, does not work with newest intellij
/**
 * @typedef {string} APIStatus
 */
/**
 * Enumeration of API Request States
 * @enum {APIStatus}
 */

class AbstractCache{
    constructor(maxOutdatedDiff,maxAgeOutdated,maxAge=-1) {
        //console.log('   AbstractCache',maxOutdatedDiff,maxAgeOutdated,maxAge)
        this.maxOutdatedDiff = maxOutdatedDiff;
        this.maxAgeOutdated = maxAgeOutdated;
        this.maxAge = maxAge;
        this.time = -1;
    }
    static _defaultNow(){
        return Date.now()/1000;
    }
    updateTime(nowTime=null){
        //console.log("   cache updateTime B",nowTime,typeof nowTime)
        if(nowTime===null) nowTime = AbstractCache._defaultNow();
        //console.log("   cache updateTime A",nowTime,typeof nowTime)
        this.time = nowTime;
        //console.log("   cache updateTime T",this.time)
    }
    isValidAge(nowTime=null){
        if(nowTime===null) nowTime = AbstractCache._defaultNow();

        if(this.time===-1) return false;
        let age = nowTime > this.time ? nowTime - this.time : 0;
        // noinspection RedundantIfStatementJS
        if(this.maxAge!==-1 && age > this.maxAge) return false;

        return true;
    }
    invalidate(){ this.time=-1; }
    isValid(freshTime,nowTime=null){
        if(nowTime===null) nowTime = AbstractCache._defaultNow();
        if(this.time===-1) return false;
        if(!this.isValidAge(nowTime)){
            //console.log(' cache not valid age',nowTime,this.time);
            return false;
        }
        let outdatedDiff = freshTime > this.time  ? freshTime - this.time : 0;
        let age = nowTime > this.time ? nowTime - this.time : 0;
        if(this.maxOutdatedDiff!==-1 && outdatedDiff > this.maxOutdatedDiff){
            //console.log(' cache too outdated',this.time,freshTime,outdatedDiff,this.maxOutdatedDiff);
            return false;
        }
        // noinspection RedundantIfStatementJS
        if(this.maxAgeOutdated!==-1 && outdatedDiff > 0 && age > this.maxAgeOutdated){
            //console.log(' cache too old for outdated',this.time,nowTime,age,freshTime,outdatedDiff,this.maxAgeOutdated);
            return false;
        }
        //console.log(' cache valid',this.time,nowTime,age,this.maxAge,freshTime,outdatedDiff,this.maxOutdatedDiff,this.maxAgeOutdated);
        return true;
    }
}

class ValueCache extends AbstractCache{
    constructor(maxOutdatedDiff,maxAgeOutdated,maxAge=-1) {
        //console.log('  ValueCache',maxOutdatedDiff,maxAgeOutdated,maxAge)
        super(maxOutdatedDiff,maxAgeOutdated,maxAge);
        this.value = null;
    }
    update(value=null, nowTime=null){
        this.value = value
        this.updateTime(nowTime);
        //console.log("   cache update: updateTime TA",this.time)
    }
    invalidate() {
        super.invalidate();
        this.value=null;
    }

    isValid(freshTime,nowTime=null){
        if(this.value===null){
            //console.log(' cache invalid value (VC)');
            return false;
        }
        return super.isValid(freshTime,nowTime);
    }
}

class StorageCache extends ValueCache{
    static cache_key= 'app.cache';
    static cachetime_key= 'app.cachetime';
    constructor(name,maxOutdatedDiff,maxAgeOutdated,maxAge=-1) {
        //console.log(' StorageCache',name,maxOutdatedDiff,maxAgeOutdated,maxAge)
        super(maxOutdatedDiff, maxAgeOutdated, maxAge);
        this.storage = window.sessionStorage ? window.sessionStorage : null;
        this.name = name;
        this.init();
    }
    retrieve(){
        if(window.sessionStorage===null) return;
        let svalue = this.storage.getItem(StorageCache.cache_key+'.'+this.name);
        if(svalue!==null){
            // noinspection RegExpRedundantEscape
            let parts = svalue.split('[::]');
            let type = parts[0];
            let json = parts[1];
            this.value = JSON.parse(json);
        }
        this.time = +this.storage.getItem(StorageCache.cachetime_key+'.'+this.name);
        //console.log('  cache retrieve',StorageCache.cache_key+'.'+this.name,typeof this.value,this.value,this.time);
    }
    store(){
        if(window.sessionStorage===null) return;
        let svalue = this.value;
        if(svalue!==null) svalue = (typeof this.value)+'[::]'+JSON.stringify(svalue);
        //console.log(' cache store',StorageCache.cache_key+'.'+this.name,svalue);
        //console.log('  cache store for', this.value);
        if(typeof svalue!=="string" || svalue.indexOf('object Object')!==-1) throw "invalid cache storage value";
        this.storage.setItem(StorageCache.cache_key+'.'+this.name,svalue);
        //console.log('  cache time',StorageCache.cachetime_key+'.'+this.name,this.time,typeof this.time);
        //console.log('   cache time for', this.value);
        this.storage.setItem(StorageCache.cachetime_key+'.'+this.name,this.time);

        //console.log('  cache test get',this.storage.getItem(StorageCache.cache_key+'.'+this.name))
        //console.log('  cache test time',this.storage.getItem(StorageCache.cachetime_key+'.'+this.name))
    }
    clear(){
        this.storage.removeItem(StorageCache.cache_key+'.'+this.name);
        this.storage.removeItem(StorageCache.cachetime_key+'.'+this.name);
    }
    init(){
        this.retrieve();
    }
    update(value=null, nowTime=null){
        //console.log(' cache update (S)',value,nowTime,typeof nowTime);
        super.update(value,nowTime);
        this.store();
    }
    invalidate(invalidateStorage=true) {
        super.invalidate();
        if(invalidateStorage) this.clear();
    }

    isValid(freshTime,nowTime=null){
        if(app.cache.minimumStorageTimestamp > this.time) return false;
        return super.isValid(freshTime,nowTime);
    }

}

class StoredResultCache extends StorageCache{
    constructor(name,callback,maxOutdatedDiff,maxAgeOutdated,maxAge=-1) {
        //console.log('StoredResultCache',name,maxOutdatedDiff,maxAgeOutdated,maxAge)
        super(name,maxOutdatedDiff,maxAgeOutdated,maxAge);
        this.callback = callback;
    }
    async call(freshTime,nowTime,thisArg,...args){
        //console.log(' cache call (SRC)',freshTime,nowTime,this.callback.call);
        if(!this.isValid(freshTime,nowTime)){
            //console.log(' cache invalid (SRC)',freshTime,nowTime,this.callback.call);
            let value = await this.callback.call(thisArg,...args);
            this.update(value,nowTime);
            //console.log("   cache call: update: updateTime TA",this.time)
        }
        return this.value;
    }
    bind(freshTime,nowTime,thisArg,...args){
        return StoredResultCache.prototype.call.bind(this,freshTime,nowTime,thisArg,...args);
        /*return (function(instance){
            return function(){
                return instance.call(thisArg, ...args);
            }
        })(this);*/
    }
}

class ResultCache extends ValueCache{
    constructor(callback,maxOutdatedDiff,maxAgeOutdated,maxAge=-1) {
        //console.log('ResultCache',name,maxOutdatedDiff,maxAgeOutdated,maxAge)
        super(maxOutdatedDiff,maxAgeOutdated,maxAge);
        this.callback = callback;
    }
    async call(freshTime,nowTime,thisArg,...args){
        //console.log(' cache call (RC)',this.callback.call);
        if(!this.isValid(freshTime,nowTime)){
            let value = await this.callback.call(thisArg,...args);
            this.update(value,nowTime);
        }
        return this.value;
    }
    bind(freshTime,nowTime,thisArg,...args){
        return ResultCache.prototype.call.bind(this,freshTime,nowTime,thisArg,...args);
        /*return (function(instance){
            return function(){
                return instance.call(thisArg, ...args);
            }
        })(this);*/
    }
}

app.cache = {
    minimumStorageTimestamp: -1, //this is a validity check that is set by forced user permissions updates
    /**
     *
     * @param {string} api_action
     * @param {number} maxAge
     * @param {string|Object|FormData} data
     * @param {boolean} acceptNoData
     * @param {boolean} defaultErrorMessage
     * @param {null|string} cacheSuffix
     * @returns {Promise<APIRequestData|object>}
     * @constructor
     */
    APIPromise:function(api_action,maxAge=15*60,data="",acceptNoData=false,defaultErrorMessage=true,cacheSuffix=null){
        let cache = app.cache.createStoredResult('api.'+api_action+(cacheSuffix??''),function(){
            return app.api.promise(api_action,data,acceptNoData,defaultErrorMessage);
        },-1,-1,maxAge);
        cache.retrieve();
        return cache.call(-1,null,app.api);
    },
    /**
     *
     * @param {string} api_action
     * @param {number} maxAge
     * @param {string|Object|FormData} data
     * @param {boolean} acceptNoData
     * @param {boolean} defaultErrorMessage
     * @param {null|string} cacheSuffix
     * @returns {Promise<*[]>}
     * @constructor
     */
    APIPromiseArray:function(api_action,maxAge=15*60,data="",acceptNoData=true,defaultErrorMessage=true,cacheSuffix=null){
        let cache = app.cache.createStoredResult('api.'+api_action+(cacheSuffix??''),function(){
            return app.api.promise_arraydata(api_action,data,acceptNoData,defaultErrorMessage);
        },-1,-1,maxAge);
        cache.retrieve();
        return cache.call(-1,null,app.api);
    },
    clearAPICache(api_action,cacheSuffix=null){
        let cache = app.cache.createStoredValue('api.'+api_action+(cacheSuffix??''),-1,-1,86400);
        cache.clear();
    },
    createStoredResult:function(name,callback,maxOutdatedDiff,maxAgeOutdated,maxAge=-1){
        //console.log('createStoredResult',name,callback,maxOutdatedDiff,maxAgeOutdated,maxAge);
        return new StoredResultCache(name,callback,maxOutdatedDiff,maxAgeOutdated,maxAge);
    },
    createResult:function(callback,maxOutdatedDiff,maxAgeOutdated,maxAge=-1){ return new ResultCache(callback,maxOutdatedDiff,maxAgeOutdated,maxAge); },
    clearStoredValue:function(name){
        let cache = app.cache.createStoredValue(name,-1,-1,86400);
        cache.clear();
    },
    createStoredValue:function(name,maxOutdatedDiff,maxAgeOutdated,maxAge=-1){ return new StorageCache(name,maxOutdatedDiff,maxAgeOutdated,maxAge); },
    createValue:function(maxOutdatedDiff,maxAgeOutdated,maxAge=-1){ return new ValueCache(maxOutdatedDiff,maxAgeOutdated,maxAge); },
    createTimer:function(maxOutdatedDiff,maxAgeOutdated,maxAge=-1){ return new AbstractCache(maxOutdatedDiff,maxAgeOutdated,maxAge); },
    getStoredValue:function(name){
        let cache = new StorageCache(name,-1,-1,-1);
        cache.retrieve();
        return cache.value;
    },
    setStoredValue:function(name,value,nowTime=null){
        let cache = new StorageCache(name,-1,-1,-1);
        cache.update(value,nowTime);
        //console.log("   cache setStoredValue: update: updateTime TA",this.time)
        return cache.value;
    },
    clearStorage:function(){
        if(window.sessionStorage) window.sessionStorage.clear();
    },
}

app.api.perms={
    //permission cache ages. NOTE: "forced" user perm updates serverside still force a cache miss to occur.


    /**
     * Returns a promise that is resolved only if all specified permissions are available.
     * Otherwise, the promise is rejected.
     * @param $perms
     * @returns {Promise<boolean>} Promise: always resolves to true or is rejected.
     */
    promise:function ($perms){
        return new Promise((resolve,reject)=>{
            app.api.perms.check($perms).then(
                (allperms)=>{
                    if(allperms) resolve(allperms);
                    reject(allperms);
                },
                (reason)=>{
                    reject(reason);
                }
            )
        })
    },

    /**
     * Returns a promise that is resolved only if all specified permissions are available, or a default value is supplied.
     * Otherwise, the promise stays pending forever (unless a default value is supplied).
     * @param $perms
     * @param defaultResult the default value to resolve the promise to if the promise is rejected or there is an error checking permissions.  If this is null, the promise will not be resolved on failure.
     * @returns {Promise<boolean>|null|any} Promise: resolved to true if the permission checks succeeds for all specified permissions. Otherwise, it is never resolved unless the defaultResult value if supplied and not-null.
     */
    async promiseNoThrow($perms,defaultResult=null){
        return new Promise(async (resolve,reject)=>{
            try{
                return resolve(await this.promise($perms));
            }catch(ex){
                if(defaultResult!==null) return resolve(defaultResult);
                //return defaultResult;
            }
        })
    },

    /**
     * Returns a promise which resolves to whether all requested permissions are available.
     * The promise is only rejected when the request fails or encounters an error.
     * @param $perms
     * @returns {Promise<boolean>} Promise: resolves to true or false, rejected on error
     */
    check:function ($perms){
        return app.api.perms.lookup($perms).then((data)=>{
            return data['all-perms-requested'];
        });
    },

    /**
     * Returns a promise which resolves to whether all requested permissions are available.
     * If the request fails or encounters an error, the default value is returned.
     * @param $perms
     * @param defaultResult the default value to return if there is an error checking the permissions
     * @returns {Promise<boolean>} Promise: resolves to true or false, rejected on error
     */
    async checkNoThrow($perms,defaultResult=null){
        try{
            return await this.check($perms);
        }catch(ex){
            return defaultResult;
        }
    },


    /**
     * Throws an error if all specified permissions are not available, otherwise resolves to the permissions request object.
     * @param $perms
     * @returns {Promise<{checks: {}, "all-perms-requested": boolean}>|Promise<APIRequestData|Object>}
     */
    require:function ($perms) {
        let promise = app.api.perms.lookup($perms);
        promise.then((data) => {
//            console.log("Permissions-Checks", data);
            if (!data['all-perms-requested']) {
                $(".template-center").empty().text("You do not have all the permissions required for this page.");
                throw new Error("permission error");
            }
        }).catch((reason) => {
            let message = "There was an error checking your permissions - please try again later.";
            if (reason === "permission") message = "You do not have all permissions required for this page. (2)";
            $(".template-center").empty().text(message);
            throw new Error("permission error");
        });

        return promise;
    },
    //-------------------------------------

    lookup:async function(perms) { //TODO: check if this is still broken or cache-missing too often!
        let apiperms = app.api.perms;
        let cache = apiperms.cache;

        if (!Array.isArray(perms)) perms = [perms];//ensure the input is always an array (or turned into an array of one element)

        /**
         * @type {APIPermCacheDisposition}
         */
        let cacheDisposition = await app.api.perms.cache.retrieve(perms);

        let results = Object.assign(Object.assign({},cacheDisposition.cachedResults));

        let lookupTime = Date.now()/1000;

        if(cacheDisposition.uncachedPerms.length!==0){
            if(cache.debug) console.debug(' api perm requesting',cacheDisposition.uncachedPerms,cacheDisposition.cachedResults);
            let resultsRequested = await apiperms.request(cacheDisposition.uncachedPerms); //TODO: result checks is empty - implying input is empty
            lookupTime = +resultsRequested.time;
            if(cache.debug) console.debug(' api perm requested',Object.assign({},resultsRequested.checks));
            cache.store(resultsRequested.checks,lookupTime);

            results = Object.assign(results,resultsRequested.checks);
        }


        let resultsTrue = 0;
        for(let value of Object.values(results)) if(value) resultsTrue++;

        return {'checks':results, 'all-perms-requested': (resultsTrue===Object.keys(results).length), 'time':lookupTime};

    },



    request:function ($perms) {
        if (!Array.isArray($perms)) $perms = [$perms];//ensure the input is always an array (or turned into an array of one element)

        for(let i=0; i<$perms.length; i++){
            $perms[i] = app.api.perms._ensureBasePrefix($perms[i]);
        }

        let postData = app.api.arrayToPostData("name", $perms);

        if (postData.length === 0) return Promise.resolve(app.api.perms._dummyRequest());

        return app.api.promise("permissions.check.self", postData,false,false);

        /*

            let promise = new Promise(function(resolve,reject){
                let postdata_ = postData;
                if(postdata_.length===0){
                    resolve(ui_api_perm__dummyRequest());
                    return;
                }

                console.log("perm check post",postdata_)
                rcps.api.request("permissions.check.self",postdata_,function(status,data){
                    switch(status){
                        case "ajax-fail":
                            rcps.ui.common.error("Error checking permissions")
                            reject('error')
                            return
                        case "api-error":
                            if(data['api-error'].indexOf('permission')!==-1) reject('permission'); //permission-related error accessing the check API. we have to assume they don't have permission to other things.
                            else reject('error');
                            return;
                        case "got-data":
                            resolve(data);
                            return;
                    }
                });

            });
            return promise;*/
    },

    _dummyRequest:function () { // used for cases where no perms were requested
        return {'all-perms-requested': true, 'checks': {}};
    },
    _ensureBasePrefix:function(perm){
        if(perm.startsWith(app.data.values.APP_PERMISSION_BASE+".")) return perm;
        return app.data.values.APP_PERMISSION_BASE+"."+perm;
    },


    cache:{

        /**
         * maximum number of seconds the cached perms can be outdated compared to the server (assuming overzealous server cache changes).
         * this is a 'grace period' where old permission checks are allowed to exist (cache hit)  [notwithstanding other restrictions].
         * This 'grace period' can only exist for up to the time specified by cache_maxOutdatedAge from the request time.
         * NOTE: "forced" user perm updates serverside still force a cache miss to occur.
         */
        maxOutdatedDiff: 5*60,

        /**
         * maximum age in seconds of cached permissions [if they are outdated at all].
         * Permissions that match the server time will not cache-miss due to age [notwithstanding other restrictions].
         * This ensures that any permission that is within the 'grace period' of cache_maxOutdatedDiff can only remain in it for a limited time.
         * NOTE: "forced" user perm updates serverside still force a cache miss to occur.
         *
         */
        maxOutdatedAge: 5*60,

        /**
         * maximum number of seconds the cache can go between checking the server times again
         */
        checkTime: 30,

        permCheckCache : null,

        debug: false,

        init_completed:false,

        init:function(){
            let cache = app.cache;
            let permcache = app.api.perms.cache;
            if(permcache.init_completed) return;
            permcache.permCheckCache = app.cache.createStoredResult('perms.checked', async function(){
                let result = await app.api.promise('permissions.check.time');
                app.cache.minimumStorageTimestamp = result.timestamp_lastforced ?? app.cache.minimumStorageTimestamp;
                return result;
            },-1,-1,permcache.checkTime);
            permcache.init_completed = true;

            //cache.permCheckCache = rcps.cache.createStorage('perm.checked',-1,-1,cache.checkTime);
        },


        /**
         *
         * @return {Promise<APIPermCheckTimesData>}
         */
        getCheckTime:async function(){
            let api = app.api;
            let cache = app.api.perms.cache;
            cache.init();

            return cache.permCheckCache.call(-1);
        },


        /**
         * @param {string[]|string} perms
         * @returns {Promise<APIPermCacheDisposition>}
         */
        retrieve:async function(perms) {
            let api = app.api;
            let apiperms = app.api.perms;
            let permcache = app.api.perms.cache;
            permcache.init();

            if (!Array.isArray(perms)) perms = [perms];//ensure the input is always an array (or turned into an array of one element)

            /**
             *
             * @type {APIPermCheckTimesData}
             */
            let times = await permcache.getCheckTime();


            let resultsCached = {}
            let uncachedPerms = [];
            let results = [];
            for(let perm of perms){
                perm = app.api.perms._ensureBasePrefix(perm);
                let permcachei = app.cache.createStoredValue('perm.'+perm,permcache.maxOutdatedDiff,permcache.maxOutdatedAge);
                permcachei.retrieve();
                permcachei.valid = permcachei.isValid(times.timestamp) && permcachei.time>=times.timestamp_lastforced;
                if(permcachei.valid){
                    if(permcache.debug) console.debug("  api perm cache hit",permcachei,times);
                    resultsCached[perm] = permcachei.value;
                }else {
                    uncachedPerms.push(perm);
                }
                results.push(permcachei);
            }
            //--------------------------
            return {'results':results,'cachedResults':resultsCached,'uncachedPerms':uncachedPerms};

        },

        /**
         *
         * @param {object} checksObject
         * @param {int} newTime
         */
        store:function(checksObject,newTime=null){
            if(newTime===null) newTime=Date.now()/1000;
            for(let [key,value] of Object.entries(checksObject)) app.cache.setStoredValue('perm.'+key,value,newTime);
        },
    }
};
app.api.perms.cache.init();

/**
 * @typedef {Object} APIPermCacheEntry
 * @property {string} perm the requested permission name
 * @property {null|0|1} value the value of the permission, or null if no cache entry was available. This should be used to check if the cache entry exists.
 * @property {null|int} time the server time of the request for the permission
 */
/**
 * @typedef {Object} APIPermCacheEntryRaw
 * @property {string} perm the requested permission name
 * @property {null|string} value the value of the permission, or null if no cache entry was available. This should be used to check if the cache entry exists.
 * @property {null|int} time the server time of the request for the permission
 */

/**
 * @typedef {Object} APIPermCacheDisposition
 * @property {Object} cachedResults
 * @property {string[]} uncachedPerms
 */

/**
 * @typedef {Object} _APIPermCheckTimesFields
 * @property {int} timestamp
 * @property {int} timestamp_lastforced
 *
 */
/**
 * @typedef {APIRequestData & _APIPermCheckTimesFields} APIPermCheckTimesData
 *
 */
/**
 * App Common UI method library
 */
app.ui.common = {
    //scroll: {},
    //drag: {},
    //file: {},
    //autocomplete: {},
    /**
     * Whether Overlays are supported by the UI at this time
     * @returns {boolean}
     */
    supportsOverlays:function(){
        return (typeof app.ui.overlay !== "undefined");
    },
    /**
     * Whether API is supported at this time
     * @returns {boolean}
     */
    supportsAPI:function(){
        return (typeof app.api !== "undefined");
    },

    generateElementId(prefix=null){
        return (prefix??'elem')+"-"+(""+Math.random()).replaceAll('.','_');
    },


    /**
     * Displays a confirmation window for the user.
     *
     * Currently this is implemented with the native {@link window.confirm} method - but this should not be taken for granted.
     *
     * Note: if Overlays are supported at the time, this will display an overlay behind the prompt until it is complete.
     * @param message the message to display
     * @param timeoutMS a timeout in milliseconds, after which to close the confirmation prompt. Only has an effect if UI Overlays are supported - has no effect on native confirm prompts.
     * @returns {Promise<boolean>} When the user has interacted or closed the prompt, the promise will yield whether the user has agreed to the confirmation or not.
     */
    confirm:async function (message,timeoutMS=10000) {//not actually async yet but could be in the future
        let value = null;
        if(app.ui.common.supportsOverlays()){
            //app.ui.overlay.show("ui_form_confirm");
            //console.debug("ui-common.confirm",'opening overlay');
            let pvalue = app.ui.overlay.confirm('Confirmation',message,null,timeoutMS);
            value = await pvalue;
            //console.debug("ui-common.confirm",'resolved',pvalue,value);
            //app.ui.overlay.hide("ui_form_confirm");
        }else{
            //if(app.ui.common.supportsOverlays()) app.ui.overlay.show("ui_form_confirm");
            value = confirm(message);
            //if(app.ui.common.supportsOverlays()) app.ui.overlay.hide("ui_form_confirm");
        }
        return value;
    },
    /**
     * Display a message (alert) message with Informational styling.
     *
     * Note: if Overlays are supported, this uses the in-app {@link app.ui.overlay.message} method to display a custom alert.
     * Otherwise, the native {@link window.alert} is used.
     * @param message the message text to display
     * @returns {Promise<void>} A promise that is resolved when the user closes the message window.
     */
    info: async function(message) {
        if(app.ui.common.supportsOverlays()) await app.ui.overlay.message("information", message);
        else alert(message);
    },

    /**
     * Display a message (alert) message with Error styling.
     *
     * Note: if Overlays are supported, this uses the in-app {@link app.ui.overlay.message} method to display a custom alert.
     * Otherwise, the native {@link window.alert} is used.
     *
     * Note: closing the message window will disable all overlays.
     * @param message the message text to display
     * @param timeMs a timeout after which the error window will automatically be closed (in milliseconds)
     * @returns {Promise<void>} A promise that is resolved when the user closes the message window.
     */
    error:async function(message, timeMs = 10000) {
        if(app.ui.common.supportsOverlays()) await app.ui.overlay.message("error", message, null, timeMs);
        else alert(message);
        app.ui.overlay.hide("error-closed",true);
    },

    intuitiveClickNavbar: function (navbar_id, oldMethod = false) { //makes clicking the containing nav-item have the same effect as clicking the link inside it
        let navbar_id_s = $.escapeSelector(navbar_id);
        let navbar = $("#" + navbar_id_s);

//        console.log("NAVBAR", navbar, navbar.find('.nav-item'));
        navbar.find('.nav-item').click(function (evt) {
            //ar originalElement = e.srcElement || e.originalTarget;
//            console.log(" ITEM CLICK", this, evt.target, this === evt.target);
            if (this !== evt.target) return;//don't handle propagated events from the inside elements

            if ($(this).hasClass('dropdown')) {
//                console.log("  DROPDOWN", $(this).hasClass('show'));
                //$(this).toggleClass('show'); // conflicts with initial click
//                console.log("    ", $(this).hasClass('show'));

                $(this).find('.dropdown-menu').toggleClass('show');
            } else {
//                console.log("  HREF")
                let href = $(this).find(".nav-link").first().attr('href');
                if (href && href !== "#") window.location = href;
            }


        })
    },

    setup_buttonCheckBox: function (id, cb = null) {
        let id_s = $.escapeSelector(id);
        let label = $("label[for='" + id_s + "']")
        let input = $("#" + id_s);

        label.addClass('checkbox-button-label btn btn-secondary');
        input.addClass('checkbox-button-input d-none');
        let both = label.add(input);

        both.on("change click", function () {
            let cb_ = cb;
            let input_ = input;
            let label_ = label;
            let checked = input_.is(":checked");
//            console.log("buttoncheck-update", checked, $(this), input_, label_);
            //rcps.ui.event.buttonCheckbox_update(checked, $(this), input_, label_);
            if (cb !== null) cb_(checked, $(this), input_, label_);
        });
    },

    /**
     * Finds an already-defined CSS rule based on a selector.
     *
     * Unlike manipulating classes with jQuery, changing CSSRules from this method will make changes that can affect new elements added after the change - allowing you to set display states that are friendly with changing content.
     *
     * Because of some behavioral tweaks, using a parent-and-child conditional CSS rule (where you manipulate the class on a parent element to set display states) is preferable to this method.
     *
     * Note: This method cannot find cross-domain or cross-protocol CSS rules.  Only "Style Rules" are supported.
     * @param selector a selector to find the rule for (must match exactly).
     * @returns {null|CSSRule} the matching CSS rule, if any.
     * @deprecated
     */
    findCssRule: function (selector) {
        var sheet;
        var list;
        /**
         * @type CSSRule
         */
        var rule;
        var sheets = document.styleSheets;

        if (sheets) {
            // noinspection JSAssignmentUsedAsCondition
            for (var i = 0; sheet = sheets[i++];) {
                try {
                    list = sheet.cssRules || sheet.rules;   // sheet.rules in IE;
                } catch (e) { //external stylesheet access is blocked by CORS
                    continue;
                }


                for (var j = 0; j < list.length; ++j) {
                    rule = list[j]
                    // noinspection EqualityComparisonWithCoercionJS
                    if (rule.type != 1)  // styleRule
                        continue;
                    // noinspection EqualityComparisonWithCoercionJS
                    if (rule.selectorText != selector)
                        continue;
                    return rule;
                }
            }
        }
        return null;
    },

    /**
     * Shows or hides an entire css rule (not just the present elements, but ones that may not yet be present also).
     *
     * Note that this requires a css rule to exist for the selector already in your stylesheet - even if it is empty.
     *
     * Note 2: this requires the element to be visible and then hidden with this function in order to know the correct display value.
     *
     * Because of some behavioral tweaks, using a parent-and-child conditional CSS rule (where you manipulate the class on a parent element to set display states) is preferable to this method.
     *
     * Uses {@link findCssRule} to determine which rule to modify.
     * @param selector a selector matching a CSS rule
     * @param show the display state
     * @deprecated
     */
    showClass: function (selector, show = true) { //jQuery only hides/shows each matching element, it doesn't hide/show the class for future elems
        //var showCss="table-cell";
        var hideCss = "none";
        var rule = app.ui.common.findCssRule(selector);
        if (rule) {
            if (rule.style.display !== "none") rule.style['display-enabled-value'] = rule.style.display;
            let showCss = (typeof rule.style['display-enabled-value'] === "undefined") ? "block" : rule.style['display-enabled-value'];

            rule.style.display = (show ? showCss : hideCss);
        } else {
            if (show) $(selector).show();
            else $(selector).hide();
        }

        app.ui.event.fire("form:show-class", {selector: selector, show: show});
    },

    /**
     * Creates a "transient" date field from a selected input - which is an Input Text field that becomes a date field when focused.
     *
     * Elements attacched with this method will have either `transient-date-text` or `transient-date-picker` class depending on whether they are focused.
     * @param {jQuery} jqTextIn the selected input element(s)
     */
    attachTransientDateField(jqTextIn) {
        jqTextIn.addClass('transient-date-text');
        jqTextIn.focus(function () {
            $(this).attr('type', 'date');
            jqTextIn.addClass('transient-date-picker');
            jqTextIn.removeClass('transient-date-text');
        });
        jqTextIn.blur(function () {
            $(this).attr('type', 'text');
            jqTextIn.removeClass('transient-date-picker');
            jqTextIn.addClass('transient-date-text');
        });
    },

    /**
     * Updates the GET parameters of the current page URL (using {@link window.history.pushState} ) and title of the page with the object properties provided.
     *
     * Note: This will add a History entry that the user must use the back-button to return from.
     *
     * Fires a `page:update-url-obj` {@link app.ui.event} event when complete.
     * @param params an object containing property names and values to set as GET parameters of the current page address
     * @param title the new title for the page and history entry
     */
    updateURLObj: function (params = {}, title = "") {
        const url = new URL(window.location);
        url.search = "";
        for (const field in params)
            url.searchParams.set(field, params[field]);
//        console.log("updating URL to " + url.href);
        window.history.pushState({}, title, url);
        app.ui.event.fire("page:update-url-obj", {params: params, title: title});
    },

    /**
     * Updates the GET parameters of the current page URL (using {@link window.history.pushState} ) and title of the page with the string provided.
     *
     * Note: This will add a History entry that the user must use the back-button to return from.
     *
     * Fires a `page:update-url-obj` {@link app.ui.event} event when complete.
     * @param {string} search a string set as GET parameters of the current page address
     * @param title the new title for the page and history entry
     */
    updateURLSearch: function (search, title = "") {
        const url = new URL(window.location);
        url.search = search;
//        console.log("updating URL to " + url.href, search, title);
        window.history.pushState({}, title, url);
        document.title = title;
        app.ui.event.fire("page:update-url-search", {search: search, title: title});
    },

    /**
     * Clears contained form element (input, textarea, select) values.
     *
     *
     * This method will set the value of all matching elements [except checkboxes] to "" (blank string).
     * Checkbox elements will be unchecked instead.
     *
     * Note: this method will call {@link app.ui.fixes.fixCheckboxValues} which may standardize the value of matched checkboxes
     * @param formid the ID (without `#`) of a form or parent element containing the form elements.
     */
    clearForm:function(formid) {
        app.ui.event.fire("form:clearing", {form: formid});
        app.ui.overlay.show("ui_form_clear")
        var formid_s = $.escapeSelector(formid);
        $("#" + formid_s + " input").not(":checkbox").val("");
        $("#" + formid_s + " textarea").val("");
        $("#" + formid_s + " select").val("");
        app.ui.fixes.fixCheckboxValues();
        $("input[type=checkbox]").prop('checked', false);
        app.ui.overlay.hide("ui_form_clear");
        app.ui.event.fire("form:cleared", {form: formid});
    },

    /**
     * Legacy method - create a Bootstrap `form-group row` DIV element and appends elements to it
     * @param {jQuery|HTMLElement} args an array of elements to append
     * @returns {*|jQuery|HTMLElement}
     * @deprecated
     */
    createFormRow:function(...args) {
        var div = $('<div class="form-group row">');
        for (let arg of args) {
            //console.log("appending",arg)
            if (!Array.isArray(arg)) arg = $(arg);
            div.append(arg);
        }
        return div;
    },

    /**
     * Legacy method - create a Bootstrap form label to use within a row.
     * @param $id the id of the corresponding form element (the `for` attribute)
     * @param $dispname the display text of the label
     * @param $classes additional classes that should be set on the label
     * @returns {*|jQuery|HTMLElement}
     * @deprecated
     */
    createFormLabel:function($id, $dispname, $classes = "col-sm-2 col-form-label") {
        let $label = $('<label for="' + $id + '" class="' + $classes + ' col-form-label" >');
        $label.text($dispname);
        return $label;
    },

    /**
     * Legacy method - create a Bootstrap input element with the `form-control` class.
     * @param $name the name to set on the input
     * @param $placeholder the placeholder value of the input
     * @param $type the type to set on the input
     * @param {string} $input_attrs additional HTML attributes and values as a string
     * @returns {*|jQuery|HTMLElement}
     * @deprecated
     */
    createFormInput:function ($name, $placeholder = "", $type = "text", $input_attrs = "") {
        let $input = $('<input type="' + $type + '" class="form-control" name="' + $name + '" id="' + $name + '" placeholder="' + $placeholder + '" ' + $input_attrs + '>');
        return $input;
    },

    /**
     * Legacy method - create a Bootstrap select with the `form-control` class
     * @param id the `id` attribute for the Select element
     * @param {*[][]} options an array of options, with each option being an array in the form [value] or [value,displayname].
     * @returns {*|jQuery|HTMLElement}
     * @deprecated
     */
    createFormSelect:function(id, options) {
        let $select = $('<select class="form-control" name="' + id + '" id="' + id + '">');
        for (let option of options) {
            let opvalue = option[0];
//            console.log(option)
            let opdispname = option.length === 1 ? option[0] : option[1];
            let op = $('<option>');
            op.val(opvalue);
            op.text(opdispname);
            $select.append(op);
        }
        return $select;
    },

    /**
     * Legacy method - create a Bootstrap Select element with a label and input column
     * @param $name the `id` of the Select element
     * @param $displayname the display text of the label
     * @param $options options for the select element. See {@link createFormSelect}
     * @param $showlabel whether to include a label
     * @param $label_override_style the classes to set on the label
     * @param $input_attrs [unused] additional input attributes
     * @returns {(*|Window.jQuery|HTMLElement|jQuery|HTMLElement)[]|*|jQuery|HTMLElement} if including a label, an array of the label and input column element. Otherwise, just the input column.
     * @deprecated
     */
    createFormRowSelect:function($name, $displayname, $options, $showlabel = true, $label_override_style = "col-sm-2", $input_attrs = "") {
        let $label = app.ui.common.createFormLabel($name, $displayname, $label_override_style);
        let $input = app.ui.common.createFormSelect($name, $options);
        let $coldiv = $('<div class="col">');
        $coldiv.append($input);
        if (!$showlabel) return $coldiv;
        return [$label, $coldiv];
    },

    /**
     * Legacy method - create a Bootstrap Input with a label and input column
     * @param $name the `id` attribute of the input element
     * @param $displayname the display text of the label
     * @param $placeholder the placeholder text of the input
     * @param $type the input type (text, etc)
     * @param $showlabel whether to include a label
     * @param $label_override_style
     * @param $input_attrs additional attributes to set on the input element
     * @returns {(*|Window.jQuery|HTMLElement|jQuery|HTMLElement)[]|*|jQuery|HTMLElement} if including a label, an array of the label and input column element. Otherwise, just the input column.
     * @deprecated
     */
    createFormRowInput:function($name, $displayname, $placeholder = "", $type = "text", $showlabel = true, $label_override_style = "col-sm-2", $input_attrs = "") {
        let $label = app.ui.common.createFormLabel($name, $displayname, $label_override_style);
        let $input = app.ui.common.createFormInput($name, $placeholder, $type, $input_attrs);
        let $coldiv = $('<div class="col">');
        $coldiv.append($input);
        if (!$showlabel) return $coldiv;
        return [$label, $coldiv];
    },

    /**
     * Autoloads result property-values from an API request into elements with corresponding ID's or Names.
     *
     *
     * Refer to {@link app.api.request} for information about how the request is made.
     *
     * Calls {@link loadFromObject} in the case that data was received. If no data was received, no action will be taken.
     *
     * @param action the API action to request
     * @param postData the POST data to send to the API
     * @param idPrefix the id or name prefix to use when finding elements to load values into
     * @param {APIRequestCallback} eventCallback a callback method called with the request status and data.
     */
    loadFromAPI(action, postData, idPrefix = "", eventCallback = null) {
        app.ui.overlay.show("loadfromapi");
        app.api.request(action, postData, function (status, data, action, flags) {
            let cb = eventCallback;
            let pfx = idPrefix;
            let act = action;
            //	console.log("form_load cb ",action,status);
            switch (status) {
                case "ajax-fail":
                    app.ui.common.error("Error contacting the server. Please try again later.");
                    break;
                case "api-error":
                    app.ui.common.error("An error occurred performing that action.");
                    break;
                case "no-data":
                    //rcps.ui.common.error("No results are available."); //leave this up to the page itself
                    break;
                case "got-data":
                    app.ui.event.fire("form:loading-response", {action: act, status: status, data: data, prefix: pfx});
                    app.ui.common.loadFromObject(data, pfx);
                    app.ui.event.fire("form:loaded-response", {action: act, status: status, data: data, prefix: pfx});
                    break;
                case "postprocess":
                    app.ui.overlay.hide("loadfromapi");
                    break;
            }
            if (cb !== null) cb(status, data, action, flags);
        });
    },

    /**
     * Stub for {@link jQuery.serializeArray}
     * @param formid the selector for a form or input selection
     * @returns {*|jQuery}
     */
    serializeForm:function(formid){
        return $(formid).serializeArray();
    },

    /**
     * Autoload values from an object into corresponding Radio elements.
     *
     * This method will find radio elements with a NAME attribute matching the key (property name) from the object and will check or uncheck each based on whether they have a matching value (using string comparison).
     *
     * Note: elements will be filled anywhere in the body unless a 'data target' is set with {@link setLoadDataTarget}.
     * @param object the object containing the property values.
     * @param namePrefix a prefix to prepend when searching for radio element names.
     */
    loadRadiosFromObject:function(object,namePrefix=""){
        let target = app.ui.common.loadDataTarget!==null ? $(app.ui.common.loadDataTarget) : $('body');
        $.each(object, function (key, val) {
            if (key === "") return;
            let escapedKey = $.escapeSelector(namePrefix + key);
            //console.log(" radio? ",key,escapedKey,val);
            target.find('input[name="' + escapedKey + '"][type="radio"]').each(function () {
//                console.log("  set radio",key,val,$(this).val(),(""+$(this).val())===(""+val),this);
                $(this).prop('checked', (""+$(this).val())===(""+val));
            })
        });
    },

    loadDataTarget:null,

    /**
     * Sets the container element for field values loaded by {@link loadRadiosFromObject} and {@link loadFromObject}.
     *
     * If this is set to null, the entire document body will be searched for matching elements when loading values.
     *
     * Otherwise, this must be set to a jQuery selection that supports {@link jQuery.find} to search for child form elements.
     *
     * @param {jQuery|null} v the jquery selection of parent element(s)
     */
    setLoadDataTarget(v){
        app.ui.common.loadDataTarget = v;
    },

    /**
     * @function
     * @name loadFromObject_postprocessor
     * @param {*} key the property name from the object
     * @param {*} val the property value from the object
     * @param {jQuery|HTMLElement} elem the element(s) found to match the property name, if any.
     * a function called after a property value has been considered by loadFromObject
     */

    /**
     * Auto-loads property values from an object into corresponding DOM elements.
     *
     * Elements must be a form control (input,textbox,select) or text element (div,span,label) with either an ID or NAME attribute matching the object keys (property names).
     *
     *
     * This method also calls {@link loadRadiosFromObject} to ensure radio values are updated.
     *
     * Makes use of the custom jQuery method {@link jQuery.fn.selectOption} when encountering a matching Select element.
     *
     *
     * Note: elements will be filled anywhere in the body unless a 'data target' is set with {@link setLoadDataTarget}.
     *
     * @param object The object containing the properties
     * @param idPrefix a prefix to prepend onto object keys before filling elements.
     * @param onlyEmptyInputs whether to only allow filling "empty" elements (if the element has a null or blank value or is an unchecked checkbox)
     * @param {loadFromObject_postprocessor|null} postProcessor
     * @param allowAppendingOptions whether new option values may be appended to Select elements when they do not exist.
     * @param allowDisabledOption whether to allow selecting 'disabled' option values on Select elements.
     * @param allowPlaceholderOnNull whether to select a 'placeholder-value' option when the property value is Null (for Select elements)
     * @param allowPlaceholderOnBlank whether to select a 'placeholder-value' option when the property value is Blank (for Select elements)
     */
    loadFromObject:function(object, idPrefix = "", onlyEmptyInputs = false, postProcessor = null, allowAppendingOptions = false,allowDisabledOption=false,allowPlaceholderOnNull=true,allowPlaceholderOnBlank=false) {
//    console.log("loadFromObject",object);
        let target = app.ui.common.loadDataTarget!==null ? $(app.ui.common.loadDataTarget) : $('body');
        app.ui.common.loadRadiosFromObject(object, idPrefix);
        $.each(object, function (key, val) {
            if (key === "") return;
            let escapedKey = $.escapeSelector(idPrefix + key);
            let elem = target.find("#" + escapedKey)
            if (elem.length === 0) {
                elem = target.find('*[name="' + escapedKey + '"]');
                //if (elem.length !== 0) console.log(" deferred to named element instead of id", escapedKey);
            }
            if (elem.length === 0) {
                return console.warn(" no matching single field for " + escapedKey);
            }
//            console.log(" loadFromObject:prop",key,escapedKey,""+escapedKey,elem,val);

            let tagname = elem.prop("tagName");
            let isDateInput = (tagname === "INPUT" && elem[0].type.toLowerCase() === "date");
            let isTimeInput = (tagname === "INPUT" && elem[0].type.toLowerCase() === "time");
            let isDTField = (escapedKey.toLowerCase().includes("date") || escapedKey.toLowerCase().includes("time"));



            //console.log(" loaded json value  "+escapedKey+" => ",val," | ",elem)

            let date_parts = [null, null];

            if (isDTField || isDateInput || isTimeInput) {
                date_parts = app.util.datetime.split(val);//getDatetimeParts(val);
//                console.log("  split date parts",val,date_parts,date_parts[0],date_parts[1])
            }

            let canSetValues = true;
            if (onlyEmptyInputs) {
                let empty = elem.is(':checkbox') ? !elem.prop('checked') : (elem.val() === null || elem.val().length === 0);
                canSetValues = empty;
            }

            if (canSetValues) {

                if (tagname === "INPUT" && elem[0].type.toLowerCase() === "radio") { //if we are told to add nonexistent select values in
                    //console.log("RADIO OPTION - skip (should be handled by radio value loader)");
                    return;
                }
/*
                if (tagname === "SELECT" && allowAppendingOptions) { //if we are told to add nonexistent select values in
                    let exists = false;
                    if(val===null) val="";//select options don't support null
                    elem.find('option').each(function () { //make sure the value doesn't exist
                        console.log("loadvalues select comparing",escapedKey,this.value,'to',"" + val,("" + this.value) === ("" + val))
                        if (("" + this.value) === ("" + val)) exists = true;
                    });
                    console.log("SELECT OPTION ", key, exists, val, elem);
                    let disp = (val===null || val==="") ? '(empty)' : val;
                    if (!exists) elem.append($('<option>').addClass('appended-option loaded-value').val(val).text(disp)); //append it - don't break so that we still select it with val(...)
                }

 */

                if (isTimeInput) { //Time: limit to time. Also FIXED: time input won't submit / complains of validation error with seconds from loaded data.
                    let timeparts = (date_parts[1] + ":00:00").split(":");
                    val = timeparts[0] + ":" + timeparts[1]; //for whatever reason, the inputs don't like Seconds in the field.
                }
                if (isDateInput) { //Date: limit to date
//                    console.log("  datefield ", tagname, elem[0].type, val, date_parts, elem, key);
                    val = date_parts[0];
                }

                if(tagname === "SELECT"){
                    elem.selectOption(val,allowAppendingOptions,allowDisabledOption,allowPlaceholderOnNull,allowPlaceholderOnBlank);
                } else if (tagname === "SPAN" || tagname === "DIV" || tagname === "TD" || tagname === "LABEL") {
//                    console.log("  setting text elem", tagname, elem, val)
                    elem.text(val);
                } else if (elem.is(':checkbox')) {
                    if (val === 1 || val === "1" || val === true || ("" + val).toLowerCase() === "true") elem.prop('checked', true);
                    else elem.prop('checked', false);
                } else {
//                    console.log("  set ", key, val, elem);

                    if(elem.hasClass('format-currency')){
                        elem.finVal(val);
                    }else{
                        elem.tval(val);
                    }

                }
                if (postProcessor !== null) postProcessor(key, val, elem);
            }
        });
//        console.log("Loaded fields from json")
    },

    setEditMode:function(formid, state = true, callback = null, readonlyPlaceholder = "(empty)") {
        app.ui.event.fire("form:editmode-change", {form: formid, state: state});
        let formid_s = $.escapeSelector(formid);
        let form = $("#" + formid_s);

        form.addClass('ui-editmode-' + (state ? 'enabled' : 'disabled'));
        form.removeClass('ui-editmode-' + (!state ? 'enabled' : 'disabled'));

        var ui_current_editmode = form.data('editmode');
        if (typeof ui_current_editmode === "undefined") ui_current_editmode = true;


        if (state === ui_current_editmode) return;
        //console.log("new ui editmode", state);
        ui_current_editmode = state;
        form.data('editmode', ui_current_editmode);


        var readOnly = true;
        var classAdd = "dummy-class-readonly"; //form-control-plaintext
        var classRemove = "dummy-class-editable"; //form-control
        if (state) {
            [classAdd, classRemove] = [classRemove, classAdd];
            readOnly = false;
        }
        //console.log(classAdd,classRemove,readOnly);
        //console.log("#"+formid_s+" input, #"+formid_s+" select")
        $("#" + formid_s + " input,#" + formid_s + " select,#" + formid_s + " textarea").prop("readonly", readOnly); //switch whether inputs are editable

        $("#" + formid_s + " input,#" + formid_s + " select,#" + formid_s + " textarea").each(function () {
            if ($(this).is(":checkbox") || $(this).is("select")) {
                $(this).prop('disabled', readOnly);
            } else {
                $(this).addClass(classAdd); //change visual indication of editable state with bootstrap
                //      console.log("  ","removing ",classRemove," from ",this,$(this).hasClass(classRemove),this.classList)
                $(this).removeClass(classRemove);
                //      console.log("  ",$(this).hasClass(classRemove))
            }
        });
        if (state) { //if going editable, restore placeholders (input hints) from saved data
            $("#" + formid_s + " input,#" + formid_s + " textarea").each(function () {
                var savedPlaceholder = $(this).data('placeholder');
                $(this).attr('placeholder', savedPlaceholder);
            });
        } else { //if going readonly, save placeholders to data and show empty indicator instead of input hints
            $("#" + formid_s + " input,#" + formid_s + " textarea").each(function () {
                var savePlaceholder = $(this).attr('placeholder');
                $(this).data('placeholder', savePlaceholder);
                $(this).attr('placeholder', readonlyPlaceholder); //show indication that field is empty rather than an input hint.
            });
        }
        if (callback !== null) callback(state)

        app.ui.event.fire("form:editmode-changed", {form: formid, state: state});
    }

};
app.util = {

    formatIdentifierName(str){
        str = str.replaceAll('_',' ')
        return app.util.capitalizeFirstChar(str);
    },
    capitalizeFirstChar(str){
        let first = str.substr(0,1);
        let rest = str.substr(1);
        return first.toUpperCase()+rest;
    },


    objectPropertiesEqual(obj1,obj2){
        let keys1 = Object.keys(obj1);
        let keys2 = Object.keys(obj2);
        if(keys1.length!==keys2.length) return false;
        for(let key of keys1){
            if(obj1[key]!==obj2[key]) return false;
        }
        return true;
    },

    delayPromise:async function(delay){
        return await app.util.setTimeoutPromise(function(){},delay);
    },
    setTimeoutPromise: async function(fn,delay){
        return new Promise((resolve)=>{
            setTimeout(()=>{
                fn();
                resolve(delay);
            },delay);
        });
    },
    setTimeoutPromiseEx: async function(fn,delay){
        return new Promise((resolve,reject)=>{
            setTimeout(()=>{
                fn(resolve,reject);
            },delay);
        });
    },
    waitForProperty(object,propertyName,checkInterval=250,allowNull=true){
        return new Promise((resolve)=>{
            let checkfn = function(){
                if(typeof object[propertyName]==='undefined' || (!allowNull && object[propertyName]===null)){
                    setTimeout(checkfn,checkInterval);
                }else{
                    resolve(object[propertyName]);
                }
            };
            checkfn();
        })
    },

    /**
     * @param {string} delimiter
     * @param {?string|?string[]} args
     */
    joinNotEmpty:function(delimiter,...args){
        if(args.length===1 && Array.isArray(args[0])) args=args[0];
        let aargs = Array.prototype.slice.call(args); //arguments object doesn't support a full implementation of .join with separator, but Array does.


        //console.log("joinNotEmpty",delimiter,args,aargs);
        let ret = aargs.filter(Boolean).join(delimiter); //join with delimiter only if necessary
        //console.log('joinNotEmpty ret',ret, ['x','y'].join('T'), args.join('T'), ""+delimiter, ['X','Y'].join(delimiter), typeof args);
        return ret;
    },
    escapeHtmlJQ:function(str){
        if(window.jQuery) return $('<div>').text(str).html();
        return 'error';
    },
    escapeRegExp: function (string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    },
    escapeWildcardAsRegex: function (string) {
        return string.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replaceAll(/[*]/g, '.*?'); // $& means the whole matched string
    },
    setCookie: function (name, value, exdate) {
        //If exdate exists then pass it as a new Date and convert to UTC format
        (exdate) && (exdate = new Date(exdate).toUTCString());
        var c_value = escape(value) + ((exdate === null || exdate === undefined) ? "" : "; expires=" + exdate + "; SameSite=Strict");
        document.cookie = name + "=" + c_value;
    },
    getCookie: function (name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    },
    isNumeric: function (str) {
        if (typeof str != "string") return false // we only process strings!
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
            !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
    },

    isIntegerString: function (str, requireUnsigned = false) {
        return app.util.isNumeric(str) && str.indexOf('.') === -1 && (!requireUnsigned || str.indexOf('-') === -1);
    },
    autoConvertFromString: function (value) {
        if (value === "true") value = true;
        if (value === "false") value = false;
        if (app.util.isIntegerString(value)) value = +value;
        return value;
    },

    finance: {
        format: function (value) {
            let formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',

                // These options are needed to round to whole numbers if that's what you want.
                //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
                //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
            });
            return formatter.format(value);
        },
        stripSymbols: function (str) {
            return str.replaceAll('$', '').replaceAll(',', '');
        },
        addSymbols: function (value,commas=true) {
            value = app.util.finance.stripSymbols("" + value);
            let formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',

                // These options are needed to round to whole numbers if that's what you want.
                //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
                //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
            });
            let newvalue = formatter.format(value);
            if(!commas) newvalue = newvalue.replaceAll(',', '');
            return newvalue;
        }
    },

    datetime: {
        toLocalISOString:function(d){
            if(d==='now') d=new Date();
            d = d.getTime();
            let tz_off = (new Date()).getTimezoneOffset()*60000;
            return (new Date(d-tz_off)).toISOString().slice(0,-1);
        },
        toIsoDatePart:function(datepart,local=false){
            if(datepart==='now'){
                datepart = Date.now();
            } else if(datepart.length==="20210101".length && !isNaN(Number(datepart))){
                //console.log(" splitting concatenated datetime value (all-digits)")
                datepart = datepart.substr(0,4)+"-"+datepart.substr(4,2)+"-"+datepart.substr(6,2);
            }
            let d = new Date(datepart);
            if(d.toString()==="Invalid Date") return null;
            return (local ? this.toLocalISOString(d) : d.toISOString()).substr(0,"1996-08-30".length);
        },


        /**
         * Split a datetime (or date or time) string into date and time parts
         * @param str
         * @param toIso force the output date to be in YYYY-mm-dd format
         * @returns {string[]|*[]} [year-month-day|null , hour:minute[:second]|null]
         */
        split: function (str,toIso=true,isoToLocal=false) {
            str = "" + str;
            let parts = [null,null];
            if (str.indexOf(' ') !== -1) {
                parts = str.split(' ');
            }else{
                if (str.includes(":")) parts=[null, str];
                if (str.includes("-") || str.includes("/")) parts=[str, null];

            }
            if(toIso && parts[0]!==null){
                parts[0] = app.util.datetime.toIsoDatePart(parts[0]+" 00:00",isoToLocal);
            }
            return parts;
        },

        toLocaleStringPart(datetime,type=0,defaultValue=null,fixTimezone=false){
            let parts = app.util.datetime.toLocaleString(datetime,null,fixTimezone);
            if(parts===null) return defaultValue;
            return parts[type]?? defaultValue;
        },

        /**
         * Get a locale string version of a date value
         * @param datetime
         * @param {*} [defaultValue] the value returned if the input date was invalid / could not be interpreted.
         * @param {boolean|string} fixTimezone Whether to attempt to avoid timezone changes which may shift the displayed date. If this is enabled, the timezone 'UTC' is used for conversion.  If this is a string, that value will be used as the timezone.
         * @returns {string[]|*} [localedatestring, localetimestring]
         */
        toLocaleString(datetime,defaultValue=null,fixTimezone=false) { //1988-09-01 00:00:00.000 causes an error - need to split and add a T in between:  new Date('1988-09-01T00:00:00.000')
            //console.log("datetime.toLocaleString",datetime,defaultValue)
            datetime = ""+datetime;
            if(datetime.length==="20210101".length && /^[0-9]+$/.test(datetime)){
                //console.log(" splitting concatenated datetime value (all-digits)")
                datetime = datetime.substr(0,4)+"-"+datetime.substr(4,2)+"-"+datetime.substr(6,2);
            }
            let parts = app.util.datetime.split(datetime);
            if(parts[0]!==null || parts[1]!==null) datetime = app.util.joinNotEmpty('T',parts);
            //console.log(" rejoined",datetime,parts)



            if(datetime===null) return ['',''];
            let d = new Date(datetime);
            if(d.toString()==="Invalid Date" && /^[0-9]+$/.test(datetime)){
                //console.log(" reinterpreted as number (timestamp)");
                d = new Date(+datetime);//date accepts timestamps... but only as numbers.
            }else{

                //console.log(" did not reinterpret as number");
            }

            //console.log(" interpreted as date",datetime,d);
            let locale = 'en-US';
            let tz = 'UTC';
            let optionsD = {};
            let optionsT = {timeStyle: 'short'};
            if(typeof fixTimezone==="string") tz = fixTimezone;
            if(fixTimezone===true){
                optionsD['timeZone'] = tz;
                optionsT['timeZone'] = tz;
            }


            let time = [d.toLocaleDateString('en-US',optionsD), d.toLocaleTimeString('en-US', optionsT).replace(' ', "\xA0")];

            if(d.toString()==="Invalid Date" || time[0]==="Invalid Date" || time[1]==="Invalid Date"){
                //console.log(" Invalid date",time,d,datetime);
                return defaultValue;
            }
            return time;
        },
        /**
         * Create date and time parts from a provided date value
         * @param date
         * @returns {[string, string, string]} [year-month-day,hour:minute:second,hour:minute]
         */
        parts: function (date = null) {

            let date2;
            if (date === null) date2 = new Date();
            else date2 = new Date(date);
            let year = "" + date2.getFullYear();
            let month = "" + (date2.getMonth() + 1);
            let day = "" + date2.getDate();

            let hour = "" + date2.getHours();
            let minute = "" + date2.getMinutes();
            let second = "" + date2.getSeconds();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            if (hour.length < 2) hour = "0" + hour;
            if (minute.length < 2) minute = "0" + minute;
            if (second.length < 2) second = "0" + second;


            return [[year, month, day].join('-'), [hour, minute, second].join(':'), [hour, minute].join(':')];
        },
        fromUnixTS: function (unix_timestamp) {
            let localedt = app.util.datetime.toLocaleString(unix_timestamp * 1000,null,true);
            return localedt[0] + ' ' + localedt[1];
        },

        localDateFromString: function (ds, todayIn = null) {
            let parts = ds.split('\-')
            let today;
            if (todayIn == null) today = new Date();
            else today = new Date(todayIn.getTime());
            today.setFullYear(parseInt(parts[0]));
            today.setMonth(parseInt(parts[1]) - 1);
            today.setDate(parseInt(parts[2]));
            return today;
        },

        age: function (d1, d2 = null) {
            if (d2 === null) d2 = new Date();
            //we can't just use difference divided by 365 because of leap-years
            var y1 = d1.getFullYear();
            var y2 = d2.getFullYear();
            var ydiff = y2 - y1; //can't stop here because we may not have reached the correct month/day yet
//            console.log(ydiff, y1, y2, d1, d2)

            d1.setFullYear(d2.getFullYear()); //set the dates to the same year so now we're only comparing dates within the year
            if (d2 < d1 && ydiff > 0) return ydiff - 1; //they haven't reached the same date of the given year yet
            return ydiff;
        }
    },

    file: {
        /**
         *
         * @param {number} size
         * @param {"SI"|"IEC"} system
         * @returns {string}
         */
        getSizeString: function (size, system = "IEC") { //if you want base 1024 (IEC) instead of 1000 (SI), then you need GiB,MiB,KiB suffix and use powers of 2
            size = +size;

            let baseValue = 1000;
            let baseSuffix = "B";
            let basePrefixes = ["K", "M", "G"];
            let units = [];
            switch (system) {
                case "IEC":
                    baseValue = 1024;
                    baseSuffix = "iB"
                    break;
                case "SI":
                    baseValue = 1000;
                    break;
            }

            for (let i = 0; i < basePrefixes.length; i++) {
                units.push({
                    unit: basePrefixes[i] + baseSuffix,
                    base: baseValue,
                });
                baseValue *= baseValue;
            }


            //console.log("checking size",units.length);
            for (let i = units.length - 1; i >= 0; i--) {
                let base = units[i].base;
                let unit = units[i].unit;
                //console.log("checking size",size,base,unit);
                if (size > base) return (size / base).toFixed(2) + " " + unit;
            }
            return size + " B";

        }
    },
};
app.util.color = {
    toRgb(str){
        if(str.startsWith('rgb')) return this.rgbStringToRgb(str); //handle RGB strings that were produced from setOpacity and fromRgb
        return this.hexToRgb(this.toHex(str));
    },
    flatten(str,strBase='white'){
        let rgb = this.toRgb(str);
        let newrgb = this.flattenRgb(rgb,strBase);
        return this.fromRgb(newrgb);
    },
    flattenRgb(rgb,strBase='white'){
        let base = this.toRgb(strBase);
        let alpha = rgb.a??1.0;
        if(alpha===1.0) return rgb;//rgb is already flattened.
        let amt_fg = alpha;
        let amt_bg = 1.0 - alpha;

        return {
            r: rgb.r * amt_fg + base.r*amt_bg,
            g: rgb.g * amt_fg + base.g*amt_bg,
            b: rgb.b * amt_fg + base.b*amt_bg,
            a: 1.0
        }
    },
    blendRgb(baseRgb,rgb){
        let base = baseRgb;
        base.a = base.a??1.0;
        rgb.a = rgb.a??1.0;
        if(rgb.a===1.0) return rgb;//forground color take precedence

        let alpha = 1 - (1 - rgb.a) * (1 - base.a); //final alpha of the mixed color.
        let amt_fg = rgb.a / alpha; //foreground color amount to use (scaled by the final alpha)
        let amt_bg = base.a * (1 - rgb.a) / alpha; //background color amount to use.  The remaining amount from amt_fg reduced further by the provided background opacity.

        return {
            r: rgb.r * amt_fg + base.r*amt_bg,
            g: rgb.g * amt_fg + base.g*amt_bg,
            b: rgb.b * amt_fg + base.b*amt_bg,
            a: alpha
        }
    },
    rgbStringToRgb(str){
        //strip off prefix
        if(str.startsWith('rgba')) str=str.substr(4);
        else str=str.substr(3);

        str = str.substr(1,str.length-2);//strip off ( and )
        let parts = str.replaceAll(/\s+/g,'').split(',');

        return {
            r:+parts[0],
            g:+parts[1],
            b:+parts[2],
            a:+(parts[3]??1.0)
        };
    },
    convertColorString(str){
        var ctx = document.createElement("canvas").getContext("2d");
        ctx.fillStyle = str;
        return ctx.fillStyle;
    },
    toHex(str){
        let standard = this.convertColorString(str);//either hex or rgb/rgba.
        if(!str.startsWith('rgb')) return standard;
        let rgb = this.rgbStringToRgb(rgb);
        return this.rgbToHex(rgb);
    },
    rgbToHex(rgb){
        let alphaAsByte = Number((rgb.a??1.0)*255.0).toFixed(0) ;
        let hrgb={
            r: Number(rgb.r).toString(16),
            g: Number(rgb.g).toString(16),
            b: Number(rgb.b).toString(16),
            a: Number(alphaAsByte).toString(16),
        }
        return '#'+hrgb.r.padStart(2,'0') + hrgb.g.padStart(2,'0') + hrgb.b.padStart(2,'0') + hrgb.a.padStart(2,'0');
    },
    hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(hex);
        //console.log("HEX MATCHES",result);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
            a: (parseInt(result[4]??'ff', 16)/255),
        } : null;
    },
    fromRgb(rgb){
        return 'rgba('+rgb.r+","+rgb.g+","+rgb.b+","+(rgb.a??1.0)+")";
    },
    setOpacity(str,opacity){
        let rgb = this.toRgb(str);
        if(rgb===null) throw "color cannot be converted to RGB: "+str;
        rgb.a = opacity;
        return this.fromRgb(rgb);
    }
};

app.util.csv = {
    /**
     *
     * @param {string} str
     * @returns {string}
     */
    quoteValue:function(str){
        str = str.replaceAll("\u00A0",' ');
        str = str.replaceAll('"','""');//"If double-quotes are used to enclose fields, then a double-quote appearing inside a field must be escaped by preceding it with another double quote."
        str = '"'+str+'"';
        return str;
    },

    /**
     *
     * @param {string[]} arr
     */
    rowFromStringArray:function(arr){
        let values=[];
        for(let value of arr){
            values.push( app.util.csv.quoteValue(""+value) );
        }
        return values.join(',');
    },

    /**
     *
     * @param {string[][]} arr
     * @return string
     */
    fromArray2D:function(arr){
        let rowTexts = [];
        for(let rowValues of arr){
            rowTexts.push(app.util.csv.rowFromStringArray(rowValues));
        }
        return rowTexts.join("\r\n");
    },

    /**
     *
     * @param {HTMLElement|jQuery} tableElem
     * @returns {string[][]}
     */
    collectArray2DFromTable:function(tableElem,cellType='td'){
        tableElem = $(tableElem);
        let rows = tableElem.children('tr');
        let tableRows = [];
        rows.each(function(){
            let csvRowReplacement = $(this).data('csv-cells');
            if(typeof csvRowReplacement!=='undefined'){
                tableRows.push(csvRowReplacement);
                return;
            }

            let cells = $(this).children($.escapeSelector(cellType)+':visible').not('.no-print').not('.tool-box').not('.no-export');
            let rowCells = [];
            cells.each(function(){
                let csvCellReplacement = $(this).data('csv-value');
                if(typeof csvCellReplacement!=='undefined'){
                    if(Array.isArray(csvCellReplacement)) rowCells.push(...csvCellReplacement)
                    else rowCells.push(csvCellReplacement);
                    return;
                }
                let cellText = $(this).text().trim();
                let cellChildren = $(this).children();
                if(cellText==="" && cellChildren.length===1){
                    if($(cellChildren).prop('tagName')==='INPUT' && $(cellChildren).prop('type')==='checkbox'){
                        cellText = $(cellChildren).is(':checked') ? 'Y' : 'N';
                    }
                }
                rowCells.push( cellText );
            })
            tableRows.push(rowCells);
        });
        return tableRows;
    },

    /**
     *
     * @param {HTMLElement|jQuery} tableElem
     * @returns {string}
     */
    fromTable:function(tableElem,cellType='td'){
        let arr2d = app.util.csv.collectArray2DFromTable(tableElem,cellType);
        return app.util.csv.fromArray2D(arr2d);
    },

    /**
     *
     * @param {string} csv
     */
    toDataURI:function(csv){
        let proto = 'data';
        let contentType = 'text/csv';
        let charset = 'utf-8';
        return proto+':'+contentType+';'+'charset='+charset+','+encodeURIComponent(csv);
    },

    /**
     *
     * @param {string} csv
     * @param {string} filename
     * @param {string|null} text
     */
    toDownloadLink(csv,filename="export.csv",text=null){
        if(!filename.toLowerCase().endsWith('.csv')) filename+='.csv';
        if(text===null) text = filename;
        let link = $('<a>').attr('href',app.util.csv.toDataURI(csv)).attr('download',filename).text(text);
        return link;
    },

    /**
     * Triggers a download of a CSV file from the provided data.
     * Note: browser security only allows this from a user-generated event (eg: clicking a link).
     * @param {string} csv
     * @param {string} filename
     */
    triggerDownload(csv,filename="export.csv"){
        let link = app.util.csv.toDownloadLink(csv,filename);
        let id = ('csvdownloadtemp'+Math.random()).replace('.','_');
        link.attr('id',id);

        link.click(function(){
            setTimeout(function(){
                link.remove();
            },10000);
        });
        $('body').append(link);



        setTimeout(function(){
            let bodyElem = $('#'+id);
            //console.log(id,bodyElem);
            bodyElem.click();
            bodyElem[0].click();
            bodyElem.trigger('click');
        },500);






    }
};


class Currency{
    static prefix = '$';
    static integerBound = Number.MAX_SAFE_INTEGER;//maximum JS safe integer.  ~~ is a 32-bit operation so this would be Math.pow(2,32)/2-1;
    static dollarsBound = Math.trunc(Currency.integerBound/100);
    static centsBound = Currency.integerBound-1;


    [Symbol.toPrimitive](hint) {
        if (hint === 'number') {
            return this.cents;
        }
        //if (hint === 'string') {
        return this.toString();
        //}
        return null;
    }


    static zero(){
        return new Currency(0);
    }

    /**
     *
     * @param {Currency} currencySum
     * @param {Currency} currencyValue
     * @returns {Currency}
     */
    static accumulateSum(currencySum,currencyValue){
        return currencySum.add(currencyValue);
    }
    /**
     * Sums a list of currency values
     * @param {Currency[]|string[]} currencyValues
     * @returns {Currency}
     */
    static sumOf(currencyValues){
        return currencyValues.map((v)=>Currency._from(v)).reduce(Currency.accumulateSum,Currency.zero());
    }

    /**
     * Converts a list of quantities into currency values, assuming each item is priced at this currency value.
     * @param {int[]} amounts quantities of items
     */
    mulAmounts(amounts){
        return amounts.map((quantity)=>this.mulAmount(quantity));
    }


    constructor(cents) {
        if(typeof cents==='string') throw "Currency must be constructed with a number of cents, not a string.";
        if(Math.trunc(cents)!==+cents) throw "Currency must be constructed with a whole number of cents: "+cents;

        if( (+cents) > Currency.centsBound){
            console.trace();
            throw "Currency value is too large to safely calculate using this class: "+cents+" > "+Currency.centsBound;
        }
        this.cents = +cents;
    }
    static convertCentsToDollarsFloat(cents){
        return (new Currency(cents)).getDollarsFloat();
    }
    static convertCentsToDollarsString(cents){
        return (new Currency(cents)).toString();
    }
    /** Gets cents counts as a 0-padded string.
     *
     * For example: 2 becomes "02"
     * @param {int|string} cents a count of the number of cents.
     */
    static getCentCountAsString(cents){
        return (""+cents).padStart(2,'0').substr(0,2)
    }
    /** Pads a cents partial string from after the decimal.
     *
     * For example: "2" from "3.2" becomes "20"
     * @param {string} centpart a string part of everything after the decimal point.
     * */
    static getCentPartAsString(centpart){
        return (""+centpart).padEnd(2,'0').substr(0,2)
    }
    getWholeDollars(){
        return Math.trunc(this.cents/100);
    }
    /** gets the cents part of the currency value */
    getCents(){
        return this.cents%100;
    }
    /** Gets the cents part of the currency value as a 0-prefixed string */
    getCentsString(){
        return Currency.getCentCountAsString(this.getCents());
    }
    /** gets the currency value fully represented as cents */
    getTotalCents(){
        return this.cents;
    }
    /** @param {int} cents */
    setTotalCents(cents){
        return this.cents = cents;
    }
    /** converts the currency value to a floating point value. Performing math with this value may introduce inaccuracy */
    getDollarsFloat(){
        return this.cents/100;
    }
    /** converts a dollar value string like "3.24" to a currency object */
    static fromString(str){
        str = ""+str;//force str to be a string.
        str = str.trim();//extraneous spaces before/after value.
        if(str.startsWith(Currency.prefix)) str = str.substr(Currency.prefix.length);//$
        str = str.trim();//internal spaces - necessary because some formats look like "$ 3.00"
        let parts = (str+".00").split('.');
        let dollars = +(parts[0]);
        let cents = +Currency.getCentPartAsString(parts[1]);// ".2" means 20 cents, not 2.  ".02" means 2 cents

        if( dollars > Currency.dollarsBound) throw "Dollar amount is too large to safely calculate using this class: "+dollars+" > "+Currency.dollarsBound;

        let totalCents = cents + dollars*100;
        return new Currency(totalCents);
    }

    /**
     * Retrieve a currency value from an element on the page.
     *
     * This method assumes the value should be interpreted as a string in the format of dollars (eg: 3.50)
     *
     * If the final retrieved value is null or undefined, an exception will be thrown.
     *
     * By setting `defaultValue` to null, you can force missing elements/missing values to throw an exception.
     *
     * By setting `blankValue` to null (in addition to defaultValue), you can force blank values to throw an exception.
     *
     * @param {string|jQuery|HTMLElement} selector the selector or element to retrieve the value from
     * @param {string|jQuery|HTMLElement} searchElement the optional parent selector or parent element to search for the child element within
     * @param {string|Number} defaultValue the value to use is there is no value available from the element (not including blank)
     * @param {string|Number} blankValue the value to use when the value from the element was blank
     * @returns {Currency}
     */
    static fromSelector(selector,searchElement=null,defaultValue="0.00",blankValue="0.00"){
        let elem = searchElement===null ? $(selector) : $(searchElement??document.body).find(selector);
        let value = null;

        if(elem.length) value = elem.tval();

        if(typeof value === 'undefined' || value===null) value=defaultValue;
        else value = (""+value).trim();

        if(value==="") value=blankValue;

        if(typeof value === 'undefined' || value===null){
            throw "Could not retrieve a currency value from that selector: "+selector;
        }

        return Currency.fromString($(searchElement??document.body).find(selector).tval());
    }
    /**
     * Sets the value or text of an element to the dollars-string representation of the currency value (eg: 3.50)
     * @param {string|jQuery|HTMLElement} selector the selector or element to retrieve the value from
     * @param {string|jQuery|HTMLElement} searchElement the optional parent selector or parent element to search for the child element within
     */
    toSelector(selector,searchElement=null){
        $(searchElement??document.body).find(selector).tval(this.toString());
    }

    /**
     *
     * @param {int} dollars
     * @param {int} cents
     * @returns {Currency}
     */
    static fromDollars(dollars,cents=0){
        if(Math.trunc(dollars)!==+dollars) throw "Dollars must be an integer value";
        if(Math.trunc(cents)!==+cents) throw "Cents must be an integer value";
        if( (+dollars) > Currency.dollarsBound) throw "Dollar amount is too large to safely calculate using this class: "+dollars+" > "+Currency.dollarsBound;
        return new Currency(dollars*100 + cents);
    }
    /** @private
     * @returns Currency */
    static _from(value,forceCopy=true){
        if(value instanceof Currency){
            if(forceCopy) return new Currency(value.cents);
            else return value;
        }
        if(typeof value === "string" || typeof value==="number") return Currency.fromString(value);
        throw "Unsupported type: "+(typeof value);
    }

    /** @param {int} cents */
    static fromCents(cents){
        return new Currency(cents);
    }
    toString(){
        return this.getWholeDollars()+"."+this.getCentsString();
    }
    toFloat(){
        return this.getDollarsFloat();
    }
    negate(){
        return new Currency(-this.cents);
    }
    negateSelf(){
        this.cents = -this.cents;
        return this;
    }
    add(currency2){
        currency2 = Currency._from(currency2,false);
        return new Currency(this.cents + currency2.cents);
    }
    /** Increment this currency value by another. This modifies the current object. */
    inc(currency2){
        currency2 = Currency._from(currency2,false);
        this.cents += currency2.cents;
        return this;
    }
    sub(currency2){
        currency2 = Currency._from(currency2,false);
        return new Currency(this.cents - currency2.cents);
    }
    /** Decrement this currency value by another. This modifies the current object. */
    dec(currency2){
        currency2 = Currency._from(currency2,false);
        this.cents -= currency2.cents;
        return this;
    }

    /**
     * Multiply this currency value against an amount.
     *
     * @param {int} amt a whole number quantity of the value to produce (like 3, 10, or 243)
     * @returns {Currency}
     */
    mulAmount(amt){
        if(Math.trunc(amt)!==+amt){
            console.trace(+amt,Math.trunc(amt));
            throw "Multiplication by floating point values will introduce floating point errors."
        }
        return new Currency(this.cents * amt);
    }
    /** Scales this currency value by an amount. This modifies the current object. */
    mulAmountSelf(amt){
        if(Math.trunc(amt)!==+amt){
            console.trace(+amt,Math.trunc(amt));
            throw "Multiplication by floating point values will introduce floating point errors."
        }
        this.cents *= +amt;
        return this;
    }
    divAmountAsFloat(amt){
        return this.cents/+amt;
    }
    divAmountAsInt(amt){
        return Math.trunc(this.cents/+amt);
    }



    /** multiply against another currency value */
    mul(currency2){
        currency2 = Currency._from(currency2,false);
        return new Currency(this.cents * currency2.cents);
    }
    mulSelf(currency2){
        currency2 = Currency._from(currency2,false);
        this.cents *= currency2.cents;
        return this;
    }
    /** @deprecated returns a currency value from the whole-number division */
    div(currency2){
        currency2 = Currency._from(currency2,false);
        return new Currency(Math.trunc(this.cents / currency2.cents));
    }
    addAsFloat(currency2){
        currency2 = Currency._from(currency2,false);
        return this.add(currency2).toFloat();
    }
    subAsFloat(currency2){
        currency2 = Currency._from(currency2,false);
        return this.sub(currency2).toFloat();
    }
    mulAsFloat(currency2){
        currency2 = Currency._from(currency2,false);
        return this.mul(currency2).toFloat();
    }
    divAsFloat(currency2){
        currency2 = Currency._from(currency2,false);
        return this.div(currency2).toFloat();
    }
    divCentsAsFloat(currency2){
        currency2 = Currency._from(currency2,false);
        return this.cents/currency2.cents;
    }
    divCentsAsInt(currency2){
        currency2 = Currency._from(currency2,false);
        return Math.trunc(this.cents/currency2.cents);
    }

    static fail(reason,...args){
        //console.log('Test arguments: ',...args.map((v)=>[typeof v,v]));
        throw reason + args.map((v)=>""+v).join(' ');
    }
    static test(){
        let fail = Currency.fail;
        for(let i=0;i<1000000;i++){
            let c = new Currency(i);
            let c2 = c.add(0.01);
            if(c2.cents!==(i+1)) throw "bad cents "+i;
        }
        for(let i=0;i<10000;i++){
            for(let j=0;j<100;j++){
                let s = i+"."+j;
                let c = Currency.fromString(s);
                if(c.toFloat() !== parseFloat(s)) fail("bad construction A ",s,c.cents);
                if(c.getCents() !== j) fail("bad construction B ",s,c.cents);
                if(c.getWholeDollars() !== i) fail("bad construction C ",s,c.cents);
                let c2 = new Currency(c.getCents());
                if(c.cents!==c2.cents) fail("bad construction D ",s,c.cents,c2.cents);
                let c3 = Currency.fromString(c.toString());
                if(c.cents!==c3.cents)  fail("bad construction E ",s,c.cents,c2.cents);
                let c4 = Currency.fromString(c.toFloat());
                if(c.cents!==c4.cents)  fail("bad construction F ",s,c.cents,c2.cents);

            }
        }
    }

}

app.util.currency=Currency;
app.util.grouping={

    /**
     * Groups an array of objects by property values.
     * These are stored as separate arrays, each one is stored as a property of the index_object.
     * In this way, the index_object will contain properties with keys of all distinct property values for the entries, each containing an array of corresponding entries.
     * @param {object[]} arr an array of objects
     * @param propName the name (key) of a property that exists in the objects
     * @param index_object the object in which to store the groupings
     * @param {boolean} store_original_index whether to set the 'original_index' property of each object to mark its position in the source array. (used for sorting). This will modify the objects.
     */
    groupObjectArrayByProperty(arr,propName,index_object={}, store_original_index=true){
        for(let i=0;i<arr.length;i++){
            this.groupEntryByProperty(arr[i], propName, index_object, store_original_index ? i : null);
        }
        return index_object
    },
    /**
     * Groups an object by a property value. (This method is intended to be used in a loop).
     * These are stored as separate arrays, each one is stored as a property of the index_object.
     * In this way, the index_object will contain properties with keys of all distinct property values for the entries, each containing an array of corresponding entries.
     * @param entry the
     * @param propName
     * @param index_object
     * @param original_index
     */
    groupEntryByProperty(entry,propName,index_object,original_index=null){
        if(original_index!==null) entry.original_index = original_index;
        let propValue = entry[propName];
        if(typeof index_object[propValue]==='undefined') index_object[propValue]=[];
        index_object[propValue].push(entry);
        return propValue;
    },
    cmpEntriesByOriginalIndex(a,b){
        return a.original_index - b.original_index;
    },
    sortByOriginalIndex(arr){
      arr.sort(this.cmpEntriesByOriginalIndex);
    },

    /**
     * Retrieves a single entry from each grouping in the index object, subject to filtering.
     * @param index_object the object containing grouped entries
     * @param groupFilter function which confirms or declines each grouping value (the original object's property value)
     */
    getRepresentativeEntries(index_object,groupFilter=function(){return true;}){ //
        let representatives = []
        for(let propValue of Object.keys(index_object)){
            if(!groupFilter(propValue)) continue;
            let entry = index_object[propValue][0];
            representatives.push(entry);
        }
        return representatives;
    }
}
/**
 * Wraps a promise with methods that conform with jQuery ajax methods (done, fail, always).
 * @param {Promise} promise
 * @returns {{always(*): void, fail(*): this, promise, done(*): this}|*}
 */
app.util.promise2ajax = function(promise){
    return {
        promise: promise,
        done(fn){
            let subpromise = this.promise.then(fn);
            return app.util.promise2ajax(subpromise);
        },
        fail(fn){
            let subpromise = this.promise.catch(fn);
            return app.util.promise2ajax(subpromise);
        },
        always(fn){
            let subpromise = this.promise.finally(fn);
            return app.util.promise2ajax(subpromise);
        }
    }
}

/**
 * Wraps a jQuery Ajax object a promise
 * @param {jQuery.jqXHR} ajax
 * @returns {Promise}
 */
app.util.ajax2promise = function(ajax){
    return new Promise((resolve,reject)=>{
        ajax.done(resolve).fail(reject);
    })
}


//IDE won't pull in documentation for this so...

/**
 * @typedef {object} jQuery.jqXHR
 * @property {function(function)} done
 * @property {function(function)} fail
 * @property {function(function)} always
 * @property {function(function)} then
 * @property {function(function)} success
 * @property {function(function)} error
 * @property {function(function)} complete
 */

/**
 * @method
 * @deprecated
 * @name jQuery.jqXHR#success
 * @param function
 */
/**
 * @method
 * @deprecated
 * @name jQuery.jqXHR#error
 * @param function
 */
/**
 * @method
 * @deprecated
 * @name jQuery.jqXHR#complete
 * @param function
 */
/**
 * Rough implementation of a tree-like structure with object keys ("object path")
 *
 * For a true Tree-Node implementation see {@link TreeNode}
 *
 */
app.util.tree={
    max_object_path_depth: 10,

    path:{
        getParts(path){
            return path.split('.');
        },
        getContainers(path, includeSelf=true){
            let parts = this.getParts(path);
            let paths = [];
            let currentPath = '';
            for(let part of parts){
                if(currentPath!=='') currentPath+='.';
                currentPath+=part;
                if(!includeSelf && currentPath===path) continue;
                paths.push(currentPath);
            }
            return paths;
        },
        getParent(path){
            let parts = this.getParts(path);
            parts.pop();
            return parts.join('.');
        }
    },

    getObjectPath(baseObject,namespace){
        let parts = this.path.getParts(namespace);
        let object = baseObject;
        do{
            let part = parts.shift();
            object = object[part]??null;
        }while(object!==null && parts.length>0)
        return object;
    },


    _addObjectAnnotations(object, namespace, identifier=null, hasChildren = null, addNamespace = null, required=null) {
        if (typeof object.namespace === "undefined")
            Object.defineProperty(object, 'namespace', {
                value: '',
                enumerable: false,
                writable: true,
            });
        if (typeof object.identifier === "undefined")
            Object.defineProperty(object, 'identifier', {
                value: '',
                enumerable: false,
                writable: true,
            });
        if (typeof object.namespaces === "undefined")
            Object.defineProperty(object, 'namespaces', {
                value: [],
                enumerable: false,
                writable: true,
            });
        if (typeof object.hasChildren === "undefined")
            Object.defineProperty(object, 'hasChildren', {
                value: false,
                enumerable: false,
                writable: true,
            });
        if (typeof object.required === "undefined")
            Object.defineProperty(object, 'required', {
                value: false,
                enumerable: false,
                writable: true,
            });
        if(namespace!==null) object.namespace = namespace;
        if(identifier!==null) object.identifier = identifier;
        if (hasChildren) object.hasChildren = hasChildren;
        if(required!==null) object.required=required;
        if (addNamespace !== null && !object.namespaces.includes(addNamespace)) object.namespaces.push(addNamespace);
    },
    _defineObjectPart(parentObject, parentnamespace,partnamespace, part, isLastPart, value, defaultObject, addAnnotations,required=false) {
        let exists = typeof parentObject[part] !== "undefined";

        if (exists) {
            //console.log(" assigning object namespace (def)", isLastPart);
            if (isLastPart) {//we're at the namespace we are setting the value for - BUT it's already defined!
                parentObject[part] = Object.assign(parentObject[part], value); //merge the passed object with this namespace!
            }
        } else {
            //console.log(" assigning object namespace (undef)", part);
            if (isLastPart) {//we're at the namespace we are setting the value for
                //console.log("  last - merging with input value", JSON.stringify(value), JSON.stringify(defaultObject));
                parentObject[part] = Object.assign(Object.assign({}, defaultObject), value); //assign passed object to this namespace
            } else {
                //console.log("  intermediate part - assigning default placeholder", JSON.stringify(defaultObject));
                parentObject[part] = Object.assign({}, defaultObject);//assign part of current parent
            }
        }
        if (addAnnotations){
            app.util.tree._addObjectAnnotations(parentObject, parentnamespace, null,true, part);
            app.util.tree._addObjectAnnotations(parentObject[part],partnamespace,part,null,required);
        }
        return parentObject[part];//move to next parent down
    },
    defineObjectPath: function (parentObject, namespace, value, defaultObject = {}, addAnnotations = true, required=false) {
        if (!/^[a-zA-Z0-9._]+$/g.test(namespace)) throw "Invalid object namespace: "+namespace;
        let parts = namespace.split(/\./);


        if (addAnnotations) app.util.tree._addObjectAnnotations(parentObject,'',null,null,null,required);

        //let parentObject = baseobject;
        //console.log("defineObjectPath", namespace, parentObject, JSON.stringify(value), JSON.stringify(defaultObject));
        let iLastPart = parts.length - 1;
        let parentnamespace = ''
        let currentnamespace='';
        for (let i = 0; i < parts.length; i++) {//traverse the namespaces down until we get to ours
            let part = parts[i];
            let isLastPart = i === iLastPart;

            //console.log(" defineObjectPath part ",part,parentnamespace,currentnamespace);
            parentObject = app.util.tree._defineObjectPart(parentObject,parentnamespace,currentnamespace, part, isLastPart, value, defaultObject, addAnnotations,(isLastPart && required) ? true : null);

            parentnamespace = currentnamespace; //go to child part
            if(currentnamespace.length) currentnamespace+='.';
            currentnamespace+=part;

        }
    },


    /**
     * Internal function - updates namespaces for the object paths of this object (if supplied) and all child objects
     * @param {AnnotatedPathObject} object
     * @param {?string} namespace namespace this object is in - to be set. if null is supplied, the namespace will not be changed
     * @param {null|string[]} namespaces sub-namespaces (keys) this object contains - to be set. If null, it is not modified
     * @param depth recursion depth
     * @private
     */
    _updateNamespaces:function(object,namespace=null,namespaces=null,depth=0){
        if(depth>app.util.tree.max_object_path_depth) throw "max object recursion depth reached";
        if(namespace!==null) object.namespace=namespace;
        if(namespaces!==null) object.namespaces=namespaces;
        for(let key of object.namespaces){
            app.util.tree._updateNamespaces(object[key],object.namespace+'.'+key,null,depth+1);
        }
    },

    /**
     * Forces all objects in the tree to have their child list ("namespaces") to be sorted by their children's order values.
     * @param object the parent object to start sorting at
     * @param depth the current depth
     */
    sortNamespaceOrdering(object,depth=0){
        if(depth>app.util.tree.max_object_path_depth) throw "max object recursion depth reached";
        object.namespaces.sort((a,b)=>{
            let aOrder = (object[a]??{}).order??null;
            let bOrder = (object[b]??{}).order??null;
            if(aOrder===bOrder) return 0;
            if(aOrder==null) return +1; //if A has null order, B goes first
            if(bOrder==null) return -1; //if B has null order, A goes first
            if(aOrder<bOrder) return -1;
            if(aOrder>bOrder) return +1;
            return 0;
        });
        for(let key of object.namespaces){
            app.util.tree.sortNamespaceOrdering(object[key],depth+1);
        }
    },

    /**
     * Replace intermediate object path nodes which only have a single child with the child  (eg: A->B->C  becomes A->C)
     * @param {AnnotatedPathObject} object
     * @param excludeDepth
     * @param useAnnotations
     * @param depth
     * @param {AnnotatedPathObject|null} parent
     * @param currentkey
     */

    //TODO: this [DID-past-tense - update comment please] swaps out a parent of a single object with the object.                  (A,...->B,...C->D  =>   A,...->B,...D)
    // INSTEAD(also?) we want to swap a single middle element with all of its children   (A,...->B->C,...D  =>   A,...->C,...D)
    // instead of checking if the node has a single child, it should check if it has no siblings at the same depth!
    /**
     * Replace intermediate object path nodes which only have a single sibling by adding their children to the parent  (eg: A->B->C  becomes A->C)
     * @param {AnnotatedPathObject} object
     * @param minimumSiblings minimum number of siblings [in the same namespace path] required to let this object path remain (to distinguish elements)
     * @param excludeDepth depth to exclude from condensing
     * @param useAnnotations
     * @param depth
     * @param {AnnotatedPathObject|null} parent
     * @param currentkey
     */
    condenseObjectPaths_siblinglessParents:function(object,minimumSiblings=1,excludeDepth=0,useAnnotations=true,depth=0,parent=null,currentkey=''){
        if(depth>app.util.tree.max_object_path_depth) throw "max object recursion depth reached";
        let keys = (useAnnotations ? object.namespaces.slice() : Object.keys(object)).slice();//note: copy keys so we don't have a reference that can be altered.

        let hasChildren = useAnnotations ?  object.hasChildren : Object.keys(object).length;//note: have to recalculate keys length because the recursion may modify it.
        if(!hasChildren) return;//don't process leaves directly.

        for(let key of keys){
            //if(useAnnotations) console.log(' '.repeat(depth+1),'IKEY',key,keys.slice());
            app.util.tree.condenseObjectPaths_siblinglessParents(object[key],minimumSiblings,excludeDepth,useAnnotations,depth+1, object,key);
            // if(useAnnotations) console.log(' '.repeat(depth+1),'OKEY',key,keys.slice());
        }

        //if(typeof parent.namespaces==='undefined'){
        //    console.log('condenseObjectPaths parent namespaces undef',object,'minsiblings',minimumSiblings,'excludedepth',excludeDepth,'useannot.',useAnnotations,'depth',depth,'parent',parent,'currentkey',currentkey);
        //}
        let siblings = (parent===null ? 0 : useAnnotations ? parent.namespaces.length : Object.keys(parent).length)-1;//number of siblings,  -1 if this is the top object


        keys = (useAnnotations ? object.namespaces : Object.keys(object)).slice();//have to recalculate this because it may have changed
        //hasChildren = useAnnotations ?  object.hasChildren : Object.keys(object).length;//have to recalculate this because it may have changed

        let isRequiredNode = useAnnotations ? object.required : false;

        let hasSingleChild = keys.length===1;
        let isExcluded = depth <= excludeDepth;
        let shouldBeReplaced = siblings>=0 && siblings<minimumSiblings/*hasSingleChild*/ && !isExcluded && !isRequiredNode;
        if(shouldBeReplaced && parent!=null){
            /*
            //code for replacing this node with a single child
            let childkey = keys[0];
            parent[childkey] = object[childkey]; //TODO: update annotation namespaces down the path.
            console.log("condensing object path",object,object.namespace,object.identifier,keys,'with single child object',childkey,object[childkey]);
            rcps.util._updateNamespaces(parent,null,[...parent.namespaces,childkey]);//add new child namespace and update all namespace strings of children
             */

            //remove current
            if(useAnnotations){
                let index = parent.namespaces.indexOf(currentkey);
                if(index!==-1) parent.namespaces.splice(index,1);
                parent.hasChildren = (parent.namespaces.length!==0);
            }
            delete parent[currentkey];

            //code for adding all children to parent
            for(let childkey of keys){
                parent[childkey] = object[childkey];
                if(useAnnotations) {
                    parent.namespaces.push(childkey);
                    parent.hasChildren = (parent.namespaces.length !== 0);
                }
            }
            app.util.tree._updateNamespaces(parent);//update all namespace strings of children

        }
    },
    /**
     * Replace intermediate object path nodes which only have a single sibling by adding their children to the parent  (eg: A->B->C  becomes A->C)
     * @param {AnnotatedPathObject} object
     * @param unused unused
     * @param excludeDepth depth to exclude from condensing
     * @param useAnnotations
     * @param depth
     * @param {AnnotatedPathObject|null} parent
     * @param currentkey
     */
    condenseObjectPaths_singleChildParents:function(object,unused=1,excludeDepth=0,useAnnotations=true,depth=0,parent=null,currentkey=''){
        if(depth>app.util.tree.max_object_path_depth) throw "max object recursion depth reached";
        let keys = (useAnnotations ? object.namespaces.slice() : Object.keys(object)).slice();//note: copy keys so we don't have a reference that can be altered.

        let hasChildren = useAnnotations ?  object.hasChildren : Object.keys(object).length;//note: have to recalculate keys length because the recursion may modify it.
        if(!hasChildren) return;//don't process leaves directly.

        for(let key of keys){
            //if(useAnnotations) console.log(' '.repeat(depth+1),'IKEY',key,keys.slice());
            app.util.tree.condenseObjectPaths_singleChildParents(object[key],unused,excludeDepth,useAnnotations,depth+1, object,key);
            // if(useAnnotations) console.log(' '.repeat(depth+1),'OKEY',key,keys.slice());
        }

        //if(typeof parent.namespaces==='undefined'){
        //    console.log('condenseObjectPaths parent namespaces undef',object,'minsiblings',minimumSiblings,'excludedepth',excludeDepth,'useannot.',useAnnotations,'depth',depth,'parent',parent,'currentkey',currentkey);
        //}
        //let siblings = (parent===null ? 0 : useAnnotations ? parent.namespaces.length : Object.keys(parent).length)-1;//number of siblings,  -1 if this is the top object


        keys = (useAnnotations ? object.namespaces : Object.keys(object)).slice();//have to recalculate this because it may have changed
        //hasChildren = useAnnotations ?  object.hasChildren : Object.keys(object).length;//have to recalculate this because it may have changed

        let isRequiredNode = useAnnotations ? object.required : false;

        let hasSingleChild = keys.length===1;
        let isExcluded = depth <= excludeDepth;
        let shouldBeReplaced = hasSingleChild && !isExcluded && !isRequiredNode;
        if(shouldBeReplaced && parent!=null){
            //remove current
            if(useAnnotations){
                let index = parent.namespaces.indexOf(currentkey);
                if(index!==-1) parent.namespaces.splice(index,1);
                parent.hasChildren = (parent.namespaces.length!==0);
            }
            delete parent[currentkey];

            //code for adding all children to parent
            for(let childkey of keys){
                parent[childkey] = object[childkey];
                if(useAnnotations) {
                    parent.namespaces.push(childkey);
                    parent.hasChildren = (parent.namespaces.length !== 0);
                }
            }
            app.util.tree._updateNamespaces(parent);//update all namespace strings of children

        }
    },

    /**
     *
     * @param {AnnotatedPathObject} object
     * @param {PathObjectLeafPruner} cb_canBePruned
     * @param {int} excludeDepth
     * @param {boolean} useAnnotations
     * @param {int} depth
     * @param {AnnotatedPathObject|null} parent
     * @param {string|null} currentkey
     */
    pruneObjectPaths: function(object,cb_canBePruned,excludeDepth=0,useAnnotations=true,depth=0, parent = null, currentkey=null){
        if(depth>app.util.tree.max_object_path_depth) throw "max object recursion depth reached";
        let keys = (useAnnotations ? object.namespaces : Object.keys(object)).slice();//note: copy keys so we don't have a reference that can be altered.

        //if(useAnnotations) console.log(' '.repeat(depth+1),'>pruneObjectPaths',object,object.namespace,currentkey,object.namespaces);

        for(let key of keys){
            //if(useAnnotations) console.log(' '.repeat(depth+1),'IKEY',key,keys.slice());
            app.util.tree.pruneObjectPaths(object[key],cb_canBePruned,excludeDepth,useAnnotations,depth+1, object,key);
            // if(useAnnotations) console.log(' '.repeat(depth+1),'OKEY',key,keys.slice());
        }
        let isRequiredNode = useAnnotations ? object.required : false;

        let hasChildren = useAnnotations ?  object.hasChildren : Object.keys(object).length;//note: have to recalculate keys length because the recursion may modify it.
        let isExcluded = depth <= excludeDepth;
        let shouldBePruned = !hasChildren && !isExcluded && !isRequiredNode;


        //if(useAnnotations) console.log(' '.repeat(depth+1),'<pruneObjectPaths',object,object.namespace,currentkey,hasChildren,isExcluded,shouldBePruned,parent);

        if(shouldBePruned && parent!=null){
            if(!cb_canBePruned(object,depth,parent,currentkey)) return; //we need another check for pruning, otherwise we would prune all leaves of the tree then the parents, etc... until nothing was left.  We need to exclude some leaves.
            if(useAnnotations){
                let index = parent.namespaces.indexOf(currentkey);
                if(index!==-1) parent.namespaces.splice(index,1);
                if(parent.namespaces.length===0) parent.hasChildren = false;
            }
            delete parent[currentkey];
        }
    },

    /**
     * @callback PathObjectLeafPruner
     * @param {AnnotatedPathObject} object
     * @param {int} depth
     * @param {AnnotatedPathObject} parent
     * @param {string} currentkey
     * @return {boolean} whether the leaf object should be pruned
     */

    /**
     * @typedef {object} AnnotatedPathObject
     * @property {string} namespace
     * @property {string} identifier
     * @property {string[]} namespaces
     * @property {boolean} hasChildren
     * @property {boolean} required
     * @property {AnnotatedPathObject} [any]
     */

    /**
     * @callback PathObjectCallback
     * @param {AnnotatedPathObject} value current object path being processed
     * @param {string} key the current namespace key being processed (without prefixed namespacing)
     * @param {null|AnnotatedPathObject} parent parent object of this object path, or null if the current object is a first-level key
     * @param {int} depth recursion/path depth (first level keys have a depth of 0)
     * @param {string} fullns the full namespace of the current key
     * @param {string} parentns the parent's full namespace of the current key
     */

    /**
     *
     * @param object
     * @param {PathObjectCallback} callback
     * @param {boolean} useAnnotatedOrder
     * @param {null|AnnotatedPathObject} parent
     * @param {int} depth
     * @param {string} parentns
     * @param {string} identifier
     */
    recurseObjectPaths:function(object,callback,useAnnotatedOrder=true,parent=null,depth=0,parentns="",identifier=""){
        if(object===null) return;
        if(depth>app.util.tree.max_object_path_depth) throw "max object recursion depth reached";
        let keys = [];

        if(useAnnotatedOrder){
            keys = object.namespaces;
            if(parentns==="") parentns = object.namespace;
            if(identifier==="") identifier = object.identifier;
        }
        else keys = Object.keys(object);

        //console.log(' keys ',keys);
        let fullns = [parentns,identifier].filter(Boolean).join("."); //join with delimiter only if necessary


        //console.log(" ".repeat(depth),"recurseObjectPaths",object,parent,depth,parentns,identifier,fullns);
        callback(object,identifier,parent,depth,fullns,parentns);

        parentns = fullns;
        for(let identifier of keys){
            let value = object[identifier];
            if(useAnnotatedOrder) identifier = value.identifier;
            //console.log(" ".repeat(depth+1),"key",identifier,parentns);
            app.util.tree.recurseObjectPaths(value,callback,useAnnotatedOrder,object,depth+1,parentns,identifier);
        }
    },
}
/**
 * @author trevor ozbun <trevor.ozbun@renogov.org>
 *
 */



let BKNodeUniqueID = 0;

/**
 * Defines an n-ary tree where each node has a key value and each node is linked in both directions.
 *
 * For storage in nodes, extend this class.
 *
 * Inheriting classes need to override {@link cloneIsolated}, {@link createRoot}, {@link createChild}
 */
export class BidirectionalKeyedNode {
    //#region CONSTRUCTOR

    static _createChildContainer(children = null){
        let cont = children??{};

        cont[Symbol.iterator]=function*() {
            //return Object.values(this);//doesn't seem to work with for(let child of node.children)
            for(let sibling of Object.values(this)){
                yield sibling;
            }
        }
        return cont;
    }

    /**
     * @param {number|string} key a key value of uniquely representing this node among its immediate siblings under the same parent node.
     * @param {BidirectionalKeyedNode|null} parent the parent node to link to this node, if any.
     * @param {Object.<string, BidirectionalKeyedNode>|null} children child nodes to link to from this node, if any.
     */
    constructor(key,parent=null,children=null) {
        /**
         * A unique number assigned to the node at construction time, incremented with each successive node.
         *
         * @deprecated do not use this property if you can avoid it, use {@link identityEquals} if you absolutely must check if two nodes are the same.
         * @type {number}
         */
        this.instanceId = BKNodeUniqueID++;
        /**
         * The key value of uniquely representing this node among its siblings under the same parent node.
         *
         * Note: this key does not have to be unique to the tree, it only has to uniquely identify the branch taken to it among siblings.
         * @member {number|string}
         */
        this.key = key;
        /**
         * The parent node linking to this node, if any.
         *
         * If this is null, the node is considered to be a "root" node by definition (except in methods start at a given node).
         * @member {BidirectionalKeyedNode|null}
         */
        this.parent = parent??null;
        /**
         * An object containing all child nodes of the current node with property names being the key of each object.
         * @member {Object<string, BidirectionalKeyedNode>}
         */
        this.children = BidirectionalKeyedNode._createChildContainer(children);

        /**
         * The depth value of the node (starting at 0 for root nodes).
         *
         * This also indicates the number of ancestors the node has in the tree.
         *
         * This value can be recalculated by calling {@link _recalculateDepth}
         * @member {number}
         */
        this.depth = 0;
        /**
         * The number of immediate children the node has.
         *
         * This is a cached value of the number of keys in the {@link children} object
         *
         * This value can be recalculated by calling {@link _recalculateChildCount}
         * @member {number}
         */
        this.childCount = 0;
        this._recalculateChildCount();
        BidirectionalKeyedNode._onUpdateLink(this.parent,this);
    }

    /**
     * Creates an 'isolated' clone of the current node (a leaf orphan without any linking).
     *  Subclasses should override this.
     *
     *  Note: By default only the following properties are maintained unless overridden: key.
     *  @return BidirectionalKeyedNode the new node.
     */
    cloneIsolated(){
        return new BidirectionalKeyedNode(this.key);
    }

    cloneSubtree(){
        let oldIdToNewId = {};
        let oldNodesById = {};
        let newNodesById = {};


        function createNewNode(oldNode){
            let newNode = oldNode.cloneIsolated();
            oldIdToNewId[oldNode.instanceId] = newNode.instanceId;
            oldNodesById[oldNode.instanceId] = oldNode;
            newNodesById[newNode.instanceId] = newNode;
            return newNode.instanceId;
        }
        function getNewNode(oldNode){
            return newNodesById[ oldIdToNewId[oldNode.instanceId] ?? null ] ?? null;
        }


        for(let oldNode of this.preorderIterator(true)){ //prepare new nodes for each old node - but not linked yet
            createNewNode(oldNode);
        }

        for(let oldNode of this.preorderIterator(true)){ //prepare new nodes for each old node - but not linked yet
            let newNode = getNewNode(oldNode);
            for(let oldChild of oldNode.children){
                let newChild = getNewNode(oldChild);
                newNode.adopt(newChild);
            }
        }

        //console.log("cloneSubtree","this",this,getNewNode(this));
        return getNewNode(this);



    }

    //#endregion

    //#region INTERNAL CALCULATIONS
    identityEquals(node){
        // noinspection JSDeprecatedSymbols
        return this.instanceId === node.instanceId;
    }
    /**
     * Replace the current node in the tree with another node.  Note: linking will be modified on the new node.
     *
     * The order in the parent's children list is not guaranteed to be maintained.
     *
     * The current node will be isolated from the tree with no parent and no children.
     *
     * @param {BidirectionalKeyedNode} newNode
     */
    replace(newNode){
        newNode.parent = this.parent;
        if(!this.isOrphan()) {
            if (newNode.key === this.key) {
                this.parent.children[this.key] = newNode;
                BidirectionalKeyedNode._onUpdateLink(this.parent,newNode);
            }else{
                this.parent.adopt(newNode);
                this.parent = null;
                this._onUpdateParentLink();
            }
        } else newNode.parent = null;
        if(!this.isLeaf()){
            newNode.children = this.children;
            for(let child of newNode.children) BidirectionalKeyedNode.attach(newNode,child);
            this.children = {};
        }
    }


    /**
     * Note: O(n) complexity where n is the number of children
     * @private
     */
    _recalculateChildCount(){ this.childCount = Object.keys(this.children).length; }

    /**
     * Note: O(n) complexity where n is the number of nodes in the path back to the root.
     * @private
     */
    _recalculateDepth(){
        let depth = 0;
        this.traceback(function(){depth++;},false)
        this.depth = depth;
        return this.depth;
    }
    //#endregion

    //#region GENERAL NODE PROPERTIES
    /** Note: O(1) constant time complexity */
    isOrphan(){ return this.parent===null; }
    /** Note: O(1) constant time complexity */
    isRoot(){ return this.isOrphan(); }
    /** Note: O(1) constant time complexity.  */
    isLeaf(){ return this.childCount===0; }


    /**
     * Returns the count of "edges" (connections) the current node has to other nodes.
     *
     * This as defined as {@link childCount} plus 1 if the node has a parent.
     * @param {boolean} forceParentNode whether to force the parent node to be included in the count regardless of whether one is attached. If true, all values will be at least 1 with no children, and higher than 1 with children.  This option is mostly for naming clarity vs childCount+1
     * @returns {number}
     */
    edgeCount(forceParentNode=false){
        return this.childCount + (this.parent===null ? (forceParentNode?1:0) : 1);
    }
    /**
     * Returns a list of all edge nodes (direct connections to/from this node).
     *
     * Note: the parent node is always listed as an edge regardless of whether it exists.
     *
     * @param {boolean} forceParentNode whether to force the parent node to appear in the list regardless of whether it exists (null).
     * @returns {(BidirectionalKeyedNode|null)[]}
     */
    edgeNodes(forceParentNode=false){
        let list = [];
        if(forceParentNode) list.push(this.parent);
        list = list.concat(Object.values(this.children));
        return list;
    }

    /**
     * Returns a list of all edges (connections by from this node) by name.
     *
     * For child nodes, the name is defined as their attached node's {@link key} and `!PARENT!` for parent nodes (if applicable)
     * @param {boolean} useParentKey if True, add the key of the parent to the list, instead of the default '!PARENT!'.  If you do this, it will not be possible to detect a parent key.
     * @returns {(string|number)[]}
     */
    edgeKeys(useParentKey=false){
        let list = [];
        if(this.parent!==null) list.push(useParentKey ? this.parent.key : "!PARENT!");
        list = list.concat(Object.keys(this.children));
        return list;
    }

    /**
     * Retrieve a named node that is connected by an edge directly to this one.
     *
     * WARNING: if useParentKey is enabled, the potential of a parent with the same name as a child node will prevent you from determining if the returned node is a parent or child.
     * @param {string|number} key the node key name of the node to retrieve, or '!PARENT!' to retrieve the parent node.
     * @param {boolean} useParentKey If true, also check the parent node's key.  If this is enabled, it will be impossible to know if the returned node is a parent or child.
     * @return {BidirectionalKeyedNode|null} The requested node, or null if it is not present.
     */
    getEdgeNodeByKey(key,useParentKey=false){
        if(key==='!PARENT!' || (useParentKey && this.parent!==null && this.parent.key === key)) return this.parent;
        return this.children[key] ?? null;
    }

    /**
     * Get a particular node connected by an edge directly to this one, indicated by an index.
     *
     * For the purposes of numbering, 0 will always indicate the parent node, while values 1-N indicate child nodes (indexed 0 - N-1).
     *
     * You should consider the indexing to be like that of an array [parent, child1, child2, ..., childN]
     *
     * Negative values will be mapped to ((length of edges) + i) so that negative positions are from the last edge (the last child) in the above list.
     * High enough negative values may return the parent node - if this is not desirable, consider using {@link getChild}.
     *
     * @param i
     */
    getEdgeNode(i){
        //let edges = this.edgeNodes(true);
        if(i<0) i += this.edgeCount(true);
        return this.edgeNodes(true)[i] ?? null;
    }

    /**
     * Alias of {@link edgeCount}
     */
    connectionCount(){ return this.edgeCount(); }

    /**
     * Alias of {@link edgeKeys}
     */
    connections(useParentKey=false){ return this.edgeKeys(useParentKey); }
    /**
     * Alias of {@link getEdgeNodeByKey}
     */
    connectedNodeByKey(key,useParentKey=false){ return this.getEdgeNodeByKey(key,useParentKey); }
    /**
     * Alias of {@link getEdgeNode}
     */
    connectedNode(i){ return this.getEdgeNode(i); }


    /** @returns {(number|string)[]} an array of immediate child keys. The order is defined by {@link Object.keys}. */
    childKeys(){
        return Object.keys(this.children);
    }
    /** @returns {BidirectionalKeyedNode[]} an array of immediate child nodes. The order is defined by {@link Object.values}.*/
    childNodes(){
        return Object.values(this.children);
    }
    /** @returns {[string,BidirectionalKeyedNode][]} an array of each immediate child key and node, as returned by {@link Object.entries}. Best used with a destructuring loop like `for(let [key,node] of entries)`*/
    childEntries(){
        return Object.entries(this.children);
    }

    /**
     * Gets a child node by its key.  Equivalent to node.children[key]
     * @param {string|number} key the unique key of the child among its siblings
     * @param {any} returnOnMissing the value to return if the child key does not exist. Defaults to null.
     * @returns {BidirectionalKeyedNode|any|null}
     */
    getChildByKey(key,returnOnMissing=null){
        return this.children[key]??returnOnMissing;
    }

    /**
     * Gets a child node by an index value (based on the position in {@link childNodes}).
     * @param i the index of the child to return, starting at 0 for the first child. If this value is negative, it will be mapped to (Child Count + i) (it will be a position from the end where -1 is the last child)
     * @returns {BidirectionalKeyedNode|null} The child node, or null if a child with the provided index doesn't exist.
     */
    getChild(i){
        if(this.isLeaf()) return null;
        if(i<0) i += this.childCount;
        return this.childNodes()[i] ?? null;
    }

    //#endregion

    //#region NODE LINKING METHODS
    /**
     * Attaches a node as a child of this node.
     *
     * This will cause the node to be removed from any previous tree/parent and be placed as a child of this node and a branch in its tree; by definition it will no longer be a root node.
     *
     * Equivalent to using {@link BidirectionalKeyedNode.attach}(this,childNode).
     * @param {BidirectionalKeyedNode} childNode
     */
    adopt(childNode){
        BidirectionalKeyedNode.attach(this,childNode);
        return this;
    }

    /**
     * Detaches a child of this node with the provided key.
     *
     * This will turn the specified child node into a root node of its own isolated tree.  Its branch will be severed from this tree.
     *
     * Equivalent to {@link disownNode} and {@link BidirectionalKeyedNode.detachChildNode} on a child with the given key.
     * @param {string|number} key
     */
    disown(key){
        BidirectionalKeyedNode.detachChildNode(this.children[key]);
        return this;
    }
    /**
     * Detaches a specific child node from this parent.
     *
     * This will turn the specified child node into a root node of its own isolated tree.  Its branch will be severed from this tree.
     *
     * Equivalent to {@link BidirectionalKeyedNode.detachChildNode}(childNode)
     * @param {BidirectionalKeyedNode} childNode the node to detach
     */
    disownNode(childNode){
        BidirectionalKeyedNode.detachChildNode(childNode);
        return this;
    }

    /**
     * Detaches all immediate children from the current node.
     *
     * This will make any child nodes into root nodes of their own, and turns any child branches into separate trees.
     *
     * This is identical to {@link BidirectionalKeyedNode.detatchChildrenOf}(this)
     *
     * @returns {BidirectionalKeyedNode}
     */
    disownAll(){
        BidirectionalKeyedNode.detatchChildrenOf(this);
        return this;
    }

    /**
     * Detaches the parent node from this node.
     *
     * This will make the current node a root node (retaining its descendents) and will cut off the branch of this node from any tree it was contained within.
     *
     * This is identical to {@link BidirectionalKeyedNode.detachChildNode}(this)
     *
     * @returns {BidirectionalKeyedNode}
     */
    detachParent(){
        BidirectionalKeyedNode.detachChildNode(this);
        return this;
    }

    /**
     * Detaches any parent and children from this node, turning it into an isolated root and leaf node with no connections.
     *
     * Note: this will not re-link an existing tree around this element; it will cause the branches from this element to be cut off into separate trees.
     * @returns {BidirectionalKeyedNode} the current node
     */
    isolate(){
        this.disownAll();
        this.detachParent();
        return this;
    }

    /**
     * Remove this node from the tree and attempt to repair the surrounding tree.
     *
     * Note: the default behavior is for the parent node to inherit the orphaned children directly. More limited trees (like BSTs) should override this method.
     */
    extract(){
        let parent = this.parent;
        let childNodes = this.childNodes();
        this.isolate();
        for(let child of childNodes){
            parent.adopt(child);
        }
    }

    //#endregion

    //#region INTERNAL UPDATE EVENTS
    // noinspection JSUnusedLocalSymbols
    /** when a child is updated, recalculate the child count */
    _onUpdateChildLink(key){
        this._recalculateChildCount();
    }
    /** when the parent link of this node is updated, update the depth to be parent.depth+1 or 0 if there is no parent */
    _onUpdateParentLink(){
        if(this.parent===null){
            this.depth = 0;
        }else{
            this.depth = this.parent.depth+1;
        }
    }

    /**
     * When a parent/child link is changed in some way, call {@link _onUpdateChildLink} and {@link _onUpdateParentLink} if possible.
     * @param {BidirectionalKeyedNode|null} parent
     * @param {BidirectionalKeyedNode} child
     * @private
     */
    static _onUpdateLink(parent,child){
        if(parent!==null) parent._onUpdateChildLink(child.key);
        child._onUpdateParentLink();
    }
    //#endregion

    //#region STATIC NODE LINKING METHODS
    /**
     *
     * @param {BidirectionalKeyedNode|null} parent
     * @param {BidirectionalKeyedNode} child
     */
    static attach(parent,child,){
        if(parent!==null) parent.children[child.key]=child;
        child.parent=parent;
        BidirectionalKeyedNode._onUpdateLink(parent,child)
    }


    /**
     * @param {BidirectionalKeyedNode} child
     */
    static detachChildNode(child){
        let parent = child.parent;
        if(parent!==null) delete parent.children[child.key];
        child.parent=null;
        BidirectionalKeyedNode._onUpdateLink(parent,child);
    }
    static detatchChildrenOf(parent){
        for(let key of parent.childKeys()) delete parent.children[key];
        for(let child of parent.childNodes()){
            child.parent=null;
            BidirectionalKeyedNode._onUpdateLink(parent,child);
        }
    }
    //#endregion

    //#region STATIC CONSTRUCTION METHODS
    /**
     * @param key
     * @param {Object.<string, BidirectionalKeyedNode>|null} children
     */
    static createRoot(key,children=null){
        return new BidirectionalKeyedNode(key,null,children);
    }
    createChild(childKey,secondChildren=null){
        let child = new BidirectionalKeyedNode(childKey,secondChildren);
        this.adopt(child);
        return child;
    }
    //#endregion

    //#region TRAVERSAL AND TRAVERSAL-BASED-CALCULATIONS

    /**
     * Gets a tree traversal iterator with a particular order or direction.
     *
     * Inorder traversal is not supported for this N-ary tree implementation.
     *
     * This iterator does not include an option for {@link descend} traversal since that method requires a path to follow.
     * @param includeThis whether to include the current node in the yielded results. If this is false, the node will still be 'explored' normally, only the result is excluded.
     * @param {BKNPredicate|function|null} predicate an optional predicate function to filter results by. This function takes the current node being processed and returns true/false whether to include it in the results.  A value of 0 or 1 will terminate the generation after the potential inclusion of the result.
     * @param {"preorder"|"postorder"|"traceback"|"reversepostorder"} order the order of the node traversal. Either 'preorder', 'postorder' or 'traceback'.  Note: 'traceback' is a special traversal that only traces the current node back to the root.
     * @returns {Generator<*, void, *>|Generator<BidirectionalKeyedNode, void, *>}
     */
    traversalIterator(includeThis=true, predicate = null, order='preorder'){
        switch(order){
            case 'preorder':
                return this.preorderIterator(includeThis,predicate);
            case 'postorder':
                return this.postorderIterator(includeThis,predicate);
            case 'reversepostorder':
                // noinspection JSDeprecatedSymbols
                return this.reversePostorderIterator(includeThis,predicate);
            case 'traceback':
                return this.tracebackIterator(includeThis,predicate);
        }
        throw "Unknown traversal order: "+order;
    }

    /**
     * Traverses the tree in Preorder and runs a callback for each node, starting with the current node as the root.
     *
     * An iterative method is used. This is generally significantly better than recursively following each child node when the tree depth is large.
     *
     * Extremely wide trees (where one node has many children) may increase memory usage.
     * @param {BKNCallback|function} fn the callback function
     * @param {boolean} includeThis whether to include the current node in the traversal callbacks. If this is false, the current node is processed, but will not trigger a callback.
     * @param {"preorder"|"postorder"|"traceback"|"reversepostorder"} order the order of the node traversal. Either 'preorder', 'postorder' or 'traceback'.  Note: 'traceback' is a special traversal that only traces the current node back to the root.
     */
    traverse(fn,includeThis=true, order='preorder'){
        let nodes = this.traversalIterator(includeThis,null,order);
        for(let node of nodes){
            fn(node);
        }
    }

    /**
     * Traverses the tree in Preorder and yields each node, starting with the current node as the root.
     *
     * An iterative method is used. This is generally significantly better than recursively following each child node when the tree depth is large.
     *
     * Extremely wide trees (where one node has many children) may increase memory usage.
     * @param {boolean} includeThis whether to include the current node in the traversal results (subject to the predicate's result). If this is false, the current node is processed, but will not be returned.
     * @param {BKNPredicate|function|null} predicate an optional predicate function to filter results by. This function takes the current node being processed and returns true/false whether to include it in the results.  A value of 0 or 1 will terminate the generation after the potential inclusion of the result.
     * @returns {Generator<*, void, *>}
     */
    *preorderIterator(includeThis=true,predicate = null){
        let stack = [this];
        //console.log(" PUSH1",this.key);
        while(stack.length>0) {//while the stack is not empty
            let traversedNode = stack.pop();
            //console.log("  POP",traversedNode.key,includeThis,traversedNode!==this,traversedNode===this);
            if(includeThis || traversedNode!==this){
                let predicateResult = predicate===null ? true : predicate(traversedNode);
                if(predicateResult){
                    yield traversedNode;
                }
                if(predicateResult===0 || predicateResult===1) return;
            }
            stack = stack.concat(traversedNode.childNodes().reverse());
            /*let children = traversedNode.childNodes();
            //console.log("  CHILDREN",traversedNode.key,children.length,children.length - 1);
            for (let i = traversedNode.childCount - 1; i >= 0; i--){
                //if(typeof children[i]==='undefined') console.log("undefined child",i,children,Object.keys(children));
                //console.log("   PUSH",i,children.length,children[i].key);
                stack.push(children[i]);
            }*/
        }
    }

    /**
     * Traverses the tree in Reverse Postorder and yields each node, starting with the current node as the root.
     *
     * An iterative method is used. This is generally significantly better than recursively following each child node.
     *
     * Extremely large trees (where one node has many children) may increase memory usage.
     * @param {boolean} includeThis whether to include the current node in the traversal results (subject to the predicate's result). If this is false, the current node is processed, but will not be returned.
     * @param {BKNPredicate|function|null} predicate an optional predicate function to filter results by. This function takes the current node being processed and returns true/false whether to include it in the results.  A value of 0 or 1 will terminate the generation after the potential inclusion of the result.
     * @returns {Generator<*, void, *>}
     * @deprecated This was written while trying to create the Postorder method and is not officially supported.
     */
    *reversePostorderIterator(includeThis=true,predicate=null){ //I Wrote this before realizing it was a reversed stack order being built...
        let stack1 = [this];
        //let stack2 = []; //writeup: push nodes from stack 1 to stack2 before adding their children - but we can just yield the node instead.
        while(stack1.length>0){
            let node1 = stack1.pop();

            if(includeThis || node1!==this){
                let condition = predicate===null ? true : predicate(node1);
                if(condition) yield node1;
                if(condition===0 || condition===1) return;
            }

            //stack2.push(node1);
            stack1 = stack1.concat(node1.childNodes());
        }
    }
    /**
     * Traverses the tree in Postorder and yields each node, starting with the current node as the root.
     *
     * An iterative method is used. This is generally significantly better than recursively following each child node.
     *
     * Extremely large trees (where one node has many children) may increase memory usage.
     * @param {boolean} includeThis whether to include the current node in the traversal results (subject to the predicate's result). If this is false, the current node is processed, but will not be returned.
     * @param {BKNPredicate|function|null} predicate an optional predicate function to filter results by. This function takes the current node being processed and returns true/false whether to include it in the results.  A value of 0 or 1 will terminate the generation after the potential inclusion of the result.
     * @returns {Generator<*, void, *>}
     */
    *postorderIterator(includeThis=true,predicate=null){
        let root = this;
        let stack = [this];
        let path = [];
        while(stack.length>0){
            //console.log('     ',root.key,stack);
            root = stack[stack.length - 1];//stack.peek();
            if(path.length>0 && path[path.length-1]===root){
                //console.log('      ','pop',root,path.length,path[path.length-1],path[path.length-1]===root);

                if(includeThis || root!==this){
                    let condition = predicate===null ? true : predicate(root);
                    if(condition) yield root;
                    if(condition===0 || condition===1) return;
                }

                stack.pop();
                path.pop();
            }else{
                //console.log('      ','push',root,path.length,path[path.length-1],path[path.length-1]===root);
                path.push(root);
                stack = stack.concat(root.childNodes().reverse());
            }
        }
    }

    /**
     * Traverses and lists all nodes of the tree in an array. The order is defined by {@link traversalIterator}.
     *
     * This method may be costly over using the iterator directly.
     * @param includeThis whether to include the current node in the results
     * @param {"preorder"|"postorder"|"traceback"|"reversepostorder"} order the order of the node traversal. Either 'preorder', 'postorder' or 'traceback'.  Note: 'traceback' is a special traversal that only traces the current node back to the root.
     * @returns {BidirectionalKeyedNode[]}
     */
    nodes(includeThis=true,order='preorder'){
        return [... this.traversalIterator(includeThis,null,order)];
    }

    /**
     * Traces the path of the current node back to the last available parent/ancestor (the "root" node) and runs a callback function for each node along the path.
     *
     * If the current node is a root, then the only node that may be visited is the current node (if enabled).
     *
     * See {@link descend} for an opposite operation - following a path down.
     * @param {BKNCallback|function} fn a function to call for each node visited when tracing back
     * @param includeThis whether to include the current node when calling the function.
     */
    traceback(fn,includeThis=true){
        let iter = this.tracebackIterator(includeThis);
        for(let node of iter) fn(node);
    }

    /**
     * Traces the path of the current node back to the last available parent/ancestor (the "root" node).
     *
     * If the current node is a root, then the only node that may be visited is the current node (if enabled).
     *
     * See {@link descendIterator} for an opposite operation - following a path down.
     * @param includeThis whether to include the current node when calling the function (subject to the predicate's filtering)
     * @param {BKNPredicate|function|null} predicate an optional predicate function to filter results by. This function takes the current node being processed and returns true/false whether to include it in the results.  A value of 0 or 1 will terminate the generation after the potential inclusion of the result.
     * @returns {Generator<*, void, *>}
     */
    *tracebackIterator(includeThis=true,predicate = null){
        if(includeThis){
            let condition = predicate === null ? true : predicate(this)
            if(condition) yield this;
            if(condition===1 || condition===0) return;
        }
        let ancestor = this.parent;
        while(ancestor!==null){
            let condition = predicate === null ? true : predicate(ancestor)
            if(condition) yield ancestor;
            if(condition===1 || condition===0) return;
            ancestor = ancestor.parent;
        }
    }

    /**
     * Traces the path of the current node back to the "root" node, as defined by {@link traceback} and returns a list of each node visited.
     * @returns {BidirectionalKeyedNode[]}
     */
    tracebackNodes(includeThis=true){
        let list = [];
        this.traceback(function(node){ list.push(node); },includeThis);
        return list;
    }
    /**
     * Traces the path of the current node back to the "root" node, as defined by {@link traceback} and returns a list of each node visited.
     * @returns {(string|number)[]}
     */
    tracebackKeys(includeThis=true, minDepth=-1, maxDepth=Number.MAX_SAFE_INTEGER){
        let list = [];
        this.traceback(function(node){
            if(node.depth>=minDepth && node.depth<=maxDepth) list.push(node.key);
        },includeThis);
        return list;
    }

    /**
     * Finds the highest node of which the current node belongs to its subtree. (The oldest ancestor of the current node).
     * This function uses the behavior defined in {@link traceback}
     * @param includeThis Whether to return the current node if it has no parent. Otherwise, null will be returned.
     * @returns {BidirectionalKeyedNode|null} The highest parent of the
     */
    findRoot(includeThis=true){
        let parents = this.tracebackIterator(includeThis);
        let node = null;
        for(node of parents){ } //force the iterator to move to the end, collect the last node
        return node;
    }

    /**
     * Alias for {@link traceback} to mirror the naming of {@link descend}
     * @param fn
     * @param includeThis
     */
    ascend(fn,includeThis=true){
        return this.traceback(fn,includeThis);
    }


    /**
     * Traverses the tree according to {@link BidirectionalKeyedNode.traversalIterator} and yields Leaf nodes starting at the current node.
     *
     * This will have the same complexity as `preorderIterator()`
     * @param includeThis
     * @param {"preorder"|"postorder"|"traceback"|"reversepostorder"} order the order of the node traversal. Either 'preorder', 'postorder' or 'traceback'.  Note: 'traceback' is a special traversal that only traces the current node back to the root.
     * @returns {Generator<*, void, *>}
     */
    leafIterator(includeThis=true,order='preorder'){
        return this.traversalIterator(includeThis,function(node){
            return node.isLeaf()
        },order)
    }
    /**
     * Traverses the tree according to {@link BidirectionalKeyedNode.leafIterator} and runs a callback function on Leaf nodes starting at the current node.
     *
     * This will have the same complexity as `traverse()`
     * @param {BKNCallback|function} fn callback function to call on each leaf node
     * @param includeThis whether to consider the current node when running callbacks (only applies if it itself is a leaf)
     * @param {"preorder"|"postorder"|"traceback"|"reversepostorder"} order the order of the node traversal. Either 'preorder', 'postorder' or 'traceback'.  Note: 'traceback' is a special traversal that only traces the current node back to the root.
     */
    traverseLeaves(fn,includeThis=true,order='preorder'){
        let leaves = this.leafIterator(includeThis,order);
        for(let leaf of leaves) fn(leaf);
        //this.traverse(function(node){ if(node.isLeaf()) fn(node); },includeThis)
    }

    /**
     * Retrieves an array of leaf nodes as traversed by {@link traverseLeaves}
     * @param includeThis whether to consider the current node (only applies if it itself is a leaf)
     * @param {"preorder"|"postorder"|"traceback"|"reversepostorder"} order the order of the node traversal. Either 'preorder', 'postorder' or 'traceback'.  Note: 'traceback' is a special traversal that only traces the current node back to the root.
     * @returns {BidirectionalKeyedNode[]}
     */
    leaves(includeThis=true,order='preorder'){
        return [... this.leafIterator(includeThis,order)];
    }

    /**
     * Retrieves an array of keys for leaf nodes as traversed by {@link traverseLeaves}
     * @param includeThis whether to consider the current node (only applies if it itself is a leaf)
     * @param {"preorder"|"postorder"|"traceback"|"reversepostorder"} order the order of the node traversal. Either 'preorder', 'postorder' or 'traceback'.  Note: 'traceback' is a special traversal that only traces the current node back to the root.
     * @returns {(string|number)[]} the leaf node keys
     */
    leafKeys(includeThis=true,order='preorder'){
        let list = [];
        this.traverseLeaves(function(node){
            list.push(node.key);
        },includeThis,order);
        return list;
    }

    /**
     * Removes all current leaves from the tree starting with the current node as the root.
     *
     * This method uses {@link leaves} to retrieve a list of leaves to prune - a tree with many leaves may see an increase of memory usage.
     *
     * As the current node is used as the root, it itself will not be pruned from the tree.
     * @param {BKNPredicate|function|null} [fnBeforePrune] a conditional function that is called with the leaf node before removal. If the result is true, the leaf is pruned. If not defined, all leaves are pruned.
     * @param {"preorder"|"postorder"|"traceback"|"reversepostorder"} order the order of the node traversal. Either 'preorder', 'postorder' or 'traceback'.  Note: 'traceback' is a special traversal that only traces the current node back to the root.
     */
    pruneLeaves(fnBeforePrune=null,order='preorder'){
        let leaves = this.leaves(false,order);
        for(let leaf of leaves){
            let condition = fnBeforePrune===null ? true : fnBeforePrune(leaf);
            if(condition) BidirectionalKeyedNode.detachChildNode(leaf);
            if(condition===0||condition===1) return;
        }
    }

    /**
     * Runs a callback function against all leaf nodes before pruning them repeatedly until there are no child nodes.
     *
     * This is used for 'condensing' functions where all child data gets packed into the current node.
     *
     * This method only guarantees that the callback will be ran on a child node before its parent node. It does not guarantee a specific order among siblings or unrelated branches.
     *
     * **If you simply want to remove all children, use {@link disownAll} instead!**
     * @param {BKNPredicate|function|null} [fnBeforePrune] a conditional function that is called with the leaf node before removal. If the result is true, the leaf is pruned. If not defined, all leaves are pruned.
     * @param {"preorder"|"postorder"|"traceback"|"reversepostorder"} order the order of the node traversal. Either 'preorder', 'postorder' or 'traceback'.  Note: 'traceback' is a special traversal that only traces the current node back to the root.
     */
    pruneAllBottomUp(fnBeforePrune, order='preorder'){
        while(this.childCount>0){
            this.pruneLeaves(fnBeforePrune,order)
        }
    }

    /**
     * Generates a list from all tree nodes in the traversal order defined by {@link traverse}
     * @param {boolean} includeThis whether to include the current node in the traversal. If this is false, the current node is processed, but will not be returned
     * @param {"preorder"|"postorder"|"traceback"|"reversepostorder"} order the order of the node traversal. Either 'preorder', 'postorder' or 'traceback'.  Note: 'traceback' is a special traversal that only traces the current node back to the root.
     * @returns BidirectionalKeyedNode[]
     */
    treeList(includeThis=true, order='preorder'){
        let list = [];
        this.traverse(function(node){
            list.push(node);
        },includeThis, order);
        return list;
    }
    treeKeyList(includeThis=true,order='preorder'){
        let list = [];
        this.traverse(function(node){
            list.push(node.key);
        },includeThis,order);
        return list;
    }
    treeInstanceList(includeThis=true,order='preorder'){
        let list = [];
        this.traverse(function(node){
            list.push(node.instanceId);
        },includeThis,order);
        return list;
    }

    /**
     * Alias for {@link traverse}
     * @param {boolean} includeThis whether to include the current node in the traversal callbacks. If this is false, the current node is processed, but will not trigger a callback.
     * @param {BKNCallback} fn the callback function
     * @param {"preorder"|"postorder"|"traceback"|"reversepostorder"} order the order of the node traversal. Either 'preorder', 'postorder' or 'traceback'.  Note: 'traceback' is a special traversal that only traces the current node back to the root.
     */
    each(fn,includeThis=true, order='preorder'){
        this.traverse(fn,includeThis, order);
    }

    /**
     * Follows a path down the tree given by child key names and runs a callback on each, starting at the current node.
     *
     * This function is intended to be the opposite of {@link tracebackKeys} where the path returned by tracebackKeys() should be the path to the descendant from the root.
     * @param {BKNCallback|function} fn the callback function
     * @param {string[]} keyPath a list of keys indicating which child node to follow at each level of the tree, starting with a child of the current node.
     * @param {boolean} includeThis whether to include the current node in the callbacks while descending the path.
     * @return {BidirectionalKeyedNode|null} the last node visited, or null if one of the children did not exist (the path was not valid)
     * @param {BKNBeforeVisit|function} fnBeforeVisit a function called on each move down the path before the value is yielded.  This function has the benefit of being able to detect missing keys before returning.  Because of the structure of this iterator, adding children during this method is acceptable.
     */
    descend(fn,keyPath, includeThis=true, fnBeforeVisit = null){
        //console.log("   Descend",keyPath,includeThis);
        let descent = this.descendIterator(keyPath,includeThis, null, fnBeforeVisit);
        let next;
        while(!(next=descent.next()).done){ //we could use a For loop - but for some reason it will consume the return value without iterating it.
            fn(next.value);
        }
        return next.value ?? null;
    }

    /**
     * Follows a path down the tree given by child key names and yields each, starting at the current node.
     *
     * This function is intended to be the opposite of {@link tracebackKeys} where the path returned by tracebackKeys() should be the path to the descendant from the root.
     *
     * This iterator returns a final value of the last node visited, or null if one of the children did not exist (the path was not valid). WARNING: for loops will consume this value.
     * @param {string[]} keyPath a list of keys indicating which child node to follow at each level of the tree, starting with a child of the current node.
     * @param {boolean} includeThis whether to include the current node in the results while descending the path.
     * @param {BKNPredicate|function|null} predicate an optional predicate function to filter results by. This function takes the current node being processed and returns true/false whether to include it in the results.  A value of 0 or 1 will terminate the generation after the potential inclusion of the result.
     * @param {BKNBeforeVisit|function} fnBeforeVisit a function called on each move down the path before the value is yielded.  This function has the benefit of being able to detect missing keys before returning.  Because of the structure of this iterator, adding children during this method is acceptable.
     */
    *descendIterator(keyPath, includeThis=true, predicate = null, fnBeforeVisit = null){
        let keysReverse = keyPath.reverse();
        let currentNode = this;
        if(includeThis){
            let condition = predicate === null ? true : predicate(currentNode);
            if(condition) yield currentNode;
            if(condition===0 || condition===1) return keysReverse.length>0 ? null : currentNode;
        }
        while(keysReverse.length>0 && currentNode!==null){
            let childKey = keysReverse.pop();
            //console.log("TreeNode.descendIterator.BeforeVisit",'currentNode',currentNode,'childKey',childKey,'childNode',currentNode.children[childKey] ?? null,'notHasMore',!keysReverse.length,'cb:BeforeVisit',fnBeforeVisit);
            if(fnBeforeVisit) fnBeforeVisit('a','b', 'c', 'd');
            if(fnBeforeVisit) fnBeforeVisit(currentNode,childKey, currentNode.children[childKey] ?? null, !keysReverse.length);
            currentNode = currentNode.children[childKey] ?? null;
            if(currentNode!==null){
                let condition = predicate === null ? true : predicate(currentNode);
                if(condition) yield currentNode;
                if(condition===0 || condition===1) return keysReverse.length>0 ? null : currentNode;
            }
        }
        //console.log("       Generator returning",[...keyPath],includeThis,predicate,'|',[...keysReverse],keysReverse.length>0,currentNode,'->',keysReverse.length>0 ? null : currentNode);
        //return -999;
        return keysReverse.length>0 ? null : currentNode;
    }

    /**
     * Follows a path down the tree given by child key names and attempts to locate a specific descendant node (the one given by the last key)
     * @param keyPath a list of keys indicating which child node to follow at each level of the tree, starting with a child of the current node.
     * @returns {BidirectionalKeyedNode|null} the descendant requested, or null if the descendant or one of the keys in the path did not exist.
     * @param {function(BidirectionalKeyedNode,string,boolean)} fnOnNotExists a function called when a child node does not exist before the value is yielded.  This function has the benefit of being able to detect missing keys before returning.  Because of the structure of this iterator, adding children during this method is acceptable.
     */
    getDescendant(keyPath,fnOnNotExists = null){
        return this.descend(function(){},keyPath,false,function(from,key,to,last){
            //console.log(' ',"nav TreeNode.getDescendant.BKNBeforeVisit",'from',from,'key',key,'to',to,'last',last,'cb:notexists',fnOnNotExists);
            if(to===null && fnOnNotExists) fnOnNotExists(from,key,last)
        });
    }

    //#endregion

    //#region map,filter,reduce
    /**
     * Processes all nodes of the current node's subtree through a mapping function which may replace the nodes.
     *
     * This function uses {@link replace} and so changes to parent/child linkage will not be maintained from the replacement node.  The order is defined by {@link nodes}.
     *
     * WARNING: unlike Array.map, this function modifies the tree in-place (as it is inefficient to copy the tree).  For this reason, you should not do anything to drastically alter the structure of the tree.
     *
     * NOTE: only nodes that existed in the tree before mapping will be visited by this function.
     * @param {function} fnMap a function that takes each node in the tree and outputs a replacement node. Note: if any value except a node is returned, the node will be left unmodified.
     * @param includeThis whether to map the current node also.
     */
    map(fnMap,includeThis=true){
        let _tree = this;
        let nodes = this.nodes(includeThis);
        for(let node of nodes){
            let newNode = fnMap(node);
            if(node===this) _tree = newNode;
            if(newNode instanceof BidirectionalKeyedNode) node.replace(newNode);
        }
        return _tree;
    }

    /**
     * Processes all the current node's subtree through a filtering function which may delete nodes.
     *
     * The order of processing is defined by {@link nodes}.  The behavior of node removal is defined by {@link extract}.
     *
     * WARNING: unlike Array.filter, this method directly modifies the tree (as it is inefficient to copy the tree).  Do not further modify the tree linkage within the filter function.
     *
     * NOTE: only nodes that existed in the tree before mapping will be visited by this function. The current node (the subtree root) is not included in the processed nodes, since if it was removed then the tree may have different parents at that level.
     * @param {BKNPredicate|function} fnFilter a function that takes each node in the tree and outputs a result. If the result is false-like, the node is removed. If the result is 0 or 1, filtering will end abruptly after the potential removal.
     * @returns {BidirectionalKeyedNode} the current node / current subtree being filtered.
     */
    filter(fnFilter){
        let nodes = this.nodes(false);
        for(let node of nodes){
            let condition = fnFilter(node);
            if(!condition) node.extract();
            if(condition===0 || condition===1) break;
        }
        return this;
    }
    //#endregion

}

/**
 * Defines an N-ary Tree node
 *
 * Alias of {@link BidirectionalKeyedNode}
 */
export class TreeNode extends BidirectionalKeyedNode{

}


app.util.TreeNode = TreeNode;
app.util.BidirectionalKeyedNode = BidirectionalKeyedNode


/**
 * @function
 * @name BKNBeforeVisit
 * A callback function used before visiting a node during a traversal
 * @param {BidirectionalKeyedNode|null} fromNode the current node being visited from
 * @param {string} key the child key or edge being followed
 * @param {BidirectionalKeyedNode|null} toNode the new node to be visited
 * @param {boolean} [last] whether the toNode would be the last visit in the traversal (if detectable/supported).
 */

/**
 * @function
 * @name BKNPredicate
 * A conditional callback function used to decide the inclusion or status of traversed tree nodes
 * @param {BidirectionalKeyedNode} node the node
 * @returns {boolean|0|1} Whether to include the node in the results / whether the node passes the check of the predicate. A value of 0 or 1 signals to stop any iteration after yielding or not yielding the result.
 */

/**
 * @function
 * @name BKNCallback
 * A callback function used when traversing node trees
 * @param {BidirectionalKeyedNode} node the node
 */

/**
 * Helper library for the Bootstrap Autocomplete JS Library
 * @see http://bootstrap-autocomplete.readthedocs.io/
 * @see https://github.com/xcash/bootstrap-autocomplete
 */
app.ui.common.autocomplete = {
    isSupported(){
        return (typeof $.fn.autoComplete!=='undefined') || (typeof $('<div>').autoComplete !=='undefined');
    },

    /**
     * Hide all bootstrap autocomplete dropdown menus
     * @param {jQuery|null} parent parent element to limit searched to
     */
    hideAll(parent=null){
        if(parent===null) parent=$('body');
        parent.find('.bootstrap-autocomplete.dropdown-menu.show').removeClass('show')
    },

    /**
     * Resolves an input control (ID or selection) or into a jQuery selection
     * @param {object|jQuery|string} control jQuery selection or control ID
     * @returns {jQuery}
     */
    resolveControl(control) {
        if (control instanceof jQuery) {
            //console.log("autocomplete resolved jq",control)
            return control;
        }
        let controlid = control;
        if (typeof control !== 'string') controlid = ""+control;
        var id_s = $.escapeSelector(controlid);
        let elem = $("#" + id_s);
        //console.log("autocomplete resolved id",controlid,id_s,elem);
        return elem;
    },

    /**
     * Wrap an input control in a bootstrap dropdown container element.
     *
     * This sometimes helps with autocomplete dropdown positioning issues in certain layouts.
     * @param {object|jQuery|string} control jQuery selection or control ID
     */
    wrapElement:function(control){
        this.resolveControl(control).wrap('<div class="dropdown"></div>')
    },


    /**
     * Translate an array of values into an autocomplete-compatible list consisting of Value and Display-Text.
     *
     * This considers each array element to be both the Value and Display Text of the list entries.
     *
     * The display text is a string conversion of the value.
     *
     * The resulting array will have the format `[ {value: ..., text: ...}, ...]`
     *
     * @param {*[]} arr an array of values
     * @returns {ACDisplayResult[]}
     */
    arrayToDisplayList(arr){
        let list = [];
        for(let value of arr) list.push({value:value,text:""+value});
        return list;
    },

    /**
     * Filters an array to entries that start with or contain a provided search value.
     *
     * This is intended for use with custom autocomplete providers.
     *
     * @param {*[]} arr an array of values or text
     * @param {string} search a search string / prefix for elements to show
     * @param caseSense whether to use a case-sensitive comparison (default: false)
     * @param contains whether to use a 'contains' match, otherwise matches when the text starts with the search value (default: false)
     * @returns {*[]} the array elements that matched the search.
     */
    filterArrayBySearch(arr,search,caseSense=false,contains=false){
        if(!caseSense) search=(""+search).toUpperCase();
        return arr.filter(function(value){
            if(!caseSense) value = (""+value).toUpperCase();
//            console.log(" filter result ",value,search,value.startsWith(search),contains,value.includes(search))
            return (!contains && value.startsWith(search)) || (contains && value.includes(search));
        });
    },

    /**
     * Default Autocomplete input focus handler.
     *
     * This method is called by default when the autocomplete input is focused.
     *
     * This implementation triggers a 'paste' event for the input (when it is not readonly or disabled) in order to prompt an autocomplete to display when the input is focused.
     */
    onDefaultFocus(evt){
        $(this).not(":read-only").not(":disabled").trigger('paste'); //this looks weird but it forces the autocomplete to open on focus regardless of typing
    },

    /**
     * Default Autocomplete item select handler.
     *
     * This method is called by default when an item is selected from the autocomplete dropdown list for the input.
     *
     * This implementation sets the value of the input to a selected autocomplete item, when it is selected - then triggers a 'change' event for the input.
     *
     * No action is performed if the item has an undefined value.
     */
    onDefaultSelect(evt,item){
//        console.log('ac select', "this", this, "item", item, "v", evt);
        if (typeof item['value'] !== "undefined") {
//            console.log(" forcing select of", item['value'])
            $(this).val(item['value']);//select actual value not displayed text
        }
        $(this).change();
    },

    /**
     * Default Autocomplete Free-Value entry handler.
     *
     * This method is called when a non-autocompleted value is entered in the input.
     *
     * This implementation performs no action except debug logging.
     *
     */
    onDefaultFreeValue(v,val){
//        console.log('ac freevalue', this, val, v);
    },

    /**
     * Default Autocomplete dropdown-shown handler.
     *
     * This method is called when an autocomplete dropdown is shown for the input.
     *
     * This implementation forces autocomplete dropdowns to be hidden when the input is readonly or disabled.  This is a workaround for dropdowns being shown when tab-selecting a disabled input.
     * @param evt
     */
    onDefaultDDShown(evt){
//        console.log('autocomplete.dd.shown', this, evt);
        if($(this).is(':read-only') || $(this).is(':disabled')){ //close autocomplete when tab-selecting a read-only field
            app.ui.common.autocomplete.hideAll();//another solution may be to use a custom handler for all autocompletes so we can block the results
        }
    },


    /**
     *
     * @param api_id
     * @param min_len
     * @param customValueProvider
     * @returns {{minLength: number, noResultsText: string, resolverSettings: {url: string}}}
     */
    createAutocompleteSettings(api_id=null,min_len=0,customValueProvider=null){
        let action = 'ac-' + api_id;
        if(typeof api_id==='string' && api_id.startsWith('@')) action=api_id.substring(1);

        let settings = {
            resolverSettings: {url: app.api.uri+'?action=' + encodeURIComponent(action)},
            minLength: min_len,
            noResultsText: '',
        };
        if(customValueProvider!==null){
            settings.resolverSettings='custom';
            settings.events = {search: customValueProvider}
        }
        return settings;
    },



    /**
     * Register a control with autocomplete support, adding event handling.
     * @param {jQuery|string} control the selector or element to use as an autocompleted input
     * @param {int} min_len the minimum length of input text required to trigger autocomplete
     * @param {string|null} api_id the API action to request autocomplete entries from (if any is required)
     * @param {boolean} wrap whether to wrap the input in a Bootstrap Dropdown container element. This can solve some positioning and display issues.
     * @param {ACCustomValueProvider|null} customValueProvider a custom function that can provide results to the autocomplete list, as an alternative to an API request.
     * @param {function|null} onSelect event handler for when an autocomplete item is selected. If this is null, {@link onDefaultSelect} is used.
     * @param {function|null} onFreeValue event handler for when a free value is entered in the input rather than an autocompleted one. If this is null, {@link onDefaultFreeValue} is used.
     * @param {function|null} onDDShown event handler for when the autocomplete dropdown is displayed. If this is null, {@link onDefaultDDShown} is used.
     * @param {function|null} onFocus event handler for when the input is focused. If this is null, {@link onDefaultFocus} is used.
     */
    attach:function(control, min_len = 0, api_id = null, wrap=false,customValueProvider=null, onSelect=null, onFreeValue=null, onDDShown=null, onFocus=null) {
        if(!this.isSupported()) return console.warn("App UI Autocomplete: Bootstrap Autocomplete is not available");
        if(wrap) this.wrapElement(control);
        if (api_id === null) api_id = control;
        //var id_s = $.escapeSelector(controlid);
        var api_id_s = $.escapeSelector(api_id);
        var elem = this.resolveControl(control);


//        console.log("attaching autocomplete to", elem);
        //var input = elem[0];

        let settings = this.createAutocompleteSettings(api_id,min_len,customValueProvider);
        // noinspection JSUnresolvedFunction
        elem.autoComplete(settings);

        elem.focus(onFocus ?? this.onDefaultFocus);
        elem.on('autocomplete.select', onSelect??this.onDefaultSelect)
        elem.on('autocomplete.freevalue', onFreeValue??this.onDefaultFreeValue)
        elem.on('autocomplete.dd.shown', onDDShown??this.onDefaultDDShown)


    },



    /**
     *
     * @param api_id
     * @param selector
     * @param min_len
     * @param onSelect
     * @param onFreeValue
     * @param {boolean} wrap
     * @deprecated stub function for attach(...)
     * @see attach
     */
    attachTo:function(api_id,selector, min_len = 0,onSelect=null,onFreeValue=null, wrap=false) {
        return this.attach(selector,min_len,api_id,wrap,null,onSelect,onFreeValue);
    }

}


/**
 * @typedef {object} ACDisplayResult
 * @description Object representing the display and value of an autocomplete option
 * @property {string|number|null} value the value that will be set on the form control when selecting this autocomplete choice
 * @property {string} text the text that will be displayed in the list of autocomplete options
 */

/**
 * @typedef {function} ACResolveCallback
 * @description Callback function that sets the display-list of autocomplete results
 * @param {ACDisplayResult[]} results a list of autocomplete options to be displayed
 */

/**
 * @typedef {function} ACCustomValueProvider
 * @description Function that provides a display-list
 * @param {string} searchQuery text entered by the user, to be autocompleted
 * @param {ACResolveCallback} resolve callback function that should be called with the results
 * @param {jQuery|null} origJQElement Original jQuery element
 */
class CheckboxStateShims {
    static updateFromCheckbox(checkbox){
//        console.log(" CBSHIM-UPDATE");
        let $this = $(checkbox);
        let shimId = $this.data2('checkbox-shim');
        let checkboxShim = $('#'+$.escapeSelector(shimId));
//        console.log("CHECKBOX-SHIM",$this,shimId,checkboxShim);

        let checkShim = !$this.is(':checked');
        checkboxShim.prop('checked',checkShim);
    }
    static onChangeCheckbox(){
//        console.log("CBSHIM-ONCHANGE");
        CheckboxStateShims.updateFromCheckbox(this)
    }

    static updateAll(){
        $('.cb-shimmed-state').each(function(){
            CheckboxStateShims.updateFromCheckbox(this);
        })
    }

    static addedStateWrapper = false;
    static addStateWrapper(){
        if(CheckboxStateShims.addedStateWrapper) return;
        CheckboxStateShims.addedStateWrapper = true;

        let oldAttr = jQuery.fn.attr;
        jQuery.fn.attr = function(){
            let isShimmedCB = $(this).is('.cb-shimmed-state:checkbox');
            //if(isShimmedCB) console.log("shimmed attr",this,arguments);
            if(arguments.length===0){
                //if(isShimmedCB) console.log(" apply(this)",this,arguments);
                return oldAttr.apply(this);
            }else{
                //if(isShimmedCB) console.log(" apply(this,args)",this,arguments);
                let ret = oldAttr.apply( this, arguments );
                //if(isShimmedCB) console.log(" isCheckEvent?",this,arguments);
                if(isShimmedCB && arguments[0].length>1 && arguments[0]==="checked"){
//                    console.log(" triggering cbshim",this,arguments);
                    $(this).trigger( "cbshim-change");
                }
                return ret;
            }
        }

        let oldProp = jQuery.fn.prop;
        jQuery.fn.prop = function(){
            let isShimmedCB = $(this).is('.cb-shimmed-state:checkbox');
            //if(isShimmedCB) console.log("shimmed prop",this,arguments);
            if(arguments.length===0){
                //if(isShimmedCB) console.log(" apply(this)",this,arguments);
                return oldProp.apply(this);
            }else{
                //if(isShimmedCB) console.log(" apply(this,args)",this,arguments);
                let ret = oldProp.apply( this, arguments );
                //if(isShimmedCB) console.log(" isCheckEvent?",this,arguments);
                if(isShimmedCB && arguments[0].length>1 && arguments[0]==="checked"){
//                    console.log(" triggering cbshim",this,arguments);
                    $(this).trigger( "cbshim-change");
                }
                return ret;
            }
        }
    }

    static addToCheckbox(checkbox){
        checkbox = $(checkbox);
        let cbId = checkbox.attr('id') ?? null;
        if(cbId===null) cbId = "checkbox_"+( (Math.random()+"").replace(".","_") );
        let shimId = cbId+"_off_shim";
        let checkboxShim = $('<input type="checkbox" class="cb-shim no-form-control d-none" value="0">');
        checkboxShim.attr('id',shimId);
        checkboxShim.attr('name',checkbox.attr('name') ?? 'unknown-checkbox-shim');
        checkboxShim.data2('checkbox-id',cbId);
        checkboxShim.val(checkbox.data2('off-value') ?? 0);
        checkboxShim.insertAfter(checkbox);


        checkbox.data2('checkbox-shim',shimId);
        checkbox.addClass('cb-shimmed-state');



        checkbox.change(CheckboxStateShims.onChangeCheckbox);
        checkbox.click(CheckboxStateShims.onChangeCheckbox);
        checkbox.on("cbshim-change",CheckboxStateShims.onChangeCheckbox);

        CheckboxStateShims.updateFromCheckbox(checkbox);

    }
    static addToCheckboxes(selector='input[type="checkbox"]'){
        $(selector).each(function(){
            CheckboxStateShims.addToCheckbox(this);
        })
    }
}

CheckboxStateShims.addStateWrapper();

app.ui.CheckboxStateShims = CheckboxStateShims;
app.ui.darkmode = {
    state:null,
    toggle:function (){
        if(typeof app.ui.darkmode.state === "undefined" || !app.ui.darkmode.state){
            app.ui.darkmode.state=1;
            $('body').removeClass('lightmode');
            $('body').addClass('darkmode');


            $('#main-navbar').removeClass('bg-dark');
            $('#main-navbar').removeClass('navbar-dark');
            $('#main-navbar').addClass('bg-light');
            $('#main-navbar').addClass('navbar-light');

        }else{
            app.ui.darkmode.state=0;
            $('body').addClass('lightmode');
            $('body').removeClass('darkmode');


            $('#main-navbar').addClass('bg-dark');
            $('#main-navbar').addClass('navbar-dark');
            $('#main-navbar').removeClass('bg-light');
            $('#main-navbar').removeClass('navbar-light');
        }
        app.ui.darkmode.store();
    },


    store:function (){
        let date = new Date();
        date.setFullYear(date.getFullYear()+1);
        app.util.setCookie("rcps_ui_darkmode",app.ui.darkmode.state,date)
//        console.log("darkmode","setting",app.ui.darkmode.state)
    },

    restore:function (){
        let cookieStr = app.util.getCookie('rcps_ui_darkmode');
        app.ui.darkmode.state = (cookieStr==="1" || cookieStr===1 || cookieStr===true);


//        console.log("darkmode","reading",app.ui.darkmode.state,!app.ui.darkmode.state)
        app.ui.darkmode.state = !app.ui.darkmode.state;
        app.ui.darkmode.toggle();
    }
}
app.ui.drag={
    dragover_effect: 0,
    lastdragover: 0,
    lastdragleave: 0,

    _showDraggingVisuals(){
        app.ui.drag.lastdragover = Date.now(); //log the dragover time
        if (app.ui.drag.dragover_effect === 1) return; //don't reapply styles if already applied
        //console.log('dragover');
        //apply styles immediately
//        console.log('dragover');
        $('body').addClass('ui-dragging-item');
        $('body').findAllExcluding('.ui-dragarea,.ui-dragarea *').addClass('ui-dragging-blur')
        app.ui.drag.dragover_effect = 1;
    },
    _tryHideDraggingVisuals(){
        if (app.ui.drag.dragover_effect === 0) return; //if the drag effect is already disabled, don't worry about it.
        if (app.ui.drag.lastdragleave < app.ui.drag.lastdragover) return; //if the last dragleave is older than the newest dragover, then keep the drag effect on (still dragging)
        let ts = Date.now();
        if ((ts - app.ui.drag.lastdragleave) > 250) { //if the last seen drag event was DragLeave and it was over 250ms ago, then we consider the drag to have ended.
            $('body').removeClass('ui-dragging-item');
            $('.ui-dragging-blur').removeClass('ui-dragging-blur');
            app.ui.drag.dragover_effect = 0;
        }
    },
    _indicateDraggingStopped(){
        app.ui.drag.lastdragleave = Date.now(); //log the dragleave time (this can be hovering over an element or out of the document itself)
    },

    attachDocumentListener: function () {

        //$(document).on('dnd_start.vakata', function (e, data) {
        //    console.log("DND_start.vakata");
        //});



        $(document).on('dragover', function (e) {
            e.preventDefault();
            if (!$(e.target).is('.ui-dragarea')) {
                e.originalEvent.dataTransfer.dropEffect = "none";
            }
            app.ui.drag._showDraggingVisuals();
        });
        $(document).on('dnd_start.vakata', app.ui.drag._showDraggingVisuals);
        $(document).on('dnd_closed.vakata', app.ui.drag._indicateDraggingStopped); //custom event from jstree-drag


        $(document).on('dragleave dnd_stop.vakata', app.ui.drag._indicateDraggingStopped)

        window.addEventListener('drop', (event) => {
            event.preventDefault();
            app.ui.drag._indicateDraggingStopped(); //log the dragdrop time as a leave to disable the visual effect
        }, false)

        setInterval(app.ui.drag._tryHideDraggingVisuals, 50)
    },

    attachDraggable: function (selector, effectAllowed = "copy") {
        $(selector).addClass('ui-draggable').prop('draggable', true);
        //console.log("attaching draggable", $(selector), $(selector)[0]);
        $(selector)[0].addEventListener('dragstart', function (e) {
            let selector_ = selector;
            let data = JSON.stringify($(selector_).data());
//            console.log("dragstart", "evt", e, "selector", selector_, "data", data)
            e.dataTransfer.setData("data", data);
            e.dataTransfer.effectAllowed = effectAllowed;
            //$('body').addClass('ui-dragging-item');
        }, false);
        $(selector)[0].addEventListener('dragend', function (e) {
//            console.log("dragend", "evt", e)
            //$('body').removeClass('ui-dragging-item');
        }, false);
        /*
            $(selector).on('dragstart',function(evt){
                let selector_ = selector;

                evt.originalEvent.dataTransfer.setData("data",JSON.stringify($(selector_).data()));
            })*/
    },

    attachArea:function (selector, acceptdragType = 'Files', cb_dragDrop = null) {
        $(selector).addClass('ui-dragarea');
        $(selector).on('dragenter', function (e) {
//            console.log("dragenter");

            $(this).addClass('ui-dragarea-dragging');
            //if(cb_dragEnter!==null) cb_dragEnter(e,this);
        });
        $(selector).on('dragleave', function (e) {
//            console.log("dragleave");
            $(this).removeClass('ui-dragarea-dragging');
            //if(cb_dragLeave!==null) cb_dragLeave(e,this);
        });
        $(selector).on('dragover', function (e) {
            e.preventDefault();
            //console.log("dragover ",dt.types);

            if (e.originalEvent.dataTransfer.types.includes(acceptdragType)) {
                e.originalEvent.dataTransfer.dropEffect = "copy";
            } else {
                e.originalEvent.dataTransfer.dropEffect = "none";

            }
            //if(cb_dragDrop!==null) cb_dragDrop(e,this);
        });

        $(selector).on('drop', function (e) {
            let this_ = this;
            let dt = e.originalEvent.dataTransfer;

//            console.log("drop", dt.types);
            $(selector).trigger('dragleave');
            $(this).addClass('ui-dragarea-dropped');
            setTimeout(function () {
                let this__ = this_;
                $(this__).removeClass('ui-dragarea-dropped');
            }, 250);
            e.preventDefault();

            if (dt.types.includes(acceptdragType))
                if (cb_dragDrop !== null) cb_dragDrop(e, this, dt);
        });
    }

}
/**
 * An enumeration of different event implementations.
 *
 * @see event_implementations.DOM
 * @see event_implementations.INTERNAL
 * @see event_implementations.HYBRID
 * @type {{DOM: string, INTERNAL: string, HYBRID: string}}
 */
let event_implementations = {
    /**
     * attach events using window.addEventListener, dispatch events using window.dispatchEvent, does not handle async methods
     */
    DOM: 'DOM',
    /**
     * attach events using an internal callback list, dispatch events by calling each and await every callback.
     */
    INTERNAL: 'INTERNAL',
    /**
     * attach handlers using the internal method, dispatch events for both internal callbacks and DOM listeners. (INTERNAL attach, DOM+INTERNAL dispatch)
     */
    HYBRID: 'HYBRID',
};

/**
 * App Library providing support for application events.
 *
 * Depending on the {@link app.ui.event.implementation} value, this may use internal callbacks, {@link CustomEvent}, or both.
*/
app.ui.event = {

    /**
     * @type event_implementations
     * @private
     */
    implementation: event_implementations.HYBRID,

    /**
     * A record of 'INTERNAL' mode callbacks for event listeners
     * @type {object}
     * @private
     */
    internalListeners:{

    },

    /**
     * Retrieve the full name of an app event
     * @param name the name of the app event
     * @returns {string} the full name of the app event to use in native events, etc.
     * @private
     */
    _name:function (name){
        return 'app-'+name;
    },


    /**
     * Attach an event handler using the implementation-defined method. (DOM Event or Internal Callback)
     * @param name the name of the event to handle
     * @param handler the handler callback function
     * @private
     */
    _attach(name,handler){
        if(this.implementation === event_implementations.INTERNAL || this.implementation === event_implementations.HYBRID){
            if(typeof this.internalListeners[name]==='undefined') this.internalListeners[name]=[];
            this.internalListeners[name].push(handler);
        }
        if(this.implementation === event_implementations.DOM){
            return window.addEventListener(name,handler);
        }
    },

    /**
     * Extends a {@link CustomEvent} with additional methods and information about propagation and preventdefault.
     * @param {CustomEvent} event a custom event
     * @returns {InternalCustomEvent} the extended event
     * @private
     */
    _extendEvent(event){

        event.__stopPropagation = event.stopPropagation;
        event.isPropagationStopped=false;
        event.stopPropagation=function(){
            this.isPropagationStopped=true;
            event.__stopPropagation();
        }

        event.__stopImmediatePropagation = event.stopImmediatePropagation;
        event.isImmediatePropagationStopped=false;
        event.stopImmediatePropagation=function(){
            this.isImmediatePropagationStopped=true;
            event.__stopImmediatePropagation();
            event.stopPropagation();
        }


        event.__preventDefault = event.preventDefault;
        event.isDefaultPrevented=false;
        event.preventDefault=function(){
            this.isDefaultPrevented=true;
            event.__preventDefault();
        }


        return event;
    },

    /**
     * Dispatches an app event using the implementation-defined method of notifying handlers (DOM Event or Callback).
     *
     * This method waits for all possible listeners (if they are async callbacks) before resolving.
     *
     * @param {CustomEvent} event the event to notify handlers of
     * @returns {Promise<boolean>} yields true or false depending on whether the default action as not been prevented (see {@link CustomEvent.preventDefault}
     * @private
     */
    async _dispatchAsync(event){
        let name = event.type;
        if(name==='app-fire-event') this._dummyhandler(event.detail,event);
        if(this.implementation === event_implementations.INTERNAL || this.implementation === event_implementations.HYBRID){
            let ievent = this._extendEvent(event);
            let listeners = this.internalListeners[name]??[];
            for(let listener of listeners){
                //if(name!=="app-fire-event") console.debug('   EVT awaiting0',name)
                await listener(ievent);
                //if(name!=="app-fire-event") console.debug('   EVT finished0',name)
                if(ievent.isImmediatePropagationStopped) break;
            }
            let result = !ievent.isDefaultPrevented;
            if(name!=="app-fire-event") console.debug('  EVT finishedAll',name,result,typeof result)
            return result;
        }
        if(this.implementation === event_implementations.DOM || this.implementation === event_implementations.HYBRID){
            return await window.dispatchEvent(event);
        }
    },

    /**
     * Dispatches an app event using the implementation-defined method of notifying handlers (DOM Event or Callback).
     *
     * This method does not perform any asynchronous waiting for listeners - any callbacks are called synchronously.
     *
     * This method is provided for backwards-compatibility.
     * In testing, synchronous callbacks sometimes would not complete before {@link _dispatchAsync} continued, while omitting the 'await' would allow synchronous processing.
     * However, using all Async events is preferred when the order of events must be maintained.
     *
     *
     * @param {CustomEvent} event the event to notify handlers of
     * @returns {Promise<boolean>} yields true or false depending on whether the default action as not been prevented (see {@link CustomEvent.preventDefault}
     * @private
     */
    _dispatchLegacy(event){
        let name = event.type;
        if(name==='app-fire-event') this._dummyhandler(event.detail,event);
        if(this.implementation === event_implementations.INTERNAL || this.implementation === event_implementations.HYBRID){
            let ievent = this._extendEvent(event);
            let listeners = this.internalListeners[name]??[];
            for(let listener of listeners){
                //if(name!=="app-fire-event") console.debug('   EVT awaiting0',name)
                listener(ievent);
                //if(name!=="app-fire-event") console.debug('   EVT finished0',name)
                if(ievent.isImmediatePropagationStopped) break;
            }
            let result = !ievent.isDefaultPrevented;
            if(name!=="app-fire-event") console.debug('  EVT finishedAll',name,result,typeof result)
            return result;
        }
        if(this.implementation === event_implementations.DOM || this.implementation === event_implementations.HYBRID){
            return window.dispatchEvent(event);
        }
    },

    /**
     * Dispatches a custom application event synchronously.
     *
     * Note: any asynchronous handlers will not waited-on.
     * @param name name of the event (this will be prefixed in actual events)
     * @param data data to send with the event
     * @param cancelable whether the event should be cancelable
     * @returns {UIEventResult|null} the result of the event, if any
     */
    fire: function (name,data=null,cancelable=true){
        let eventEvent = new CustomEvent(app.ui.event._name("fire-event"), {detail:{name:name,detail:data,firedevent:true},cancelable:cancelable});
        let event = new CustomEvent(app.ui.event._name(name), {detail:data,cancelable:cancelable});
        if(!  this._dispatchLegacy(eventEvent)) return null;
        return {event:event, accepted:  this._dispatchLegacy(event), metaEvent:eventEvent};
    },

    /**
     * Dispatches a custom application event asynchronously.
     *
     * Note: synchronous handlers may not be waited-on properly due to quirk with async/await.
     * @param name name of the event (this will be prefixed in actual events)
     * @param data data to send with the event
     * @param cancelable whether the event should be cancelable
     * @returns Promise<UIEventResult|null> yields the result of the event, if any
     */
    fire_async:async function (name,data=null,cancelable=true){
        let eventEvent = new CustomEvent(app.ui.event._name("fire-event"), {detail:{name:name,detail:data,firedevent:true},cancelable:cancelable});
        let event = new CustomEvent(app.ui.event._name(name), {detail:data,cancelable:cancelable});
        if(! await this._dispatchAsync(eventEvent)) return null;
        return {event:event, accepted:  await this._dispatchAsync(event), metaEvent:eventEvent};
    },

    /**
     * Dispatches a custom application event with multiple arguments given as parameters. These can be handled as parameters with handle_args.
     *
     * Note: synchronous handlers may not be waited-on properly due to quirk with async/await.
     * @param name name of the event (this will be prefixed in actual events)
     * @param args
     * @returns Promise<UIEventResult|null> yields the result of the event, if any
     */
    fire_args_async:async function (name,...args){
        let eventEvent = new CustomEvent(app.ui.event._name("fire-event"), {detail:{name:name,detail:args,firedevent:true},cancelable:true});
        let event = new CustomEvent(app.ui.event._name(name), {detail:args});
        if(! await this._dispatchAsync(eventEvent)) return null;

        //if(!window.dispatchEvent(eventEvent)) return false;
        return {event:event, accepted:  await this._dispatchAsync(event), metaEvent:eventEvent};
    },

    /**
     * Dispatches a custom application event with multiple arguments given as parameters. These can be handled as parameters with handle_args.
     *
     * Note: any asynchronous handlers will not waited-on.
     * @param name name of the event (this will be prefixed in actual events)
     * @param args
     * @returns {UIEventResult|null} the result of the event, if any
     */
    fire_args: function (name,...args){
        let eventEvent = new CustomEvent(app.ui.event._name("fire-event"), {detail:{name:name,detail:args,firedevent:true},cancelable:true});
        let event = new CustomEvent(app.ui.event._name(name), {detail:args});
        if(!  this._dispatchLegacy(eventEvent)) return null;

        //if(!window.dispatchEvent(eventEvent)) return false;
        return {event:event, accepted:   this._dispatchLegacy(event), metaEvent:eventEvent};
    },

    /**
     * Registers a listener for the Application/UI Event
     * @param {string|string[]} name name of the event
     * @param {UIEventHandler} handler handler function for the event
     */
    handle:function (name,handler){
        console.debug('EVT-REG',name);
        if(name==="filetracker:files-found") console.trace();
        if(Array.isArray(name)){//support listening to multiple events
            for(let eventname of name){
                app.ui.event.handle(eventname,handler);
            }
            return;
        }

        name = app.ui.event._name(name);
        this._attach(name,async function(e){
            let name_ = name;
            let cb = handler;
            if(Array.isArray(e.detail)){
                //if(name!=="app-fire-event") console.debug('    EVT awaiting',name,cb)
                await cb(e.detail,name_,...e.detail,e);//fill out detail - await
                //if(name!=="app-fire-event") console.debug('    EVT finished',name,cb)
            }else{
                //if(name!=="app-fire-event") console.debug('    EVT awaiting',name,cb)
                await cb(e.detail,name_,e);
                //if(name!=="app-fire-event") console.debug('    EVT finished',name,cb)
            }
        })
    },

    handle_args:function (name,handler){
        console.debug('EVT-REG',name);
        name = app.ui.event._name(name);
        this._attach(name,async function(e){
            let name_ = name;
            let cb = handler;
            if(Array.isArray(e.detail)){
                await cb(...e.detail,name_,e);
            }else{
                await cb(e.detail,name_,e);
            }
        })
    },

    /**
     * Creates a Promise which is resolved when the specified events are all fired.
     * @param {string|string[]} eventnames the name of an app event or array of names.
     * @returns {Promise<UIEventObject>|Promise<UIEventObject[]>} A promise yielding the result of the event or an array with the results of all of the events.
     */
    promise:function (eventnames) {
        if (Array.isArray(eventnames)) {
            let promises = [];
            for(let eventname of eventnames){
                promises.push( app.ui.event.promise(eventname));
            }
            return Promise.all(promises);
        } else {
            let eventname = eventnames;
            let promise = new Promise(function (resolve, reject) {
                app.ui.event.handle(eventname, function (details, eventname_) {
                    let resolve_ = resolve;
                    let reject_ = reject;

                    resolve_({details: details, name: eventname_});

                })
            });
            return promise;
        }
    },

    /**
     * waits for multiple events to be received before calling a handler function.
     * The event sent to the handler is always the first one in the list.
     *
     * Implemented using {@link app.ui.event.promise}
     * @param {string[]} eventList
     * @param {UIEventHandler} handler
     */
    waiton:function (eventList, handler){
        let promise = app.ui.event.promise(eventList).then(
            /**
             * @param {UIEventObject[]|UIEventObject} eventObject
             */
            function(eventObject){
                //console.log("promise event list",eventObject);
                if(Array.isArray(eventObject)) eventObject = eventObject[0];
                let handler_ = handler;
                handler_(eventObject.detail,eventObject.name);
            }
        )
        return promise;
    },

    /**
     * An event handler that prints debug messages when an event is fired.
     * @param details
     * @param eventname
     * @returns {*}
     * @private
     */
    _dummyhandler:function (details,eventname){
        // noinspection UnreachableCodeJS
        if(details && details.firedevent) return app.ui.event._dummyhandler(details.detail,details.name);
        else console.debug("EVT-FIRED",this.implementation,eventname, details);
    }
}


/**
 * @typedef {function} UIEventHandler
 * @param {UIEventDetail} detail data object defined for the event
 * @param {string} name name of the event
 * @param {*} [param1] parameter from array event results
 * @param {*} [param2] parameter from array event results
 * @param {*} [param3] parameter from array event results
 * @param {*} [param4] parameter from array event results
 * @param {*} [param5] parameter from array event results
 */

/**
 * @typedef {object} UIEventWaiter
 * @property {UIEventHandler} callback
 * @property {UIEventHandler} handleEvent
 * @property {function(string[])} setup
 * @property {function(): UIEventWaiter} clone
 */

/**
 * @typedef {object} UIEventObject
 * @property {UIEventDetail} detail data object defined for the event
 * @property {string} name
 *
 */

/**
 * @typedef {object} UIEventDetail
 *
 */

/**
 * @typedef {object} UIEventResult
 * @property {CustomEvent} event the event dispatched
 * @property {boolean} accepted whether the event passed. False if preventDefault was called on the event.
 * @property {CustomEvent} metaEvent an event dispatched before the primary event
 */

/**
 * @typedef {CustomEvent} InternalCustomEvent
 * @property {boolean} isDefaultPrevented
 * @property {boolean} isImmediatePropagationStopped
 * @property {boolean} isPropagationStopped
 */
// noinspection CommaExpressionJS

app.ui.fixes = {
    init: function () {
        app.ui.fixes.detectBrowser();
        app.ui.fixes.polyfills();
    },
    detectBrowser: function(){
        var b = document.documentElement;
        b.setAttribute('data-useragent',  navigator.userAgent);
        b.setAttribute('data-platform', navigator.platform );
        $(function(){
            if(navigator.userAgent.indexOf('Trident/')!==-1) $('body').addClass('no-fa-support trident');
        });
    },
    fixJSTreeCSPErrors:function(){
        if(typeof jQuery.jstree!=='undefined') jQuery.jstree.defaults.core.worker=false;
    },
    fixTrace_IE11:function(){
        let oldtrace = window.console.trace;
        this.oldtrace = oldtrace;
        if(window.console.trace.toString().indexOf('__BROWSERTOOLS_CONSOLE_TRACE')!==-1){
            //window.console.trace=function(){console.warn('Trace is disabled');}
            window.console.trace = function(){
                try{
                    oldtrace();
                }catch(e){
                    console.warn('trace failed with exception '+e.message+' @ '+e.lineNumber+' '+e.fileName);
                }
            }
        }
    },
    fixFA_IE11:function(){
        setInterval(function(){
            $('.no-fa-support span.fa').each(function(){
                let butParent = $(this).parents('button,.menuitem,.nav-menu-item').first();
                if(butParent.length && butParent.text().length) return; //don't auto-fill the text for FA icons which are inside a button with other text.


                let alt = $(this).data('fa-alt');
                if(typeof alt==="undefined" || alt===null || alt==="") {
                    function rep(this_,classname,text,alt){
                        if($(this_).is('[class*='+$.escapeSelector(classname)+']')) alt=text;
                        if($(this_).hasClass($.escapeSelector(classname))) alt=text;
                        return alt;
                    }
                    alt = rep(this,'fa-times','[X]',alt);
                    alt = rep(this,'fa-trash','[X]',alt);
                    alt = rep(this,'fa-plus','[+]',alt);
                    alt = rep(this,'fa-filter','[Adv.]',alt);
                    alt = rep(this,'fa-file','[File]',alt);
                    alt = rep(this,'fa-list','[...]',alt);
                    alt = rep(this,'fa-sort-up','[^]',alt);
                    alt = rep(this,'fa-sort-down','[V]',alt);
                    if($(this).hasClass('fa-sort')) alt='[-]';
                }
                //TODO: check if sibling has text, don't show default alt text if it does.
                if(typeof alt==="undefined" || alt===null || alt==="") {
                    $(this).addClass('d-none');
                }
                $(this).text(alt);
            });
        },500);
    },
    polyfills: function () {
        app.ui.fixes.polyfillReplaceAll();
        app.ui.fixes.polyfillPromises();
        app.ui.fixes.polyfillCustomEvents();
        app.ui.fixes.fixTrace_IE11();

        if(typeof Promise.any==='undefined'){//new Promise.any feature that allows racing multiple promises - resolves when the first promise resolves.
            Promise.any = function (...promises){
                return new Promise((resolve,reject)=>{
                    try{
                        for(let promise of promises){
                            promise.then((v)=>resolve(v),()=>{});
                        }
                        reject(undefined);
                    }catch(ex){
                        reject(ex);
                    }
                })
            }
        }

        if(typeof String.prototype.substr==='undefined'){//unlikely to ever be removed but polyfill just in case since it's not accepted standard.
            String.prototype.substr = function(start,length){
                return this.substring(start<0?this.length+start:start,start+length);
            }
        }

        if(typeof Array.prototype.group==='undefined'){
            /**
             * Groups the elements of the calling array according to the string values returned by a provided testing function. The returned object has separate properties for each group, containing arrays with the elements in the group.
             *
             * [Experimental ES6/FF104 - as of 2022-07-08]
             * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/group
             * @param {ArrayGroupCallback} func Function to execute on each element in the array. In the form func(element,[index,[array]): keystring
             * @param {any} thisArg Object to use as `this` inside callbackFn.
             * @returns {object} An Object with properties for all groups, each assigned to an array containing the elements of the associated group. The value is an object that does not inherit from Object.prototype
             */
            Array.prototype.group=function(func,thisArg=undefined){
                let groups = Object.create(null);//"The value is an object that does not inherit from Object.prototype"
                for(let i=0;i<this.length;i++){
                    let groupkeyRaw = func.call(thisArg,this[i],i,this);
                    // if(typeof groupkeyRaw==='undefined') continue;//the key returned was undefined, skip this - not a standards compliant behavior
                    let groupkey = "" + groupkeyRaw; //"It must be possible to coerce this returned callback value into a string"
                    if(typeof groups[groupkey]==='undefined') groups[groupkey]=[]; // "[the callback value] then will be used as a property name in the final returned object"
                    groups[groupkey].push(this[i]);
                }
                return groups;
            }
        }

        if(typeof Math.trunc==='undefined'){
            Math.trunc=function(num){
                if(num>=0) return Math.floor(num);
                return Math.ceil(num);
            }
        }

        /**
         *
         * @returns {Array}
         */
        Array.prototype.popValue=function(v){
            let found = this.indexOf(v);
            if(found!==-1){
                return this.splice(found,1)[0];
            }
        };

        /**
         *
         * @returns {Array}
         */
        Array.prototype.sortNumerically=function(){
            return this.sort(function(a,b){
                return a-b;
            })
        };

        String.prototype.reverse = function reverse() {// [custom] creates a new string which is reversed compared to the given string
            for (var i = this.length - 1, o = ''; i >= 0; o += this[i--]) { }
            return o;
        }

        Array.prototype.uniq = function uniq(){// [custom] creates a new array containing only unique elements from the given array. Will be sorted by value and only uses basic equivalence (===)
            return [...new Set(this)];

            //return this.sort().filter(function(elem,idx,arr){
            //    return !idx || elem !== arr[idx-1];
            //});
        }

        /**
         * Operates like {@link Function.prototype.bind}, except that the calling scope's `this` value is passed as the first argument.
         *
         * That way, you can work with both a specific `this` and the calling `this` at the same time without needing to write a wrapper.
         *
         * @param boundThis the value to set as the 'this' value of the called function
         * @param [boundArgs] the arguments to provide after the 'this' value of the calling scope.
         */
        Function.prototype.bindEx = function bindEx(boundThis,...boundArgs){
            let _function = this;
            return function(...args){
                let _caller = this;
                let func = _function.bind(boundThis,_caller,...boundArgs);
                return func(...args);
            };
        }

        String.prototype.hashCode = function() {
            var hash = 0, i, chr;
            if (this.length === 0) return hash;
            for (i = 0; i < this.length; i++) {
                chr   = this.charCodeAt(i);
                hash  = ((hash << 5) - hash) + chr;
                hash |= 0; // Convert to 32bit integer
            }
            return hash;
        };


    },
    _toggleDropdown:function(jqMenuItem, newstate=null){
        if(newstate===null){
            let state = jqMenuItem.hasClass('show');
            newstate = !state;
            //console.log("existing menu state",state,newstate);
        }
        let menu = $(jqMenuItem).children('.dropdown-menu');

        //console.log("setting menu state",newstate,menu,jqMenuItem);
        $(jqMenuItem).toggleClass('show',newstate);
        menu.toggleClass('show',newstate);//only get immediate dropdown menu

    },
    _closeChildDropdowns:function(jqMenuItem){
        //console.log("closing child dropdowns {")
        $(jqMenuItem).find('.dropdown.show').each(function(){
            app.ui.fixes._toggleDropdown(this,false);
        })
        //console.log("} child")
    },
    _closeUnrelatedDropdowns:function(jqMenuItem){
        let subject_elem = $(jqMenuItem)[0];
        //console.log("closing unrelated dropdowns {")
        $('.dropdown.show').each(function(){
            if(!this.isSameNode(subject_elem) && !this.contains(subject_elem)){
                app.ui.fixes._toggleDropdown(this,false);
            }
        })
        //console.log("} unrel")
    },
    _getMenuitemFromChild:function(subject_elem){
        subject_elem = $(subject_elem);
        if(subject_elem.is('.nav-link')) subject_elem = subject_elem.parent(); //need the menu container (li, span, div), not the link
        return subject_elem;
    },
    fixNestedDropdowns: function () {
        $('body').click(function(e){
            let target = e.target;
            app.ui.fixes._closeUnrelatedDropdowns($(target));
        });

        $('.dropdown').not('.fixed-nested-handler').click(function (e) {
            $(this).addClass('fixed-nested-handler');
            e.stopPropagation();

            let target = e.target;
            if(!$(e.target).hasClass('dropdown-toggle')){
                target = $(target).parents('.dropdown-toggle').first();
            }

            if(!$(target).hasClass('dropdown-toggle')) return; //don't toggle the menu if we didn't click the toggler, but still prevent propagation to higher menus
            e.preventDefault();

            //console.log(" clicked dropdown",e,this)
            let menu_item = app.ui.fixes._getMenuitemFromChild(this);
            app.ui.fixes._closeUnrelatedDropdowns(menu_item);
            app.ui.fixes._closeChildDropdowns(menu_item);
            app.ui.fixes._toggleDropdown(menu_item);

        })
    },
    fixCheckboxValues: function () {
//	console.log("CHECKBOXES");
        $("input[type=checkbox]").each(function () {
//		console.log(" CHECKBOX",this,$(this));
            if (typeof $(this).val() === "undefined" || $(this).val() === "" || $(this).val() === "on") {
                $(this).val(1);
            } else {
//			console.log("  NA",$(this).val())
            }
        });
    },
    fixInputNames() {
        $("input,select,textarea").each(function () {
            if (typeof $(this).prop('name') === "undefined" || $(this).prop('name') === "") {
                $(this).prop('name', $(this).prop('id'));
            }
        });
    },

    changeTabPaneSelection:function(tabePaneID){
        $(".tab-content .tab-pane").each(function () {
            var y = $(this).attr("id");
            // noinspection EqualityComparisonWithCoercionJS
            if (tabePaneID == y) $(this).addClass("active show");
            else $(this).removeClass("active show");
        });
    },
    deselectTabs:function(){
        $(".nav-tabs .nav-link").each(function () {
            var y = $(this).data("bs-target");
            if (typeof y === "undefined") y = "null";
            y = y.replace("#", "");
            //if(x===y) $(this).addClass("active");
            //else $(this).removeClass("active");
            $(this).removeClass("active");
            $(this).parent().removeClass('active-tab');
        });
    },
    markTabSelected:function(tabElem){
        $(tabElem).addClass("active");
        $(tabElem).parent().addClass('active-tab');
    },

    makeFontAwesomeIconsFixedWidth:function(){
        $(".fa-solid,.fa-regular,.fa,.fa-light,.fa-thin,.fa-duotone").not(".no-fw,button").addClass('fa-fw');//Fix fontawesome icon widths by default
    },

    fixTabs: function () {
        /* fix for tabs not working in BS4 for some reason */
        return $(".nav-tabs .nav-link").click(function () {
            //console.log("Clicked",$(this))
            var x = $(this).data("bs-target");
            if (typeof x === "undefined") x = "null";
            x = x.replace("#", "");
            app.ui.fixes.changeTabPaneSelection(x);
            app.ui.fixes.deselectTabs();
            app.ui.fixes.markTabSelected(this);
            /*
            $(".tab-content .tab-pane").each(function () {
                var y = $(this).attr("id");
                // noinspection EqualityComparisonWithCoercionJS
                if (x == y) $(this).addClass("active show");
                else $(this).removeClass("active show");
            });
            $(".nav-tabs .nav-link").each(function () {
                var y = $(this).data("bs-target");
                if (typeof y === "undefined") y = "null";
                y = y.replace("#", "");
                //if(x===y) $(this).addClass("active");
                //else $(this).removeClass("active");
                $(this).removeClass("active");
                $(this).parent().removeClass('active-tab');
            });
            //console.log(this);
            $(this).addClass("active");
            $(this).parent().addClass('active-tab');
            //console.log(this);*/
        });
    },

    polyfillReplaceAll:function(){
      if(typeof String.prototype.replaceAll==="undefined") String.prototype.replaceAll = String.prototype.replace;
    },

    polyfillCustomEvents:function(){
        //CustomEvent
        (function () {
            if (typeof window.CustomEvent === "function") return false; //If not IE

            function CustomEvent(event, params) {
                params = params || {bubbles: false, cancelable: false, detail: undefined};
                var evt = document.createEvent('CustomEvent');
                evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
                return evt;
            }

            CustomEvent.prototype = window.Event.prototype;

            window.CustomEvent = CustomEvent;
        })();
    },


    polyfillPromises:function(){
//Promise
        !function (e, t) {
            // noinspection JSUnresolvedFunction
            "object" == typeof exports && "undefined" != typeof module ? t() : "function" == typeof define && define.amd ? define(t) : t()
        }(0, function () {
            "use strict";

            function e(e) {
                var t = this.constructor;
                return this.then(function (n) {
                    return t.resolve(e()).then(function () {
                        return n
                    })
                }, function (n) {
                    return t.resolve(e()).then(function () {
                        return t.reject(n)
                    })
                })
            }

            function t(e) {
                return new this(function (t, n) {
                    function o(e, n) {
                        if (n && ("object" == typeof n || "function" == typeof n)) {
                            var f = n.then;
                            if ("function" == typeof f) return void f.call(n, function (t) {
                                o(e, t)
                            }, function (n) {
                                // noinspection EqualityComparisonWithCoercionJS,CommaExpressionJS
                                r[e] = {status: "rejected", reason: n}, 0 == --i && t(r)
                            })
                        }
                        // noinspection EqualityComparisonWithCoercionJS,CommaExpressionJS
                        r[e] = {status: "fulfilled", value: n}, 0 == --i && t(r)
                    }

                    if (!e || "undefined" == typeof e.length) return n(new TypeError(typeof e + " " + e + " is not iterable(cannot read property Symbol(Symbol.iterator))"));
                    var r = Array.prototype.slice.call(e);
                    if (0 === r.length) return t([]);
                    for (var i = r.length, f = 0; r.length > f; f++) o(f, r[f])
                })
            }

            function n(e) {
                return !(!e || "undefined" == typeof e.length)
            }

            function o() {
            }

            function r(e) {
                if (!(this instanceof r)) throw new TypeError("Promises must be constructed via new");
                if ("function" != typeof e) throw new TypeError("not a function");
                this._state = 0, this._handled = !1, this._value = undefined, this._deferreds = [], l(e, this)
            }

            function i(e, t) {
                for (; 3 === e._state;) e = e._value;
                0 !== e._state ? (e._handled = !0, r._immediateFn(function () {
                    var n = 1 === e._state ? t.onFulfilled : t.onRejected;
                    if (null !== n) {
                        var o;
                        try {
                            o = n(e._value)
                        } catch (r) {
                            // noinspection JSVoidFunctionReturnValueUsed
                            return void u(t.promise, r)
                        }
                        f(t.promise, o)
                    } else (1 === e._state ? f : u)(t.promise, e._value)
                })) : e._deferreds.push(t)
            }

            function f(e, t) {
                try {
                    if (t === e) { // noinspection ExceptionCaughtLocallyJS
                        throw new TypeError("A promise cannot be resolved with itself.");
                    }
                    if (t && ("object" == typeof t || "function" == typeof t)) {
                        var n = t.then;
                        if (t instanceof r) { // noinspection JSVoidFunctionReturnValueUsed
                            return e._state = 3, e._value = t, void c(e);
                        }

                        if ("function" == typeof n) { // noinspection JSVoidFunctionReturnValueUsed
                            return void  l(function (e, t) {
                                                        return function () {
                                                            e.apply(t, arguments)
                                                        }
                                                    }(n, t), e)
                        }
                    }
                    e._state = 1, e._value = t, c(e)
                } catch (o) {
                    u(e, o)
                }
            }

            function u(e, t) {
                e._state = 2, e._value = t, c(e)
            }

            function c(e) {
                2 === e._state && 0 === e._deferreds.length && r._immediateFn(function () {
                    e._handled || r._unhandledRejectionFn(e._value)
                });
                for (var t = 0, n = e._deferreds.length; n > t; t++) i(e, e._deferreds[t]);
                e._deferreds = null
            }

            function l(e, t) {
                var n = !1;
                try {
                    e(function (e) {
                        n || (n = !0, f(t, e))
                    }, function (e) {
                        n || (n = !0, u(t, e))
                    })
                } catch (o) {
                    if (n) return;
                    n = !0, u(t, o)
                }
            }

            var a = setTimeout;
            r.prototype["catch"] = function (e) {
                // noinspection JSUnresolvedFunction
                return this.then(null, e)
            }, r.prototype.then = function (e, t) {
                var n = new this.constructor(o);
                return i(this, new function (e, t, n) {
                    this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.promise = n
                }(e, t, n)), n
            }, r.prototype["finally"] = e, r.all = function (e) {
                return new r(function (t, o) {
                    function r(e, n) {
                        try {
                            if (n && ("object" == typeof n || "function" == typeof n)) {
                                var u = n.then;
                                if ("function" == typeof u) return void u.call(n, function (t) {
                                    r(e, t)
                                }, o)
                            }
                            // noinspection EqualityComparisonWithCoercionJS
                            i[e] = n, 0 == --f && t(i)
                        } catch (c) {
                            o(c)
                        }
                    }

                    if (!n(e)) return o(new TypeError("Promise.all accepts an array"));
                    var i = Array.prototype.slice.call(e);
                    if (0 === i.length) return t([]);
                    for (var f = i.length, u = 0; i.length > u; u++) r(u, i[u])
                })
            }, r.allSettled = t, r.resolve = function (e) {
                return e && "object" == typeof e && e.constructor === r ? e : new r(function (t) {
                    t(e)
                })
            }, r.reject = function (e) {
                return new r(function (t, n) {
                    n(e)
                })
            }, r.race = function (e) {
                return new r(function (t, o) {
                    if (!n(e)) return o(new TypeError("Promise.race accepts an array"));
                    for (var i = 0, f = e.length; f > i; i++) r.resolve(e[i]).then(t, o)
                })
            }, r._immediateFn = "function" == typeof setImmediate && function (e) {
                setImmediate(e)
            } || function (e) {
                a(e, 0)
            }, r._unhandledRejectionFn = function (e) {
                void 0 !== console && console && console.warn("Possible Unhandled Promise Rejection:", e)
            };
            var s = function () {
                if ("undefined" != typeof self) return self;
                if ("undefined" != typeof window) return window;
                if ("undefined" != typeof global) return global;
                throw Error("unable to locate global object")
            }();
            "function" != typeof s.Promise ? s.Promise = r : s.Promise.prototype["finally"] ? s.Promise.allSettled || (s.Promise.allSettled = t) : s.Promise.prototype["finally"] = e
        });
    }
};

app.ui.fixes.init();

/**
 * @callback ArrayGroupCallback
 * @description Function to execute on each element in the array. The returned value will be the key of each array grouping.
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/group
 * @param {any} element The value of the current element in the array.
 * @param {int} [index] The index (position) of the current element in the array.
 * @param {array} [array] The array that group() was called on.
 * @returns {string} The object returned from the callback indicates the group of the current element. It must be possible to coerce this returned callback value into a string (which will then be used as a property name in the final returned object).
 */
app.ui.jquery={
    setup:function(jQuery){

        jQuery.fn.data2 = function(key,value){
            if(typeof key==='undefined') return $(this).data();//no params
            if(typeof value==='undefined'){//1 param
                if(typeof key==='object'){//set fields as object{key:value}
                    for(let [k,v] of Object.entries(key)) $(this).data2(""+k,v);
                }else{//an actual key
                    return $(this).data(key);
                }
            }else{//2 params
                $(this).data(key,value).attr('data-'+key,value);
            }
            return $(this);
        }


        jQuery.fn.clickDelayed = function (fn, delayMS) {
            let this_ = this;
            $(this_).click(function () {
                setTimeout(function () {
                    let fn_ = fn;
                    let this__ = this_;
                    fn.call(this__);
                }, delayMS);
            });
            return $(this);
        }
        jQuery.fn.flash = function (timeMs = 250,className='flash-highlight') {
            //console.log(Date.now(),"FLASH1",this)
            let this_ = this;
            $(this_).addClass(className);
            //console.log(Date.now(),"FLASH2",this)
            setTimeout(function () {
                //console.log(Date.now()," FLASH removing1");
                $(this_).removeClass(className);
                //console.log(Date.now()," FLASH removing2");
            }, timeMs);
            return $(this);
        }
        /** Gets or sets an element's value or text content (when it doesn't support a value) - App Extension Method*/
        jQuery.fn.tval = function (value) {
            let value_ = value;
            let valElems = 'input,select,textarea';
            if(typeof value==="undefined"){
                if($(this).is(valElems)) return $(this).val();
                else return $(this).text();
            }

            $(this).each(function () {
                let value__ = value_;
                if ($(this).is(valElems)) $(this).val(value__).flash();
                else $(this).text(value__).flash();
            });
            return $(this);
        }
        jQuery.fn.replaceWithTemplate = function (template_name, template_source_element_id = null, callback = null, finalId=null) {
            let load_params = '?v='+encodeURIComponent(window['APP_VERSION'] ?? 'unknown');
            if (!/^[a-zA-Z0-9_-]+$/g.test(template_name)) {
                console.warn('invalid template name', template_name);
                return;
            }
            if (template_source_element_id !== null && !/^[a-zA-Z0-9_-]+$/g.test(template_source_element_id)) {
                console.warn('invalid source id', template_source_element_id);
                return;
            }
            let load_shorthand = "templates/" + encodeURIComponent(template_name) + ".html"+load_params;

            let hasTargetSelector = false;
            let targetSelector = "";


            if (template_source_element_id !== null) {
                targetSelector = '#' + $.escapeSelector(template_source_element_id);
                hasTargetSelector = true;
            }

            if (hasTargetSelector) load_shorthand += ' ' + targetSelector;




            //console.log(" loading template replacement",template_name, hasTargetSelector, targetSelector, ':', load_shorthand, this,callback,finalId);

            let this_ = this;


            let createLoadHandlerWithoutTargetSelector = function(this_,callback,resolve){
                return function () {
                    //console.log("  replacing with template (1): dest",template_name, this_, "cont", this, "loaded", $(this).contents());
                    $(this_).replaceWith($(this).contents());
                    if (callback != null) callback.call(this_);
                    resolve(this_);
                };
            };

            let createLoadHandlerWithTargetSelector = function(this_,callback,resolve,finalId=null){
                return function () {
                    //console.log("  replacing with template (2): dest",targetSelector,template_name, this_, "cont", this, "loaded", $(this).find(targetSelector));
                    let el = $(this).find(targetSelector);
                    if(finalId!==null) el.attr('id',finalId);
                    $(this_).replaceWith(el);
                    if (callback != null) callback.call(this_);
                    resolve(this_);
                };
            };

            let promiseHandler = (function(load_shorthand,targetSelector,this_,callback){
                return (resolve, reject) => {
                    if (!hasTargetSelector) {
                        $("<div>").load(load_shorthand, createLoadHandlerWithoutTargetSelector(this_,callback,resolve));
                    } else {
                        $("<div>").load(load_shorthand, createLoadHandlerWithTargetSelector(this_,callback,resolve,finalId));
                    }
                };
            })(load_shorthand,targetSelector,this_,callback);



            return new Promise(promiseHandler);
        }

        jQuery.fn.forceShow_saveClass = function (saveddisplay) {
            if (saveddisplay === "none") return $(this);
            $(this).data('fsdisplaystate', saveddisplay);
            return $(this);
        }
        jQuery.fn.forceShow_loadClass = function () {
            return $(this).data('fsdisplaystate');
        }
        jQuery.fn.forceShow_calculateClass = function () {
            return $(this).css('display');
        }


        jQuery.fn.forceHide_single = function () {
            let saveddisplay = $(this).forceShow_calculateClass();
            if (saveddisplay === "none") return;
            $(this).forceShow_saveClass(saveddisplay);

            let classn = 'd-' + $.escapeSelector(saveddisplay);
            //console.log("forceHide", classn, 'd-none', this);
            $(this).removeClass(classn);
            $(this).addClass('d-none');
            return $(this);
        }
        jQuery.fn.forceShow_single = function () {
            let currentdisplay = $(this).forceShow_calculateClass();
            if (currentdisplay !== "none") return;
            let saveddisplay = $(this).forceShow_loadClass();

            //console.log("forceShow-pre", saveddisplay, currentdisplay);
            saveddisplay = saveddisplay ? saveddisplay : "block";

            $(this).removeClass('d-none');
            let classn = 'd-' + $.escapeSelector(saveddisplay);
            //console.log("forceShow", 'd-none', classn, this);
            if (!$(this).hasClass(classn)) $(this).addClass(classn);
            return $(this);
        }
        jQuery.fn.forceHide = function () {
            $(this).each(function () {
                $(this).forceHide_single()
            });
            return $(this);
        }
        jQuery.fn.forceShow = function () {
            $(this).each(function () {
                $(this).forceShow_single()
            });
            return $(this);
        }
        jQuery.fn.serializeObject = function (supportMultipleArrayValues=false) {
            let fields = {};
            let fieldentries = $(this).serializeArray();
            for (let entry of fieldentries) {
                if(supportMultipleArrayValues && entry.name.endsWith('[]')){
                    let basename = entry.name.substr(0,entry.name.length-2);
                    if(typeof fields[basename]==='undefined') fields[basename]=[];
                    fields[basename].push(entry.value);
                }else{
                    fields[entry.name] = entry.value;
                }
            }
            return fields;
        }


        jQuery.fn.forceShowState = function (state) {
            if (state) $(this).forceShow();
            else $(this).forceHide();
            return $(this);
        }
        jQuery.fn.showState = function (state) {
            if (state) $(this).show();
            else $(this).hide();
            return $(this);
        }

        jQuery.fn.removeAnim = function () {
            $(this).each(function () {
                $(this).hide('fast', function () {
                    $(this).remove();
                });
            })
            return $(this);
        }
        jQuery.fn.appendAnim = function (elem) {
            $(elem).hide();
            $(this).append(elem);
            $(elem).show('fast');
            return $(this);
        }


        jQuery.fn.clickLoad = function (fn, delayMS = 50, delayMS2 = 50) {
            //console.log("SETTING CLICKLOAD")
            $(this).click(function () {
                let this_ = this;
                //console.log(" CALLING CLICKLOAD1",this,this_);
                app.ui.overlay.show("click-load");
                setTimeout(async function () {
                    let fn_ = fn;
                    let d2 = delayMS2;
                    let this__ = this_;
                    //console.log("  CALLING CLICKLOAD2",this,this_,this__);
                    await fn_.call(this__);
                    setTimeout(function () {
                        //console.log("   CALLING CLICKLOAD3",this,this_,this__);
                        app.ui.overlay.hide("click-load");
                    }, d2);
                }, delayMS);
            });
            return $(this);
        }

        jQuery.fn.slideOffscreen = function(disposition='to',direction='left',duration=500,elemDelay=0){
            let propa='left',propb='right';
            let viewportdim = window.innerWidth;
            let sign = -1;
            switch(direction){
                case 'down':
                    sign*=-1;
                // noinspection FallThroughInSwitchStatementJS
                case 'up':
                    viewportdim = window.innerHeight;
                    propa='top';propb='bottom';
                    break;

                case 'right':
                    sign*=-1;
                // noinspection FallThroughInSwitchStatementJS
                case 'left':
                    break;
            }



            let offset = sign*viewportdim*1.25;

            propa='margin-'+propa;
            propb='margin-'+propb;
            //console.log('slide',direction,sign,viewportdim,offset);

            let props_from = {[propa]: '0px', [propb]: '0px'};
            let props_to = {[propa]: offset+'px', [propb]: (-offset)+'px'}
            if(disposition==='from'){
                [props_from,props_to] = [props_to,props_from];
                $(this).hide();
            }

            let promises=[];
            $(this).each(function(i,elem){
                let p = app.util.setTimeoutPromiseEx((resolve, reject) => {
                    $(this).stop().show().css(props_from).animate(props_to, {
                        duration: duration,
                        complete:function(){
                            if(disposition==='to') $(this).hide();
                            resolve({this:this,i:i});
                        }
                    })
                },i*elemDelay);
                promises.push(p);
            });
            return Promise.allSettled(promises);
        }


        jQuery.fn.findAllExcluding= function(exclude_selector,returnJqueryList=true,maxdepth=100,depth=0){
            let elements_dontincludetarget = [];//simple, elements that do not include the target element and can be selected outright
            let elements_doincludetarget = [];//complicated, elements that DO include the target element, but may have children which don't include this child
            if(depth<=maxdepth){
                $(this).children().each(function(index,element){
                    if($(element).is(exclude_selector) || $(element).find(exclude_selector).length){
                        elements_doincludetarget.push(element);
                    }else{
                        elements_dontincludetarget.push(element);
                    }
                });

                for(let element of elements_doincludetarget){
                    let children_notincluding = $(element).findAllExcluding(exclude_selector,false,maxdepth,depth+1);
                    elements_dontincludetarget = elements_dontincludetarget.concat(children_notincluding);
                }
            }
            if(!returnJqueryList) return elements_dontincludetarget;
            return $(elements_dontincludetarget);
        }

        jQuery.fn.finVal = function (value=null, considerEmptyZero=false) {
            if(typeof value ==="undefined" || value==null){
                return app.util.finance.stripSymbols(""+$(this).tval());
            }else{
                if(!considerEmptyZero && (value==="" || value===null)) $(this).tval("");
                else return $(this).tval(app.util.finance.addSymbols(value));
            }
        }

        jQuery.fn.selectOption = function(value,appendValue=false,allowDisabledOption=false,allowPlaceholderOnNull=true,allowPlaceholderOnBlank=false){
            let isMultipleOptions = Array.isArray(value);

            //console.log("SELECTOPTION",value);
            let wasValueNull = value===null;
            if(value===null) value="";//select options don't support null
            $(this).each(function () {
                let isMultiSelect = $(this).prop('multiple');

                let placeholders = $(this).find('option').filter('.placeholder-value'); //annotation error: this is jquery.filter not es5 array.filter
                let options = $(this).find('option');
                options.prop('selected',false);
                options.removeAttr('selected');
                if(!allowDisabledOption) options = options.not(':disabled');
                if(!allowPlaceholderOnBlank) options = options.not('.placeholder-value');
                let selected = 0;

                if(wasValueNull && allowPlaceholderOnNull){
                    //console.log('select find placeholder',value)
                    placeholders.first().prop('selected',true);
                    selected++;
                }else{
                    //console.log('select find option',value)

                    if(!isMultipleOptions) value = [value];//force the value to be an array element so we can iterate it the same as array values.

                    for(let valueI of value){
                        //console.log(' select find option I',valueI)
                        options.each(function(){
                            //console.log(" ? selected element",(""+$(this).val()));
                            if( (""+$(this).val()) === (""+valueI) ){
                                //console.log("selected element",this);
                                $(this).prop('selected',true);
                                selected++;
                            }
                        })
                    }

                }


                //console.log("selected",selected);
                if(selected===0 && appendValue){
                    if(!Array.isArray(value)) value = [value];
                    for(let valueI of value){
                        //console.log("select appending value",selected,valueI);
                        let disp = (valueI==="" || valueI===null) ? "(empty)" : valueI;
                        let opt = $('<option>').addClass('appended-option selected-value').val(valueI).text(disp);
                        opt.prop('selected',true);
                        $(this).append(opt);
                    }
                }
                $(this).flash();

            });
        }

    },
    filterEmptyInputs:function(){
        return (typeof this.value === "undefined") || this.value !== "";
    },
    _getDefaultValue:function(domElem){
        if (domElem.tagName === "INPUT" && (domElem.type === "radio" || domElem.type === "checkbox")) {
            //console.log("  check ",domElem.defaultChecked);
            if (domElem.defaultChecked) return $(domElem).val();
        } else if (domElem.tagName === "INPUT" && typeof domElem.defaultValue !== "undefined") {
            //console.log("  standard input");
            return domElem.defaultValue;
        } else if (domElem.tagName === "SELECT") {
            //console.log("  select");
            let options = $(domElem).find('option');
            for (let i = 0; i < options.length; i++) {
                let domOption = options[i];
                if (domOption.defaultSelected) return domOption.value;
            }
        }
        //console.log("  no known default value");

        return null;
    },
    filterDefaultInputs:function(){
        let defaultValue = app.ui.jquery._getDefaultValue(this);
        if (defaultValue === null) return true; //don't filter unsupported elements

        //console.log(" filter-default?",defaultValue,$(this).val())
        return $(this).val() !== defaultValue;
    },

};
app.ui.logoutNotifier={
    timer:null,
    expiresSoon: false,

    checkSeconds:10,
    logoutSoonSeconds: 60,

    setAppLoggedIn(v){
        app.data.values['auth_loggedin'] = v;
        window.auth_loggedin = v;
    },

    async keepalive(){//TODO: ping an API that forces session refresh.
        return await app.api.promiseNoThrow("auth.status.keepalive",{},true,false);
    },
    login(){
        document.location=app.shorturl("login.php");
    },

    /**
     *
     * @return {Promise<'logged-out'|'expires-soon'|'logged-in'|null>}
     */
    async check(){
        /** @type {APIStatusCheckResult} result */
        let result = await app.api.promiseNoThrow("auth.status.check",{},true,false);
        if(result===null || typeof result!=='object' || !result.now) return null; //if now is not defined, we want to skip showing messages.

        let loggedIn_page = !! (app.data.values['auth_loggedin']??0);
        let loggedIn_api = !! (result.loggedIn??0);
        if(loggedIn_page && !loggedIn_api) return "newly-logged-out";
        if(!loggedIn_page && loggedIn_api) return "newly-logged-in";

        if(loggedIn_page && loggedIn_api){
            if(loggedIn_api && result.expiresIn<=this.logoutSoonSeconds) return "logout-soon";
            if(result.expiresIn>this.logoutSoonSeconds) return "still-logged-in";
        }
        console.log("check",loggedIn_page,loggedIn_api,result)
        if(!loggedIn_page && !loggedIn_api) return "still-logged-out";
        return null;
    },

    async tick(){
        let allowLogout = undefined;
        let result = await this.check();
        console.log("auth check:",result);
        console.log("auth check:",result);
        switch(result){
            case "newly-logged-out":// hide confirmation, show error window (once?), reset expire-confirm indicator, change loggedout data
                //this.expiresSoon = false;
                this.setAppLoggedIn(0);
                if(app.ui.overlay) app.ui.overlay.confirm_hide(null);
                allowLogout = await app.ui.common.confirm("You have been signed out.\r\nPress Cancel to sign in again.",-1);
                if(allowLogout===null) allowLogout = true;
                if(!allowLogout) this.login();
                break;
            case "logout-soon":// show confirmation (once?), set expire-confirm indicator to prevent message showing again
                console.log(" auth check: logout-soon open?",this.expiresSoon);
                if(this.expiresSoon) return;//already showed the prompt this session.
                this.expiresSoon = true;
                let pallowLogout = app.ui.common.confirm("You are about to be signed out due to inactivity.\r\nPress Cancel to stay signed in.",-1);
                allowLogout = await pallowLogout;
                console.log(" auth check: logout-soon allowLogout?",pallowLogout,allowLogout);
                if(allowLogout===null) allowLogout = true;
                if(!allowLogout) await this.keepalive(); //ping an API that forces session refresh.
                break;
            case "newly-logged-in":// reset expire-confirm indicator, change loggedout data
                this.expiresSoon = false;
                this.setAppLoggedIn(1);
                break;
            case "still-logged-in":// reset expire-confirm indicator
                this.expiresSoon = false;
                break;
        }

    },

    start(intervalMS=null){
        if(intervalMS===null) intervalMS = this.checkSeconds*1000;
        this.timer = setInterval(this.tick.bind(this),intervalMS);
    },
    stop(){
        if(this.timer!==null) clearInterval(this.timer);
    }
}


/**
 * @typedef {APIRequestData} APIStatusCheckResult
 * @property {boolean} loggedIn
 * @property {int} now
 * @property {int} expiresIn
 */
class MenuDescriptor {
    constructor(shortname, text, categories, href = '#', icon = null, required=false, order=null) {
        //shortname = shortname.replaceAll(/-/g, '_');
        shortname = shortname.replaceAll(/[^a-zA-Z0-9._]/g,'_');
        this.shortname = shortname;
        this.text = text;
        this.href = href;
        this.categories = categories;
        this.icon = icon;
        this.required = required;
        this.order = order===null ? order : order*10;
    }
}

let ui = app.ui;

app.ui.nav = {
    condenseMenus: true,
    pruneMenus: true,
    condensePruneIterations:3,
    minimumSiblingCountCondenseExclusion: 1,
    condenseExcludeDepth:1,
    pruneExcludeDepth:1,

    /**
     * @var {MenuDescriptor[]} descriptors
     */
    descriptors: [],
    categories: [],

    /**
     * @var {Object|AnnotatedPathObject}
     */
    categoryPaths: {
        namespaces: [],
    },

    getCategoryByPath(namespace){
        return app.util.tree.getObjectPath(this.categoryPaths,namespace);
    },
    catSplit: function (categoryname) {
        return categoryname.split('/\./');
    },
    catsSplit: function (categorynames) {
        for (let i = 0; i < categorynames.length; i++) categorynames[i] = app.ui.nav.catSplit(categorynames[i]);
        return categorynames;
    },
    addRoots:function(basenamespaces){
        ui.event.fire('nav:beforeroots');
        for(let basenamespace of basenamespaces) app.ui.nav.addRoot(basenamespace);
        ui.event.fire('nav:afterroots');
    },
    addRoot:function(basenamespace){
        app.ui.nav.add(basenamespace,basenamespace,[null]);
    },
    add: function (shortname, text, categories = [], href = '#', icon = null, required=false, order=null) {
        //console.log("nav add",shortname,categories,required,order, typeof order);
        href = app.shorturl(href);
        ui.event.fire('nav:beforeadd:'+shortname);
        let md = new MenuDescriptor(shortname, text, categories, href, icon,required, order);
        app.ui.nav.descriptors.push(md);
        ui.event.fire('nav:afteradd:'+shortname);
        let ret = categories.slice().map((s)=>s+'.'+shortname);
        return ret;
    },
    hasElements:function(baseNamespace){
        return app.ui.nav.categoryPaths[baseNamespace].namespaces.length > 0;
    },


    /** @private */
    _generateCat(allcats,descriptor,order){
        //console.log("NAV GENERATE CAT",descriptor.categories, order,descriptor)
        allcats = allcats.concat(descriptor.categories);
        let cats = descriptor.categories;//cats.concat(descriptor.categories);
        for (let cat of cats) {

            let path = descriptor.shortname;
            if(cat !== null){
                cat = cat.replaceAll(/[^a-zA-Z0-9._]/g,'_');
                path = cat + "." + descriptor.shortname
            }


            //cat = cat.replaceAll('-', '_');
            let value = {hasdescriptor: true, descriptor: descriptor,required:descriptor.required,order:order};
            if(order!==null) value.order=order;

            app.util.tree.defineObjectPath(app.ui.nav.categoryPaths, path,
                value,
                {hasdescriptor: false, order: order});
            order++;
        }
        return allcats
    },

    _determineDescriptorOrdering(descriptors){
        let results={
            ordered:{},
            unordered:[],
            reservedOrderValues:[],
        };

        for (let descriptor of descriptors) {
            if((descriptor.order??null) !==null){
                //console.log(" ordered descriptor for generation",descriptor, descriptor.order)
                results.ordered[descriptor.order]=descriptor;
                results.reservedOrderValues.push(descriptor.order);
            }else{
                //console.log(" unordered descriptor for generation",descriptor,descriptor.order)
                results.unordered.push(descriptor);
            }
        }
        results.reservedOrderValues = results.reservedOrderValues.sortNumerically();
        //console.log('nav determined descriptor order:',results.ordered,results.unordered.length,results.reservedOrderValues);
        return results;
    },

    _generateLowReservedCats(descriptors, allcats){
        let lowValues = descriptors.reservedOrderValues.filter((v)=>(v<0));
        //console.log(" _generateLowReservedCats",descriptors,allcats,lowValues);
        for(let order of lowValues){
            //console.log("  generate ordered nav <0",order,descriptors.ordered[order])
            allcats = this._generateCat(allcats,descriptors.ordered[order],order);
        }
        return allcats;
    },
    _generateHighReservedCats(descriptors, allcats){
        let highValues = descriptors.reservedOrderValues.filter((v)=>(v>=10000));
        //console.log(" _generateHighReservedCats",descriptors,allcats,highValues);
        for(let order of highValues){
            //console.log("  generate ordered nav >=10000",order,descriptors.ordered[order])
            allcats = this._generateCat(allcats,descriptors.ordered[order],order);
        }
        return allcats;
    },
    _generateMiddleCats(descriptors, allcats){
        let middleValues = descriptors.reservedOrderValues.filter((v)=>(v>=0 && v<10000));

        //console.log(" _generateMiddleCats",descriptors,allcats,middleValues,descriptors.unordered.length);

        //add any menus ordered >=0 but <10000 (1000 as entered in nav.add) - or slot menus without order values in.
        //console.log(" generate mixed nav >0 <10000",descriptors.reservedOrderValues.length,descriptors.unordered.length)
        for(let order = 0; order<10000; order+=10){
            let reservations = middleValues.filter((v)=>(v<=order && v>(order-10))); //any menus with a matching order or an order less than this MUST be added - but exclude ones already added last iteration
            //console.log("  order",order,reservations,middleValues);
            if(reservations.length){// the order value was reserved
                //console.log("   reserved entries",order,reservations.length);
                for(let reservedOrder of reservations){
                    allcats = this._generateCat(allcats,descriptors.ordered[reservedOrder],order);
                    order++;
                }
            }else{ //order place wasn't reserved, put an unordered descriptor here!
                let descriptor = descriptors.unordered.shift();
                //console.log("   unreserved entry",order,descriptor);
                if(typeof descriptor==='undefined') continue;
                allcats = this._generateCat(allcats,descriptor,order);
            }
            if(descriptors.unordered.length===0 && middleValues.filter((v)=>(v>order && v<10000) ).length===0) break;
        }
        return allcats;
    },

    _condenseAndPruneCats(){
        let iterations = (app.ui.nav.condenseMenus && app.ui.nav.pruneMenus) ? app.ui.nav.condensePruneIterations : 1;
        for(let i=0;i<iterations;i++){ //repeat this a couple times because condensing allows better pruning, but then in turn can cause single menus, needing more condensing.
            if(app.ui.nav.condenseMenus) app.util.tree.condenseObjectPaths_siblinglessParents(app.ui.nav.categoryPaths,app.ui.nav.minimumSiblingCountCondenseExclusion,app.ui.nav.condenseExcludeDepth); //replace any menus that are by themselves with their contents
            if(app.ui.nav.condenseMenus) app.util.tree.condenseObjectPaths_singleChildParents(app.ui.nav.categoryPaths,app.ui.nav.minimumSiblingCountCondenseExclusion,app.ui.nav.condenseExcludeDepth); //replace any menus that are by themselves with their contents

            //remove any menus that are leaves (end of the menu tree) and are not a link [useless empty menus]
            if(app.ui.nav.pruneMenus) app.util.tree.pruneObjectPaths(app.ui.nav.categoryPaths,function(object, depth, parent, currentkey){
                //console.log(' '.repeat(depth+1)," canbepruned? ",object,currentkey);
                if(object.hasdescriptor){
                    let href = object.descriptor.href;
                    return (href===null || href==="" || href==="#");//invalid links can only be menus
                }else{//undescribed paths can only be menus, not items
                    return true;
                }
            },app.ui.nav.pruneExcludeDepth);//remove elements with no children, then propagate up to each element
        }
    },

    generateCats: function () {
        //console.log('Generating nav categories');
        app.ui.nav.categoryPaths = {namespaces: []};
        let allcats = [];

        //support descriptors with a preset order # / weight
        //numbers less than 0 go in front of unordered menus, extremely high numbers go after unordered menus.
        //a menu with a defined order number in the middle takes precedence over an unordered one.
        //NOTE: if multiple categories are defined for the descriptor, the order will increase by 1 for each
        //to prevent issues, Menu Descriptor orders are multiplied by 10 whereas internal ordering starts at 0 and increments by 1 per category. (but 10 per descriptor)

        //console.log(' getting nav');

        let descriptors = this._determineDescriptorOrdering(app.ui.nav.descriptors);

        allcats = this._generateLowReservedCats(descriptors,allcats);

        allcats = this._generateMiddleCats(descriptors,allcats);

        allcats = this._generateHighReservedCats(descriptors,allcats);


        //console.log("NAV ALLCATS ",allcats);
        //console.log("NAV ALLCATS ",app.ui.nav.categoryPaths);


        //console.log(allcats);
        app.ui.nav.categories = [...new Set(allcats)];//remove duplicates and set

        this._condenseAndPruneCats();

        app.util.tree.sortNamespaceOrdering(app.ui.nav.categoryPaths);
    },

    nsToClassname:function(ns){
        if(typeof ns==='undefined'){
            //console.warn('ns undefined in nsToClassname');
            return null;
        }
        return ns.replaceAll(/\./g, '_');
    },
    identifierToDisplayname:function(identifier){
        return identifier.replaceAll(/_/g,' ');
    },
    displaynameToIdentifier:function(displayname){
        return displayname.replaceAll(/[^a-zA-Z0-9._]/g,'_');
        //return displayname.replaceAll(/[\s.:-]/g,'_');
    },


    /**
     *
     * @param {UINavCategory} category
     * @param catname
     * @param {boolean} asListItem
     * @param {jQuery} item_template
     * @param {jQuery} dropdown_template
     * @param fullns
     * @param parentns
     * @return {jQuery}
     */
    getCategoryElement: function (category, catname, asListItem, item_template, dropdown_template, fullns, parentns) {
        let id, text, href, elem, icon = null;


        id = "nav-menu-" + app.ui.nav.nsToClassname(fullns);

        if (category.hasdescriptor) {
            text = category.descriptor.text;
            href = category.descriptor.href;
            icon = category.descriptor.icon;
        } else {
            text = app.ui.nav.identifierToDisplayname(catname);
            href = '#';
        }

        if (category.hasChildren || href === '#') elem = dropdown_template.clone();
        else elem = item_template.clone();

        let link = elem.find('.nav-link')
        if (icon !== null) {
            link.empty().append($('<span class="fa mr-1">').addClass('fa-' + $.escapeSelector(icon))).append($('<span>').text(text));
        } else {
            link.text(text)
        }

        if(href===null || href==="" || href==="#"){
            link.removeAttr('href');
        }else{
            link.attr('href', href);
        }



        if (!asListItem) {
            if (category.hasChildren) elem = $('<div class="dropdown">').append(elem.children().clone());
            else elem = $('<div>').append(elem.children().clone());
        } else {
            elem.removeAttr('id');
        }
        elem.addClass(id);
        elem.attr('data-menuid', id);
        elem.attr('data-menu-namespace', parentns);
        elem.attr('data-menu-identifier', catname);

        let menuelemid = app.ui.nav.nsToClassname(("" + Math.random()));
        elem.attr('id', 'menuitem_' + menuelemid);
        elem.find('.dropdown-menu').first().attr('id', 'menudrop_' + menuelemid).addClass('dropcreatedas-' + menuelemid);
        elem.addClass('createdas-' + menuelemid);
        elem.addClass('nav-menu-item');
       //console.log("     created nav menu elem", catname, elem, elem.children(), elem.children().length, menuelemid, elem.find('.dropdown-menu').length, elem.find('.dropdown-menu'));
        //console.log(elem.html());

        return elem;
    },

    /**
     *
     * @param {UINavCategory} parentCat
     * @param {UINavCategory} childCat
     */
    appendToParentCategory: function (parentCat, childCat) {
        if (typeof parentCat.jqElem === "undefined") return;
        let parentid = parentCat.jqElem.data('menuid')
        let childid = childCat.jqElem.data('menuid')
        let parents = $('.' + $.escapeSelector(parentid));
        //console.log("           appending", childCat, " into ", parentCat, parentid, $.escapeSelector(parentid), parents, childCat.jqElem.find('.nav-link'), parents.find('.dropdown-menu'));

        parents.find('.dropdown-menu').first()
            .append(childCat.jqElem.clone())
            .addClass('foundas-' + app.ui.nav.nsToClassname(parentid))
            .addClass('contains-' + app.ui.nav.nsToClassname(childid));
    },

    /**
     *
     * @param baseNamespace
     * @param {UINavCallbackEx} callback_item
     */
    present: async function (baseNamespace, callback_item) {
        app.ui.nav.generateCats();
        await app.util.tree.recurseObjectPaths(app.ui.nav.categoryPaths[baseNamespace] ?? null, function (category, catname, parent, depth, fullns, parentns) {

            let hasParent = parent !== null && depth !== 0;
            if (hasParent && parentns === baseNamespace) hasParent = false;
            if (catname === baseNamespace) return;

            callback_item(category, catname, parent, depth, fullns, parentns, baseNamespace, hasParent);
        });
    },


    presentMainMenu: async function () {
        app.ui.event.fire('nav:beforepresent')
        let navops = $("#mainNavOptions");
        let list = navops.find('ul.nav-link-options');
        let item_template = $("#example-template-navbar-item").clone().removeClass('d-none');
        let dropdown_template = $("#example-template-navbar-dropdown").clone().removeClass('d-none');
        dropdown_template.find('.dropdown-menu').empty();
        list.empty();

        await app.ui.nav.present('main', function (category, catname, parent, depth, fullns, parentns, baseNamespace, hasParent) {

                //console.log("---".repeat(depth) + "NAV", depth, catname, fullns, category, parent, category.namespaces.slice(), parent === null ? null : parent.namespaces.slice());

                //console.log("---".repeat(depth) + " hasparent", hasParent);
                category.jqElem = app.ui.nav.getCategoryElement(category, catname, !hasParent, item_template, dropdown_template, fullns, parentns);
                //console.log("---".repeat(depth) + " jqElem", category.jqElem, category);
                if (hasParent) app.ui.nav.appendToParentCategory(parent, category);
                else list.append(category.jqElem);

                //n++;
                //if(n>200) throw "max object iterations";
            }
        );

        app.ui.fixes.fixNestedDropdowns();
        app.ui.fixes.makeFontAwesomeIconsFixedWidth();
        app.ui.event.fire('nav:afterpresent');
    }
}

/**
 * @typedef {AnnotatedPathObject} UINavCategory
 * @property {int} order
 * @property {boolean} hasdescriptor
 * @property {MenuDescriptor} [descriptor]
 * @property {jQuery} [jqElem]
 */

/**
 * @callback UINavCallback
 * @param {UINavCategory} category
 * @param catname
 * @param {null|UINavCategory} parent
 * @param depth
 * @param fullns
 * @param parentns
 */
/**
 * @callback UINavCallbackEx
 * @param {UINavCategory} category
 * @param catname
 * @param {null|UINavCategory} parent
 * @param depth
 * @param fullns
 * @param parentns
 * @param basens
 * @param hasparent
 */

//import {TreeNode} from "../util/TreeNode";

//if(typeof app.util.TreeNode==='undefined') app.util.TreeNode = TreeNode;
//let TreeNode = app.util.TreeNode;


/**
 * @extends BidirectionalKeyedNode
 */
class NavTreeNode extends TreeNode{
    constructor(idName,text,href,icon,required=false,order=null, permission=null) {
        super(idName);
        this.text = text;
        this.href = href;
        this.icon = icon;
        this.required = required;
        this.order = order===null ? order : order*10;
        this.permission = permission;
    }
    static createRoot(key,children=null){
        return new NavTreeNode(key,null,null,null,true);
    }
    traverseKeys(){

    }
}
/**
 * @extends BidirectionalKeyedNode
 */
class NavTreeRoot extends NavTreeNode{
    constructor(idName) {
        super(idName,null,null,null,true);
    }
}

export class NavTree {
    /**
     *
     * @param {string[]} rootIdNames
     */
    constructor(rootIdNames = []) {
        this.root = new NavTreeRoot('root');
        for(let rootIdName of rootIdNames){
            let menuRoot = /** @var {BidirectionalKeyedNode} menuRoot */ new NavTreeRoot(rootIdName);
            this.root.adopt(menuRoot);
        }
    }

    foo(){
        //this.root.
    }

}
app.ui.overlay={
    stack:0,
    lastMessageType:null,
    lastConfirmType:null,
    lastMessageTimer:null,
    lastConfirmTimer:null,
    lastMessageResolve:function(v){},
    lastConfirmResolve:function(v){},

    bindEvents:function(){
        $("#ui-message-close,#ui-message-close2").click(app.ui.overlay.message_hide);
        $("#ui-confirm-close").click(app.ui.overlay.confirm_hide.bind(this,null));
        $("#ui-confirm-cancel").click(app.ui.overlay.confirm_hide.bind(this,0));
        $("#ui-confirm-ok").click(app.ui.overlay.confirm_hide.bind(this,1));
    },


    show:function(reason = "") {
        app.ui.event.fire("overlay:request-show", {reason: reason});
        app.ui.overlay.stack += 1;
        console.debug("ui overlay stack", app.ui.overlay.stack, '+',reason);
        app.ui.overlay.update(reason,'+');
    },
    hide:function(reason = "", force = false) {
        app.ui.event.fire("overlay:request-hide", {reason: reason, force: force});
        if (app.ui.overlay.stack > 0) app.ui.overlay.stack -= 1;
        if (force) app.ui.overlay.stack = 0;
        console.debug("ui overlay stack", app.ui.overlay.stack, (force?'!':'-'),reason);
        app.ui.overlay.update_delayed(reason,50, (force?'!':'-'))
    },
    update_delayed:function(reason = "", delayMS = 50, direction=" ") {
        setTimeout(function () {
            let r = reason;
            app.ui.overlay.update(r,direction);
        }, delayMS)
    },
    update:function(reason = "",direction=" ") {
        //console.log("ui overlay stack", rcps.ui.overlay.stack, direction,reason);
        app.ui.event.fire("overlay:update", {reason: reason, stack: app.ui.overlay.stack});

        if (app.ui.overlay.stack) $(".ui-overlay").forceShow();
        else $(".ui-overlay").forceHide();


        //if (rcps.ui.overlay.stack) $(".ui-overlay").removeClass('d-none');
        //else $(".ui-overlay").addClass('d-none');
    },
    message:async function(type, message, title = null, timeMs = 10000) {
        app.ui.overlay.lastMessageType = type;
        if (title === null) {
            title = type;
        }
        $('.ui-message-overlay').data2('type',type);
        $('.ui-message-title').text(title);
        $(".ui-message-body").text(message);
        $(".ui-message-overlay").show();
        //$("#ui-message-close2").focus(); //doesn't work until visible
        await app.ui.overlay.message_showTimed(timeMs);
    },
    message_showTimed: async function(timeMs) {
        app.ui.overlay.message_show();

        if (timeMs < 0) return; //comment this out if you want the promise to not be resolved immediate for timeouts<0 (waits until error is closed).  This may be a breaking change.
        clearTimeout(app.ui.overlay.lastMessageTimer);

        return new Promise((resolve)=>{
            app.ui.overlay.lastMessageResolve = resolve;
            if (timeMs >= 0) app.ui.overlay.lastMessageTimer = setTimeout(app.ui.overlay.message_hide, timeMs);
            /*setTimeout(function(){ //bugfix: we can't use the same setTimeout because it could be cancelled, so the promise will never complete.
                resolve(true);
            }, timeMs);*/
        });

    },
    message_show:function() {
        $(".ui-message-overlay").forceShow();
        $("#ui-message-close2").focus();
        //$(".ui-message-overlay").removeClass('d-none');
        //$(".ui-message-overlay").addClass('d-flex');
        //$(".ui-message-overlay").show();
    },
    message_hide:function() {
        clearTimeout(app.ui.overlay.lastMessageTimer);
        $(".ui-message-overlay").forceHide();
        if (app.ui.overlay.lastMessageType === "error") app.ui.overlay.hide("error-close", true);
        app.ui.overlay.lastMessageResolve(1);
    },


    confirm_show:function(){
        $(".ui-confirm-overlay").forceShow();
        $("#ui-confirm-ok").focus();
    },
    confirm_hide(resolveWith=null){
        clearTimeout(app.ui.overlay.lastConfirmTimer);
        $(".ui-confirm-overlay").forceHide();
        app.ui.overlay.lastConfirmResolve(resolveWith);
    },
    confirm_showTimed: async function(timeMs) {
        app.ui.overlay.confirm_show();

        //if (timeMs < 0) return;
        clearTimeout(app.ui.overlay.lastConfirmTimer);

        return new Promise((resolve)=>{
            app.ui.overlay.lastConfirmResolve = resolve;
            if (timeMs >= 0) app.ui.overlay.lastConfirmTimer = setTimeout(app.ui.overlay.confirm_hide.bind(this,null), timeMs);
            /*setTimeout(function(){ //bugfix: we can't use the same setTimeout because it could be cancelled, so the promise will never complete.
                resolve(true);
            }, timeMs);*/
        });

    },
    confirm:async function(type, message, title = null, timeMs = 10000) {
        app.ui.overlay.lastConfirmType = type;
        if (title === null) {
            title = type;
        }
        $('.ui-confirm-overlay').data2('type',type);
        $('.ui-confirm-title').text(title);
        $(".ui-confirm-body").text(message);
        $(".ui-confirm-overlay").show();
        //$("#ui-message-close2").focus(); //doesn't work until visible
        return await app.ui.overlay.confirm_showTimed(timeMs);//.then(function(v){console.log("confirm resolved to:",v); return v;});
    },
}
app.ui.scroll={

    lastrequest: null,
    lastts: 0,
    accepttime: 50,
    polltime: 25,
    preventuntilts: 0,
    
//prevent any automatic scrolling with rcps.ui.scroll.to for a time duration
//note: this only prevents new requests for scrolling, it does not block scrolling that is already queued.
    prevent:function (timeMs) {
        let ts = Date.now();
        let ts_then = Date.now() + timeMs;
        app.ui.scroll.preventuntilts = ts_then;
    },


    //this function scrolls to an element (see rcps.ui.scroll.to__internal)
    //except that it throttles multiple quick requests and only considers the last request after 50ms has passed.
    to:function (jqelem, adjustment = 0, anim = true) {
        //console.log("scroll-deferred", jqelem);
        let ts = Date.now();
        if (ts < app.ui.scroll.preventuntilts) {
            //console.log(" scroll-prevented", ts, app.ui.scroll.preventuntilts);
            return;
        }

        app.ui.scroll.lastrequest = arguments;
        app.ui.scroll.lastts = ts;
        setTimeout(app.ui.scroll.to__check, app.ui.scroll.polltime); //schedule time-limited polling
    },

    to__check:function () {
        if (app.ui.scroll.lastrequest === null) return;
        let ts = Date.now();
        let tsd = ts - app.ui.scroll.lastts;
        if (tsd >= app.ui.scroll.accepttime) { //no new scroll requests in 50ms, do the scroll
            let args = app.ui.scroll.lastrequest;
            app.ui.scroll.lastrequest = null;
            app.ui.scroll.to__internal(...args);
        } else { //a new scroll request has happened in less than 50ms - lets just wait until the requests are done.
            setTimeout(app.ui.scroll.to__check, app.ui.scroll.polltime); //continue polling.
        }
    },


    to__internal:function (jqelem, adjustment = 0, anim = true) {
        //console.log(" scroll-actual", jqelem);
        var domelem = jqelem[0];


        if (!anim) {
            domelem.scrollIntoView();
        } else {
            var navbar_occluded = $('.navbar').position().top + $('.navbar').outerHeight(true);
            //console.log("scrollto ", jqelem, navbar_occluded, adjustment, jqelem.position().top, jqelem.offset().top)
            $([document.documentElement, document.body]).animate({
                scrollTop: (jqelem.offset().top - navbar_occluded) + adjustment
            }, 250);
        }
        app.ui.event.fire("form:scrolled-to", {element: jqelem, adjustment: adjustment, anim: anim});
    },

    save:function () {
        return $([document.documentElement, document.body]).scrollTop();
    },

    restore:function (v) {
        $([document.documentElement, document.body]).scrollTop(v);
    }
}
app.ui.breadcrumbs={
    set:function(subpage, uri, linktext = "", text = "") {
        subpage = parseInt(subpage);
        var el = $("#breadcrumb-subpage" + subpage);
        var link = $("#breadcrumb-subpage" + subpage + " > a");
        var span = $("#breadcrumb-subpage" + subpage + " > span");
        if (uri === null) {
            el.addClass('d-none');
        } else {
            link.attr('href', uri);
            link.text(linktext);
            span.text(text)
            el.removeClass('d-none');
        }
    }
}


app.ui.template={
    formCallbacks:[],
    loadCallbacks:[],
    /**
     *
     * @param func function to be ran when the template is finished loading (event callback)
     * @param {string[]} requiredperms
     */
    onload:function(func, requiredperms = []) {
        //rcps.ui.template.onload(cb)
        if(requiredperms.length>0) app.api.perms.require(requiredperms);
        app.ui.event.handle("template:processed", func);
    },
    handleSubmitBlock:function(e){
        e.preventDefault();
    },
    handleSubmit:function(e){
        let formname = $(this).attr('name');
        if(typeof formname==='undefined') formname=$(this).attr('id');
        if(typeof formname!=='undefined') app.ui.event.fire("form:"+formname+":submit", {element: this, event: e});
        app.ui.event.fire("form:submit", {element: this, event: e});
        //e.preventDefault();
        console.log("Handling form submit", e);
        for (let cb of app.ui.template.formCallbacks) {
            cb(e);
        }
    },
    handleLoad:function(){
        for (let callback of app.ui.template.loadCallbacks) {
            callback();
        }
    },


    prepare(){
        window.Error.stackTraceLimit = undefined;
        window.onerror = function(message, url, lineNumber, column, errorObj) {
            console.log(message,url,lineNumber)
            if(errorObj !== undefined) //so it won't blow up in the rest of the browsers
                console.log('Error: ' + errorObj.stack);
            return false;
        };
    },

    init(){
        this.prepare();
        $(this.load.bind(this));
    },

    async load(){
        app.ui.event.fire("template:init");
        app.ui.jquery.setup(jQuery);
        app.ui.event.fire("template:preparing");

        app.ui.event.fire("template:importing");
        app.data.importValues();
        app.data.importGlobals();//TODO: stop reliance on globals
        app.ui.event.fire("template:imported");

        app.ui.event.fire("template:transcluding");
        await app.ui.templates.transcludeAll();
        $(".insert-current-date").text((new Date()).toLocaleDateString());
        $(".insert-current-time").text((new Date()).toLocaleTimeString());
        $(".insert-current-year").text((new Date()).getFullYear());
        app.ui.event.fire("template:transcluded");

        app.ui.overlay.show("page-load");
        $('input, textarea, select').not(".no-form-control").addClass('form-control');
        $("input[type=checkbox]").not(".no-check-input").removeClass('form-control').addClass('form-check-input'); //tried to exempt this with .not(...) but it didn't work
        $("input[type=radio]").not(".no-check-input").removeClass('form-control').addClass('form-check-input'); //tried to exempt this with .not(...) but it didn't work
        $('button').not(".no-btn").addClass('btn');
        $(':submit').not(".no-btn").addClass('btn');


        app.ui.fixes.fixTabs();
        app.ui.fixes.fixFA_IE11();
        app.ui.fixes.fixJSTreeCSPErrors();
        app.ui.fixes.makeFontAwesomeIconsFixedWidth();

        //IE11 or lower warning
        if($('body').hasClass('trident')){
            if(!app.util.getCookie('outdatedbrowserwarning')){
                let expire = new Date(); expire.setDate(expire.getDate()+1);
                app.util.setCookie('outdatedbrowserwarning',1, expire);
                app.ui.common.error("Your browser is outdated or unsupported.\r\nParts of this website may not appear or function correctly.");
            }
        }


        $(".btn-darkmode").click(app.ui.darkmode.toggle);

        app.ui.overlay.bindEvents();

        $("form").not(".do-submit").prop('action', '#').submit(app.ui.template.handleSubmitBlock);
        $("form").not(".no-submit-handler").submit(app.ui.template.handleSubmit);


        if(typeof jQuery.jstree!=='undefined') $('.tree-container').each(function(){
            let config = $(this).data('tree-config');
            if(typeof config!=='undefined' && config!==null) $(this).jstree(config);
            else $(this).jstree();
        });

        if(typeof app.ui.tempusDominusSupport!=='undefined'){
            app.ui.tempusDominusSupport.extend();
            app.ui.tempusDominusSupport.registerControls();
        }

        app.ui.event.fire("template:performfixes");
        app.ui.common.intuitiveClickNavbar("main-navbar");
        app.ui.fixes.fixCheckboxValues();
        app.ui.fixes.fixInputNames();

        let navbar = $("#main-navbar");
        if(navbar.length){
            setInterval(
                function(){
                    navbar.data2('offset-top',navbar[0].offsetTop);
                    navbar.data2('offset-top-over-100',navbar[0].offsetTop>100?1:0);
                },
                500
            );
        }

        app.ui.drag.attachDocumentListener();


        app.ui.darkmode.restore();

        app.ui.event.fire("template:prepared");

        app.ui.event.fire("template:processing");
        app.ui.template.handleLoad();

        app.ui.event.fire("template:processed");
        app.ui.event.fire("template:postprocess");

        if(window.auth_loggedin??0){
            $('*[name="logoutbutton"]').attr('title','Signed in as '+(window.auth_username??''))
        }



        app.ui.overlay.hide("page-load");

        $('input[type="date"],input[type="datetime-local"]').each(function(){
            if(!$(this).attr('min')) $(this).attr('min','1899-01-01');
            if(!$(this).attr('max')) $(this).attr('max','2525-01-01');
        })

        if(app.loggedIn()) app.ui.logoutNotifier.start();
        //rcps.ui.overlay.hide("force-hide-pageload",true); //this is a band-aid for unrelated issues

    }
}

app.ui.template.init();


app.ui.templates = {
    templateParentSelector:'.example-elements,.template-elements',
    templateElementPattern:'#META-example-{TEMPLATENAME},#META-template-{TEMPLATENAME}',
    map:{},
    toLoad:[],

    registerNames:function(names){
        for(let name of names) app.ui.templates.registerName(name);
    },
    registerName:function(name){
        if(typeof app.ui.templates.map[name]!=='undefined') app.ui.templates.map[name] = null;
        app.ui.templates.toLoad.push(name);
    },
    loadByName(name,parentSelector=null,elementPattern=null){
        if(parentSelector===null) parentSelector = app.ui.templates.templateParentSelector;
        if(elementPattern===null) elementPattern = app.ui.templates.templateElementPattern;
        let name_s = $.escapeSelector(name);

        let elem_selector = elementPattern.replaceAll('{TEMPLATENAME}',name_s)
        //console.log("loading template element:",parentSelector,elem_selector);


        app.ui.templates.map[name] = $(parentSelector).find(elem_selector).first().clone().show().removeClass('d-none');
    },
    loadByNames:function(names=null,parentSelector=null,elementPattern=null,clear=true){
        if(names===null) names = app.ui.templates.toLoad;
        for(let name of names) app.ui.templates.loadByName(name,parentSelector,elementPattern);
        if(clear) app.ui.templates.toLoad=[];
    },
    get:function(name){
        return app.ui.templates.map[name].clone() ?? null;
    },

    transcludeAll:async function(parentElement=null){
        //console.log('transcludeall1');
        if(parentElement===null) parentElement = 'body';
        let promises = [];

        //containers for template data
        $(parentElement).find('.template-include').each(function(){


            let template_name = $(this).data('name')??null;
            let sourceid = $(this).data('sourceid')??null;
            let sourceclass = $(this).data('sourceclass')??null;

            let finalid=$(this).data('finalid')??null;
            let finalclass=$(this).data('finalclass')??null;


            //console.log(' transcludeall2',this,template_name);
            $(this).removeClass('template-include').addClass('template-data');

            let replacement = $('<div class="template-replace">');
            if(template_name!==null) replacement.data2('name',template_name);
            if(sourceid!==null) replacement.data2('sourceid',sourceid);
            if(sourceclass!==null) replacement.data2('sourceclass',sourceclass);
            if(finalid!==null) replacement.data2('finalid',finalid);
            if(finalclass!==null) replacement.data2('finalclass',finalclass);
            //console.log(' transcludeallr',this,template_name,sourceid,sourceclass,replacement);

            $(this).append(replacement);
        })

        //elements replaced directly with URI template data
        $(parentElement).find('.template-replace').each(function(){
            let template_name = $(this).data('name')??null;
            let sourceid = $(this).data('sourceid');
            let finalid=$(this).data('finalid')??null;
            let _this = this;
            //console.log(' transcludeall3c',this,template_name);
            if(template_name===null || template_name==='#' || template_name==='self') return;
            //console.log(' transcludeall3',this,template_name);
            promises.push(new Promise(async (resolve)=>{
                await $(_this).replaceWithTemplate(template_name,sourceid,null,finalid);
                resolve(template_name);
            }));
        })
        await Promise.allSettled(promises);

        //elements replaced directly with self-references within the page
        $(parentElement).find('.template-replace').each(function(){
            let template_name = $(this).data('name')??null;
            let sourceid = $(this).data('sourceid')??null;
            let sourceclass = $(this).data('sourceclass')??null;
            let finalid=$(this).data('finalid')??null;
            let finalclass=$(this).data('finalclass')??null;
            //console.log(' transcludeall4c',this,template_name);
            if(template_name!==null && template_name!=='#' && template_name!=='self') return;
            //console.log(' transcludeall4',this,template_name);

            let selector_prefix = '#';
            let source_name = sourceid===null ? sourceclass : sourceid;
            if(sourceid===null) selector_prefix='.';
            let source_selector = selector_prefix + $.escapeSelector(source_name);

            //console.log('  transcludeall template-replace self',source_selector,selector_prefix,$(source_selector).length,this,finalid,finalclass)
            let sourceElem = $(source_selector);
            let replacement = sourceElem.first().clone().removeAttr('id');
            if(finalid!==null) replacement.attr('id',finalid);
            if(finalclass!==null) replacement.addClass(finalclass);
            $(this).replaceWith(replacement)
        })



    }
};
app.ui.watchedForms = {
    states:{},

    /**
     *
     * @param selector
     * @returns {string|*|jQuery}
     * @private
     */
    _calculateState(selector){
        let data=$(selector).serialize(); //+""
//        return data;
        return data.hashCode()+':'+data.length;
    },
    /**
     *
     * @param selector_string
     * @returns {*}
     * @private
     */
    _getState(selector_string){
        return this.states[selector_string];
    },
    /**
     *
     * @param selector_string
     * @param state
     * @returns {*}
     * @private
     */
    _setState(selector_string, state){
        this.states[selector_string]=state;
        return state;
    },
    /**
     *
     * @param selector_string
     * @param onChanged
     * @param onNotChanged
     * @private
     */
    _onChangeCheck(selector_string, onChanged=null, onNotChanged=null){
        let oldstate = this._getState(selector_string);
        let newstate = this._calculateState(selector_string);
        this._setState(selector_string,newstate);
        if(oldstate===newstate){
            if(onNotChanged) onNotChanged(selector_string,oldstate,newstate);
        }else{
            //console.log('change',oldstate,newstate,typeof oldstate,typeof newstate);//FIXME: changed from fully serialized to empty string???
            if(onChanged) onChanged(selector_string,oldstate,newstate);
        }
    },

    /**
     * Watches a form for value changes using both event and interval checks.
     *
     * Marks the form with 'watched-form-changed' class if a change is detected - this is left for you to remove as a "dirty bit" indicating that unsaved changes have occurred.
     * Use {@link unmark} to clear this class and others.
     *
     * Also marks the form with 'watched-form-notseen' for the duration that the change has uniquely been identified which is then replaced with 'watched-form-seen' when the current form state is encountered a second time.
     *
     * The form is also initially marked with 'watched-form-notchanged' class until the first change is detected.
     *
     *
     * A typical usage might look like
     * @example
     *         app.ui.watchedForms.watch('#EntryForm',id==="NEW", function(form){
     *             app.ui.watchedForms.updateSaveButton('#saveButton',form);
     *         });
     *         app.ui.watchedForms.updateSaveButton('#saveButton','#EntryForm');
     *         ```
     *
     * @param selector_string
     * @param {boolean|null} formInitiallyDirty whether the form should be marked as changed/notchanged immediately. If null, no change is forced.
     * @param events
     * @param interval_check
     * @param {function(form:jQuery)} formChangeCallback
     */
    watch(selector_string, formInitiallyDirty=null, formChangeCallback=null, events=true, interval_check=1000){
        if(interval_check===true) interval_check=1000;
        let _this = this;

        let form = $(selector_string);
        this.states[selector_string] = this._calculateState(selector_string);

        if(formInitiallyDirty){
            this._markEx(form,true,false);
        }else{
            this._markEx(form,false,false);
        }


        let onChange = function(){
            _this._markEx(form,true,false);
            if(formChangeCallback!=null) formChangeCallback(form);
        };
        let onNoChange = function(){ _this._markEx(form,null,true); /*console.log('watched form notchanged');*/ };

        let onCheck=function(){_this._onChangeCheck(selector_string,onChange,onNoChange);}

        if(events){
            form.find('input,select,textarea').on('change input update keyup',onCheck)
        }
        if(interval_check){
            setInterval(onCheck,interval_check);
        }
    },
    _markEx(form_selector,changed=null,seen=null){
        let form = $(form_selector);
        if(changed!==null){
            if(changed) form.addClass('watched-form-changed').removeClass('watched-form-notchanged');
            else form.removeClass('watched-form-changed').addClass('watched-form-notchanged');
        }
        if(seen!==null){
            if(seen) form.addClass('watched-form-seen').removeClass('watched-form-notseen');
            else form.removeClass('watched-form-seen').addClass('watched-form-notseen');
        }
    },


    /**
     * Removes the 'watched-form-changed' class from a watched form, also sets the 'watched-form-seen' and 'watched-form-notchanged' classes.
     *
     * This can be used to unmark the form from the 'dirty bit' - to indicate that the data is already saved.
     * @param selector_string
     */
    unmark(selector_string){
        this._markEx(selector_string,false,true);
    },
    /**
     * Adds the 'watched-form-changed' and 'watched-form-notseen' class states to a watched form.
     *
     * This can be used to manually mark a form as 'dirty' - to indicate that the data is not saved yet.
     *
     * This may be useful on 'new item' forms which may not have changes, but also may not be saved yet.
     * @param selector_string
     */
    markDirty(selector_string){
        this._markEx(selector_string,true,false)
    },

    /**
     * Determine if a watched form has the 'watched-form-changed' class, indicating it has unsaved data.
     *
     * Use {@link unmark} to clear the state.
     * @param selector_string
     * @return whether the form is 'dirty' (has changed and has not be saved or unmarked)
     */
    isDirty(selector_string){
        return $(selector_string).hasClass('watched-form-changed');
    },

    updateSaveButton(button_selector,form_selector=null){
        if(form_selector===null){
            form_selector = $(button_selector).parents('form').first();
        }
        let dirty = this.isDirty(form_selector);
        $(button_selector)
            .removeClass('watched-form-' + (dirty ? 'isclean' : 'isdirty'))
            .addClass('watched-form-' + (dirty ? 'isdirty' : 'isclean'))
    },

    /**
     * This method calls {@link watch} using the example form where a save button is updated based on the form changes.
     *
     * The form is initially marked as dirty if the current_id matches the new_id value (default "NEW")
     * @param form_selector
     * @param save_button_selector
     * @param current_id
     * @param new_id
     */
    watchSaveForm(form_selector,save_button_selector,current_id,new_id="NEW"){
        app.ui.watchedForms.watch(form_selector,current_id===new_id, function(form){
            app.ui.watchedForms.updateSaveButton(save_button_selector,form);
        });
        app.ui.watchedForms.updateSaveButton(save_button_selector,form_selector);
    },

    registerUnsavedLeaveConfirmation(){
        window.addEventListener('beforeunload', function (e) {
            if($(".watched-form-changed").length>0){ //only show the confirmation prompt when there is an unsaved form.
                // Cancel the event
                e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
                // Chrome requires returnValue to be set
                e.returnValue = '';
            }
        });
    }

}